{
	"language": {
		"select": "ਭਾਸ਼ਾ ਚੁਣੋ",
		"sectionTitle": "ਭਾਸ਼ਾ",
		"changeSuccess": "ਭਾਸ਼ਾ ਸਫਲਤਾਪੂਰਵਕ ਬਦਲੀ ਗਈ।"
	},
	"assistant": {
		"composer": {
			"placeholder": "{{assistantName}} ਨੂੰ ਪੁੱਛੋ",
			"disclaimer": "{{assistantName}} ਗਲਤੀਆਂ ਕਰ ਸਕਦਾ ਹੈ। ਮਹੱਤਵਪੂਰਨ ਜਾਣਕਾਰੀ ਦੀ ਜਾਂਚ ਕਰੋ।"
		},
		"greeting": {
			"initialMessage": "👋 ਹੈਲੋ, ਮੈਂ **{{assistantName}}** ਲਰਨਿੰਗ ਅਸਿਸਟੈਂਟ ਹਾਂ, ਅਤੇ ਮੈਂ ਤੁਹਾਨੂੰ **{{context}}** ਲਈ ਬਿਹਤਰ ਤਿਆਰੀ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਨ ਲਈ ਇੱਥੇ ਹਾਂ! ਆਓ ਖਾਸ ਤੌਰ 'ਤੇ **{{topic}}** ਬਾਰੇ ਤੁਹਾਡੇ ਵੱਲੋਂ ਦਿੱਤੇ ਜਵਾਬ ਵਾਲੀ ਆਈਟਮ ਵਿੱਚ ਡੂੰਘਾਈ ਨਾਲ ਜਾਈਏ।",
			"starter": "ਹੈਲੋ, ਮੈਂ **{{assistantName}}** ਹਾਂ। ਮੈਂ ਕਿਵੇਂ ਮਦਦ ਕਰ ਸਕਦਾ ਹਾਂ?"
		},
		"chips": {
			"askYourOwn": "ਆਪਣਾ ਸਵਾਲ ਪੁੱਛੋ",
			"askFollowUp": "ਫਾਲੋ-ਅੱਪ ਸਵਾਲ ਪੁੱਛੋ"
		},
		"emptyState": {
			"title": "{{assistantName}} ਤੁਹਾਡਾ AI-ਸੰਚਾਲਿਤ ਲਰਨਿੰਗ ਅਸਿਸਟੈਂਟ ਹੈ",
			"contextSubtitle": "{{context}} ਨਾਲ ਸੰਬੰਧਿਤ ਕੁਝ ਵੀ ਪੁੱਛੋ",
			"activateSubtitle": "{{assistantName}} ਸਵਾਲ ਦਾ ਜਵਾਬ ਦੇਣ ਤੋਂ ਬਾਅਦ ਸਰਗਰਮ ਹੋਵੇਗਾ"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "ਤੁਰੰਤ ਅਧਿਐਨ",
			"examInfo": {
				"subtitle": {
					"setExamDate": "ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ ਸੈੱਟ ਕਰੋ",
					"examDateWithValue": "ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "ਬਿਹਤਰ ਹੋ ਸਕਦਾ ਹੈ",
				"itsAwesome": "ਇਹ ਬਹੁਤ ਵਧੀਆ ਹੈ"
			},
			"title": "ਤੁਸੀਂ ਲਗਾਤਾਰ ਵਧੀਆ ਕਰ ਰਹੇ ਹੋ!",
			"body": "ਅਧਿਐਨ ਪ੍ਰਤੀ ਤੁਹਾਡੇ ਸਮਰਪਣ ਨੂੰ ਵੇਖ ਕੇ ਸਾਨੂੰ ਬਹੁਤ ਖੁਸ਼ੀ ਹੋ ਰਹੀ ਹੈ! ਹੁਣ ਤੱਕ ਐਪ ਨਾਲ ਤੁਹਾਡਾ ਅਨੁਭਵ ਕਿਹੋ ਜਿਹਾ ਰਿਹਾ ਹੈ? ਕੀ ਤੁਸੀਂ ਸਮੀਖਿਆ ਦੇ ਕੇ ਆਪਣੇ ਵਿਚਾਰ ਸਾਂਝੇ ਕਰਨਾ ਚਾਹੋਗੇ?",
			"cta": "ਸ਼ਾਇਦ ਬਾਅਦ ਵਿੱਚ"
		},
		"actions": {
			"studyWeak": "ਕਮਜ਼ੋਰ ਖੇਤਰਾਂ 'ਤੇ ਧਿਆਨ ਦਿਓ",
			"viewProgress": "ਆਪਣੀ ਪ੍ਰਗਤੀ ਵੇਖੋ",
			"seeRank": "ਆਪਣਾ ਦਰਜਾ ਵੇਖੋ",
			"seeRankings": "ਲੀਡਰਬੋਰਡ ਵੇਖੋ",
			"unlock": "ਪ੍ਰੀਮੀਅਮ ਸਮੱਗਰੀ ਅਨਲੌਕ ਕਰੋ",
			"unlockTooltip": "ਪ੍ਰੀਮੀਅਮ ਸਮੱਗਰੀ ਅਨਲੌਕ ਕਰਕੇ ਵਿਸ਼ੇਸ਼ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਅਤੇ ਐਡਵਾਂਸਡ ਅਧਿਐਨ ਸਮੱਗਰੀ ਤੱਕ ਪਹੁੰਚ ਪ੍ਰਾਪਤ ਕਰੋ।",
			"startCustomSession": "ਇੱਕ ਕਸਟਮ ਸੈਸ਼ਨ ਬਣਾਓ",
			"startCustomSessionTooltip": "ਆਪਣੇ ਅਧਿਐਨ ਦੇ ਖਾਸ ਖੇਤਰਾਂ 'ਤੇ ਧਿਆਨ ਦੇਣ ਲਈ ਇੱਕ ਕਸਟਮ ਅਧਿਐਨ ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰੋ।",
			"takeDiagnostic": "ਡਾਇਗਨੌਸਟਿਕ ਦਿਓ",
			"takeDiagnosticTooltip": "ਆਪਣੇ ਮੌਜੂਦਾ ਪੱਧਰ ਦਾ ਮੁਲਾਂਕਣ ਕਰਨ ਅਤੇ ਉਸ ਅਨੁਸਾਰ ਆਪਣੀ ਅਧਿਐਨ ਯੋਜਨਾ ਤਿਆਰ ਕਰਨ ਲਈ ਇੱਕ ਡਾਇਗਨੌਸਟਿਕ ਦਿਓ।",
			"viewDiagnostic": "ਡਾਇਗਨੌਸਟਿਕ ਨਤੀਜੇ ਵੇਖੋ",
			"viewDiagnosticTooltip": "ਆਪਣੀਆਂ ਸ਼ਕਤੀਆਂ ਅਤੇ ਸੁਧਾਰ ਦੇ ਖੇਤਰ ਵੇਖਣ ਲਈ ਆਪਣੇ ਡਾਇਗਨੌਸਟਿਕ ਨਤੀਜੇ ਵੇਖੋ।",
			"viewPodcasts": "ਪੌਡਕਾਸਟ ਸੁਣੋ",
			"viewPodcastsTooltip": "ਆਪਣੇ ਸਿੱਖਣ ਦੇ ਅਨੁਭਵ ਨੂੰ ਬਿਹਤਰ ਬਣਾਉਣ ਲਈ ਵਿੱਦਿਅਕ ਪੌਡਕਾਸਟਾਂ ਤੱਕ ਪਹੁੰਚ ਪ੍ਰਾਪਤ ਕਰੋ।",
			"upgradeToPremium": "ਪ੍ਰੀਮੀਅਮ ਲਓ",
			"upgradeToPremiumTooltip": "ਸਾਰੀ ਸਮੱਗਰੀ ਅਤੇ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਤੱਕ ਪਹੁੰਚ ਲਈ ਪ੍ਰੀਮੀਅਮ ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ।",
			"extendAccess": "ਪਹੁੰਚ ਵਧਾਓ",
			"extendAccessTooltip": "ਪ੍ਰੀਮੀਅਮ ਸਮੱਗਰੀ ਅਤੇ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਤੱਕ ਆਪਣੀ ਪਹੁੰਚ ਵਧਾਓ।",
			"setExamDate": "ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ ਸੈੱਟ ਕਰੋ",
			"setExamDateTooltip": "ਆਪਣੀ ਪ੍ਰਗਤੀ 'ਤੇ ਨਜ਼ਰ ਰੱਖਣ ਅਤੇ ਆਪਣੇ ਇਮਤਿਹਾਨ ਦੀ ਤਿਆਰੀ ਕਰਨ ਲਈ ਆਪਣੇ ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ ਸੈੱਟ ਕਰੋ।"
		},
		"exam": {
			"daysAgo_one": "{{count}} ਦਿਨ ਪਹਿਲਾਂ",
			"daysAgo_other": "{{count}} ਦਿਨ ਪਹਿਲਾਂ",
			"untilExam_one": "ਇਮਤਿਹਾਨ ਤੱਕ {{count}} ਦਿਨ",
			"untilExam_other": "ਇਮਤਿਹਾਨ ਤੱਕ {{count}} ਦਿਨ",
			"isToday": "ਇਮਤਿਹਾਨ ਅੱਜ ਹੈ!"
		},
		"stats": {
			"mastery": "ਮੁਹਾਰਤ",
			"completed_one": "ਜਵਾਬ ਦਿੱਤੀ ਆਈਟਮ",
			"completed_other": "ਜਵਾਬ ਦਿੱਤੀਆਂ ਆਈਟਮਾਂ",
			"completedValue": "{{count}}",
			"xpEarned": "ਕਮਾਏ ਗਏ XP",
			"xpEarnedValue": "{{value}}",
			"accuracy": "ਸ਼ੁੱਧਤਾ",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "ਤੁਹਾਡੀ ਅਨੁਮਾਨਿਤ {{skill, lowercase}} ਨਿਪੁੰਨਤਾ {{level, lowercase}} ਹੈ।",
			"itemsAnsweredTooltip": "ਹੁਣ ਤੱਕ ਤੁਹਾਡੇ ਦੁਆਰਾ ਜਵਾਬ ਦਿੱਤੀਆਂ ਆਈਟਮਾਂ ਦੀ ਕੁੱਲ ਗਿਣਤੀ।",
			"responsesAnsweredTooltip": "ਹੁਣ ਤੱਕ ਤੁਹਾਡੇ ਦੁਆਰਾ ਜਮ੍ਹਾਂ ਕੀਤੀਆਂ ਪ੍ਰਤੀਕਿਰਿਆਵਾਂ ਦੀ ਕੁੱਲ ਗਿਣਤੀ।",
			"examDateTooltip": "ਤੁਹਾਡਾ ਇਮਤਿਹਾਨ {{date}} ਨੂੰ ਹੈ।",
			"skillCta": {
				"diagnostic": "ਡਾਇਗਨੌਸਟਿਕ",
				"practice": "ਅਭਿਆਸ"
			}
		},
		"menu": {
			"settings": "ਸੈਟਿੰਗਾਂ",
			"profile": "ਪ੍ਰੋਫਾਈਲ"
		},
		"diagnostics": {
			"title": "ਡਾਇਗਨੌਸਟਿਕ",
			"free": "ਮੁਫ਼ਤ",
			"duration": "{{count}} {{item}} • {{minutes}} ਮਿੰਟ",
			"completed": "{{count}} {{item}} ਪੂਰਾ ਹੋਇਆ",
			"start": "ਸ਼ੁਰੂ ਕਰੋ",
			"viewReport": "ਰਿਪੋਰਟ ਵੇਖੋ",
			"resume": "ਜਾਰੀ ਰੱਖੋ"
		},
		"practiceTests": {
			"title": "ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ",
			"sectionalTestsTitle": "ਸੈਕਸ਼ਨਲ ਟੈਸਟ",
			"diagnosticAssessmentsTitle": "ਡਾਇਗਨੌਸਟਿਕ ਮੁਲਾਂਕਣ",
			"premiumChipTooltip": "{{examName}} ਇਮਤਿਹਾਨ ਲਈ ਪੂਰੀ ਲੰਬਾਈ ਦੇ, ਪ੍ਰੀਮੀਅਮ ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ",
			"freeChipTooltip": "{{examName}} ਇਮਤਿਹਾਨ ਲਈ {{label}}",
			"freeChipTooltipDefault": "{{examName}} ਇਮਤਿਹਾਨ ਲਈ ਮੁਫ਼ਤ ਡਾਇਗਨੌਸਟਿਕ ਮੁਲਾਂਕਣ",
			"completedDescription_one": "{{count}} ਆਈਟਮ • {{date}}",
			"completedDescription_other": "{{count}} ਆਈਟਮਾਂ • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} ਆਈਟਮ • {{timeRemaining}} ਬਾਕੀ",
			"activeDescription_other": "{{attempted}}/{{count}} ਆਈਟਮਾਂ • {{timeRemaining}} ਬਾਕੀ",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} ਆਈਟਮ • {{timeRemaining}} ਬਾਕੀ • ਸ਼ੁਰੂ ਹੋਇਆ: {{startedOn}} • ਸਮਾਪਤ ਹੋਵੇਗਾ: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} ਆਈਟਮਾਂ • {{timeRemaining}} ਬਾਕੀ • ਸ਼ੁਰੂ ਹੋਇਆ: {{startedOn}} • ਸਮਾਪਤ ਹੋਵੇਗਾ: {{endsOn}}",
			"notStartedDescription_one": "{{count}} ਆਈਟਮ • {{duration}}",
			"notStartedDescription_other": "{{count}} ਆਈਟਮਾਂ • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} ਆਈਟਮ • {{duration}} • ਸਮਾਪਤ ਹੋਵੇਗਾ: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} ਆਈਟਮਾਂ • {{duration}} • ਸਮਾਪਤ ਹੋਵੇਗਾ: {{endsOn}}",
			"viewResultsCta": "ਨਤੀਜੇ ਵੇਖੋ",
			"startCta": "ਸ਼ੁਰੂ ਕਰੋ",
			"chips": {
				"items_one": "{{count}} ਆਈਟਮ",
				"items_other": "{{count}} ਆਈਟਮਾਂ",
				"progress_one": "{{attempted}}/{{count}} ਆਈਟਮ",
				"progress_other": "{{attempted}}/{{count}} ਆਈਟਮਾਂ",
				"timeRemaining": "{{time}} ਬਾਕੀ",
				"startedOn": "ਸ਼ੁਰੂ ਹੋਇਆ {{date}}",
				"endsOn": "ਸਮਾਪਤ ਹੋਵੇਗਾ {{date}}",
				"timeLeft": "{{time}} ਬਾਕੀ"
			},
			"status": {
				"notStarted": {
					"label": "ਸ਼ੁਰੂ ਨਹੀਂ ਹੋਇਆ",
					"section": "ਪੂਰੀ ਲੰਬਾਈ ਦੇ ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ"
				},
				"inProgress": {
					"label": "ਜਾਰੀ ਹੈ",
					"section": "ਜਾਰੀ ਹੈ"
				},
				"completed": {
					"label": "ਪੂਰਾ ਹੋਇਆ",
					"section": "ਪੂਰਾ ਹੋਇਆ"
				},
				"legacyReports": {
					"label": "ਪੁਰਾਣੀਆਂ ਰਿਪੋਰਟਾਂ",
					"section": "ਪੁਰਾਣੀਆਂ ਰਿਪੋਰਟਾਂ"
				},
				"migratedReports": {
					"label": "ਮਾਈਗ੍ਰੇਟ ਕੀਤੀਆਂ ਰਿਪੋਰਟਾਂ",
					"section": "ਮਾਈਗ੍ਰੇਟ ਕੀਤੀਆਂ ਰਿਪੋਰਟਾਂ"
				}
			}
		},
		"skills": {
			"title": "ਹੁਨਰ",
			"unlockSubtitle": "ਅਭਿਆਸ ਕਰਨ ਲਈ ਪ੍ਰੀਮੀਅਮ ਅਨਲੌਕ ਕਰੋ",
			"startCta": "ਅਭਿਆਸ ਕਰੋ",
			"freeItemsIncludedChip": "ਮੁਫ਼ਤ ਆਈਟਮਾਂ ਸ਼ਾਮਲ",
			"freeItemsAnsweredSubtitle_one": "{{count, number}} ਵਿੱਚੋਂ {{answered, number}} ਮੁਫ਼ਤ ਆਈਟਮ ਦਾ ਜਵਾਬ ਦਿੱਤਾ ਗਿਆ",
			"freeItemsAnsweredSubtitle_other": "{{count, number}} ਵਿੱਚੋਂ {{answered, number}} ਮੁਫ਼ਤ ਆਈਟਮਾਂ ਦਾ ਜਵਾਬ ਦਿੱਤਾ ਗਿਆ",
			"progressCards": {
				"questionTypesTitle": "ਸਵਾਲ ਦੀ ਕਿਸਮ ਅਨੁਸਾਰ ਪ੍ਰਦਰਸ਼ਨ",
				"questionTypesSubtitle": "{{skill}} ਸਵਾਲ ਦੀਆਂ ਕਿਸਮਾਂ ਵਿੱਚ ਤੁਸੀਂ ਕਿਵੇਂ ਸਕੋਰ ਕਰਦੇ ਹੋ",
				"proficiencyTitle": "ਨਿਪੁੰਨਤਾ ਅਨੁਸਾਰ ਪ੍ਰਦਰਸ਼ਨ",
				"proficiencySubtitle": "{{skill}} ਪੱਧਰਾਂ ਵਿੱਚ ਤੁਹਾਡੀ ਪ੍ਰਗਤੀ",
				"questionTypeCardSubtitle": "ਨਿਪੁੰਨਤਾ ਪੱਧਰ ਅਨੁਸਾਰ ਪ੍ਰਗਤੀ",
				"bySkillTitle": "ਹੁਨਰ ਅਨੁਸਾਰ ਪ੍ਰਦਰਸ਼ਨ",
				"bySkillSubtitle": "ਹੁਨਰਾਂ ਵਿੱਚ ਸਮੁੱਚੀ ਪ੍ਰਗਤੀ",
				"needsImprovementTitle": "ਸੁਧਾਰ ਲੋੜੀਂਦਾ",
				"needsImprovementSubtitle": "ਅੱਗੇ ਧਿਆਨ ਦੇਣ ਵਾਲੇ ਵਿਸ਼ੇ",
				"skillPerformanceTitle": "{{skill}} ਪ੍ਰਦਰਸ਼ਨ",
				"skillPerformanceSubtitle": "ਸਵਾਲ ਦੀ ਕਿਸਮ ਅਤੇ ਨਿਪੁੰਨਤਾ ਅਨੁਸਾਰ ਪ੍ਰਗਤੀ",
				"skillLevelSubtitle": "ਇਸ ਹੁਨਰ ਪੱਧਰ ਵਿੱਚ ਤੁਹਾਡੀ ਪ੍ਰਗਤੀ",
				"skillsPerformanceTitle": "ਹੁਨਰ ਪ੍ਰਦਰਸ਼ਨ",
				"performanceByItemDifficulty": "ਆਈਟਮ ਨਿਪੁੰਨਤਾ ਅਨੁਸਾਰ ਪ੍ਰਦਰਸ਼ਨ",
				"performanceByItemDifficultyCaption_one": "ਨਿਪੁੰਨਤਾ ਪੱਧਰ ਅਨੁਸਾਰ ਤੁਹਾਡੀ ਸ਼ੁੱਧਤਾ ਵਿਖਾਉਂਦਾ ਹੈ, {{count}} ਆਈਟਮ ਦੇ ਜਵਾਬ ਦੇ ਆਧਾਰ 'ਤੇ",
				"performanceByItemDifficultyCaption_other": "ਨਿਪੁੰਨਤਾ ਪੱਧਰ ਅਨੁਸਾਰ ਤੁਹਾਡੀ ਸ਼ੁੱਧਤਾ ਵਿਖਾਉਂਦਾ ਹੈ, {{count}} ਆਈਟਮਾਂ ਦੇ ਜਵਾਬ ਦੇ ਆਧਾਰ 'ਤੇ",
				"questionTypePartSubtitle": "{{skill}} · ਭਾਗ {{part}}",
				"activityGoalTitle": "ਗਤੀਵਿਧੀ ਅਤੇ ਟੀਚਾ ਪ੍ਰਗਤੀ",
				"recentActivityTitle": "ਹਾਲੀਆ ਗਤੀਵਿਧੀ",
				"goalProgressTitle": "ਟੀਚਾ ਪ੍ਰਗਤੀ",
				"goalProgressSubtitle": "ਸਮੁੱਚਾ ਸਕੋਰ · ਪਿਛਲੇ 7 ਹਫ਼ਤੇ",
				"goalProgressInsight": "ਤੁਸੀਂ ਲਗਾਤਾਰ ਸੁਧਾਰ ਕਰ ਰਹੇ ਹੋ। ਤੁਸੀਂ ਆਪਣੇ ਟੀਚੇ ਤੋਂ 14 ਅੰਕ ਪਿੱਛੇ ਹੋ ਅਤੇ ਲਗਭਗ 3 ਹਫ਼ਤਿਆਂ ਵਿੱਚ ਆਪਣੇ ਟੀਚੇ ਤੱਕ ਪਹੁੰਚ ਸਕਦੇ ਹੋ।",
				"goalProgressActualLabel": "ਤੁਹਾਡਾ ਸਕੋਰ",
				"goalProgressTargetLabel": "ਟੀਚਾ",
				"goalProgressTimeAxisLabel": "ਸਮਾਂ",
				"goalProgressScoreAxisLabel": "ਸਮੁੱਚੀ ਪ੍ਰਗਤੀ",
				"statusTitle": "ਤੁਹਾਡੀ ਸਥਿਤੀ",
				"diagnosticsTitle": "ਡਾਇਗਨੌਸਟਿਕ",
				"diagnosticsReviewCta": "ਸਮੀਖਿਆ ਕਰੋ",
				"strengthsFocusTitle": "ਮਜ਼ਬੂਤੀਆਂ ਅਤੇ ਧਿਆਨ ਖੇਤਰ",
				"strengthsFocusSubtitle": "ਤੁਹਾਡੇ ਸਭ ਤੋਂ ਮਜ਼ਬੂਤ ਖੇਤਰ ਅਤੇ ਸਵਾਲ ਦੀਆਂ ਕਿਸਮਾਂ ਜਿਨ੍ਹਾਂ ਨੂੰ ਹੋਰ ਅਭਿਆਸ ਦੀ ਲੋੜ ਹੈ",
				"strengthsLabel": "ਮਜ਼ਬੂਤੀਆਂ",
				"focusAreasLabel": "ਧਿਆਨ ਖੇਤਰ",
				"recommendedNextStepLabel": "ਸਿਫ਼ਾਰਸ਼ੀ ਅਗਲਾ ਕਦਮ",
				"recommendedNextStepCta": "ਸ਼ੁਰੂ ਕਰੋ",
				"practiceTestsViewMore": "ਸਾਰੇ {{count}} ਟੈਸਟ ਵੇਖੋ"
			},
			"proficiencySection": "ਨਿਪੁੰਨਤਾ ਪੱਧਰ ਅਨੁਸਾਰ ਅਭਿਆਸ"
		},
		"recommendedTasks": {
			"sectionTitle": "ਤੁਹਾਡੇ ਲਈ ਸਿਫ਼ਾਰਸ਼ੀ",
			"startSessionAction": "ਅਭਿਆਸ ਕਰੋ",
			"resumeAction": "ਜਾਰੀ ਰੱਖੋ",
			"reviewResultsAction": "ਨਤੀਜਿਆਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
			"startTestAction": "ਸ਼ੁਰੂ ਕਰੋ",
			"activeTestBody": "ਆਪਣਾ ਜਾਰੀ ਮੁਲਾਂਕਣ ਪੂਰਾ ਕਰੋ",
			"completedTestBody": "ਆਪਣੇ ਨਤੀਜਿਆਂ ਅਤੇ ਵਿਅਕਤੀਗਤ ਇਨਸਾਈਟਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
			"diagnosticBody": "ਇੱਕ ਬੇਸਲਾਈਨ ਪ੍ਰਾਪਤ ਕਰਨ ਅਤੇ ਇਮਤਿਹਾਨ ਦੇ ਫਾਰਮੈਟ ਤੋਂ ਜਾਣੂ ਹੋਣ ਲਈ {{label}} ਲਓ",
			"diagnosticDefaultLabel": "ਮੁਫ਼ਤ ਡਾਇਗਨੌਸਟਿਕ",
			"practiceTestBody": "ਸਮਾਂਬੱਧ ਮੌਕ ਟੈਸਟ ਨਾਲ ਆਪਣੀ ਤਿਆਰੀ ਦਾ ਮੁਲਾਂਕਣ ਕਰੋ",
			"sectionalTestBody": "ਆਪਣੇ {{skills}} ਹੁਨਰਾਂ ਦਾ ਅਭਿਆਸ ਕਰਨ ਲਈ ਇੱਕ ਕੇਂਦਰਿਤ ਟੈਸਟ ਲਓ",
			"weakSkillTitle": "ਆਪਣੇ {{skill}} ਹੁਨਰਾਂ ਨੂੰ ਵਿਕਸਿਤ ਕਰੋ",
			"weakSkillBody": "{{questionType}} ਅਭਿਆਸ, ਉਹਨਾਂ ਖੇਤਰਾਂ 'ਤੇ ਕੇਂਦਰਿਤ ਜਿੱਥੇ ਤੁਹਾਨੂੰ ਸੁਧਾਰ ਦੀ ਲੋੜ ਹੈ",
			"strongSkillTitle": "ਆਪਣੇ {{skill}} ਹੁਨਰਾਂ ਨੂੰ ਤਿੱਖੇ ਰੱਖੋ",
			"strongSkillBody": "ਵਾਧੂ ਅਭਿਆਸ ਨਾਲ {{questionType}} ਵਿੱਚ ਆਪਣੀਆਂ ਮਜ਼ਬੂਤੀਆਂ ਬਣਾਈ ਰੱਖੋ",
			"mixedSkillTitle": "ਆਪਣੇ {{skill}} ਹੁਨਰਾਂ ਵਿੱਚ ਸੁਧਾਰ ਕਰੋ",
			"mixedSkillBody": "{{questionTypes}} ਵਰਗੀਆਂ ਸਵਾਲ ਦੀਆਂ ਕਿਸਮਾਂ ਦਾ ਅਭਿਆਸ ਕਰੋ, ਉਹਨਾਂ ਖੇਤਰਾਂ 'ਤੇ ਧਿਆਨ ਦਿੰਦੇ ਹੋਏ ਜਿੱਥੇ ਤੁਹਾਨੂੰ ਸੁਧਾਰ ਦੀ ਲੋੜ ਹੈ",
			"higherDifficultySkillTitle": "{{proficiency}} ਤੱਕ ਪੱਧਰ ਵਧਾਓ",
			"higherDifficultySkillBody": "ਹੁਣ ਜਦੋਂ ਤੁਸੀਂ {{questionType}} ਵਿੱਚ ਵਧੀਆ ਕਰ ਰਹੇ ਹੋ, ਮੁਸ਼ਕਲ ਵਧਾਉਣ ਦਾ ਸਮਾਂ ਹੈ",
			"itemsChip_one": "{{count}} ਆਈਟਮ",
			"itemsChip_other": "{{count}} ਆਈਟਮਾਂ",
			"timeRemainingChip": "{{minutes}} ਮਿੰਟ ਬਾਕੀ",
			"timeRemainingChipCompact": "{{minutes}} ਮਿੰਟ"
		},
		"itemTypes": {
			"answeredLabel_one": "ਆਈਟਮ ਦਾ ਜਵਾਬ ਦਿੱਤਾ ਗਿਆ",
			"answeredLabel_other": "ਆਈਟਮਾਂ ਦਾ ਜਵਾਬ ਦਿੱਤਾ ਗਿਆ",
			"answeredAll": "ਸਭ",
			"answeredPartial": "{{total}} ਵਿੱਚੋਂ {{answered}}",
			"cardSubtitleComplete": "ਸਾਰੀਆਂ ਆਈਟਮਾਂ ਦਾ ਜਵਾਬ ਦਿੱਤਾ ਗਿਆ",
			"cardSubtitlePartial": "{{total}} ਵਿੱਚੋਂ {{attempted}} ਆਈਟਮਾਂ ਦਾ ਜਵਾਬ ਦਿੱਤਾ ਗਿਆ",
			"cardSubtitleResponses_one": "{{count}} ਪ੍ਰਤੀਕਿਰਿਆ",
			"cardSubtitleResponses_other": "{{count}} ਪ੍ਰਤੀਕਿਰਿਆਵਾਂ",
			"responsesLabel_one": "ਪ੍ਰਤੀਕਿਰਿਆ",
			"responsesLabel_other": "ਪ੍ਰਤੀਕਿਰਿਆਵਾਂ",
			"detail": {
				"skillLabel": "ਹੁਨਰ",
				"estimatedLevelLabel": "ਅਨੁਮਾਨਿਤ ਪੱਧਰ"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} ਪ੍ਰਤੀਕਿਰਿਆ",
			"responseCount_other": "{{count, number}} ਪ੍ਰਤੀਕਿਰਿਆਵਾਂ"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "{{count, number}} ਅਭਿਆਸ ਆਈਟਮ ਮੁਫ਼ਤ ਵਿੱਚ ਸ਼ਾਮਲ",
			"freeContentBannerTitle_other": "{{count, number}} ਅਭਿਆਸ ਆਈਟਮਾਂ ਮੁਫ਼ਤ ਵਿੱਚ ਸ਼ਾਮਲ",
			"freeContentBannerBody": "ਚੁਣੀਆਂ ਗਈਆਂ {{skills}} ਆਈਟਮਾਂ ਕਦੇ ਵੀ ਅਭਿਆਸ ਕਰੋ। ਪੂਰਾ ਸਟੱਡੀ ਪੈਕ ਅਨਲੌਕ ਕਰਨ ਲਈ ਅੱਪਗ੍ਰੇਡ ਕਰੋ।",
			"freeContentBannerCta": "ਮੁਫ਼ਤ ਅਭਿਆਸ ਸ਼ੁਰੂ ਕਰੋ"
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "ਦੂਜਿਆਂ ਦੇ ਮੁਕਾਬਲੇ ਆਪਣੀ ਸਥਿਤੀ ਵੇਖੋ।"
		},
		"home": {
			"title": "ਹੋਮ"
		},
		"podcasts": {
			"description": "ਮਾਹਿਰਾਂ ਦੁਆਰਾ ਸੰਚਾਲਿਤ ਆਰਥੋਪੈਡਿਕ ਪੌਡਕਾਸਟ ਸੁਣੋ।"
		},
		"more": {
			"title": "ਹੋਰ ਸੈਟਿੰਗਾਂ"
		}
	},
	"emptyState": {
		"progress": {
			"title": "ਕੋਈ ਅਧਿਐਨ ਪ੍ਰਗਤੀ ਨਹੀਂ",
			"subtitle": "ਜਿਵੇਂ-ਜਿਵੇਂ ਤੁਸੀਂ ਅਧਿਐਨ ਕਰੋਗੇ, ਤੁਹਾਡੀ ਪ੍ਰਗਤੀ ਇੱਥੇ ਦਿਖਾਈ ਦੇਵੇਗੀ।",
			"cta": "ਹੁਣੇ ਅਧਿਐਨ ਕਰੋ"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "ਗਲਤੀ",
			"body": "ਸੈਸ਼ਨ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "ਐਡਵਾਂਸਡ",
			"highIntermediate": "ਇੰਟਰਮੀਡੀਏਟ",
			"intermediate": "ਇੰਟਰਮੀਡੀਏਟ",
			"basic": "ਬੇਸਿਕ",
			"none": "ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ",
			"high": "ਮਾਹਿਰ",
			"medium": "ਲਗਭਗ ਤਿਆਰ",
			"low": "ਸੁਧਾਰ ਲੋੜੀਂਦਾ"
		}
	},
	"leaderboard": {
		"you": "ਇਹ ਤੁਸੀਂ ਹੋ",
		"periods": {
			"all_time": "ਹਰ ਸਮੇਂ",
			"month": "ਇਸ ਮਹੀਨੇ",
			"week": "ਇਸ ਹਫ਼ਤੇ"
		},
		"scope": {
			"global": "ਗਲੋਬਲ",
			"friends": "ਦੋਸਤ"
		},
		"friends": {
			"soon": "ਜਲਦੀ",
			"comingSoonTitle": "ਦੋਸਤ ਲੀਡਰਬੋਰਡ",
			"comingSoonBadge": "ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ",
			"comingSoonDescription": "ਦੋਸਤਾਂ ਦੇ ਮੁਕਾਬਲੇ ਆਪਣੀ ਪ੍ਰਗਤੀ ਨੂੰ ਟਰੈਕ ਕਰੋ ਅਤੇ ਵੇਖੋ ਕਿ ਕਲਾਸ ਵਿੱਚ ਸਭ ਤੋਂ ਅੱਗੇ ਕੌਣ ਹੈ।"
		},
		"error": {
			"title": "ਕਨੈਕਸ਼ਨ ਗਲਤੀ",
			"description": "ਲੀਡਰਬੋਰਡ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ। ਆਪਣਾ ਕਨੈਕਸ਼ਨ ਜਾਂਚੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
			"tryAgain": "ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ"
		},
		"empty": {
			"title": "ਹਾਲੇ ਤੱਕ ਕੋਈ ਲੀਡਰ ਨਹੀਂ",
			"description": "ਜਿਵੇਂ-ਜਿਵੇਂ ਹੋਰ ਲੋਕ ਅਧਿਐਨ ਕਰਦੇ ਹਨ, ਦਰਜਾਬੰਦੀ ਅੱਪਡੇਟ ਹੁੰਦੀ ਹੈ। XP ਕਮਾਉਣ ਅਤੇ ਸਿਖਰਲਾ ਸਥਾਨ ਹਾਸਲ ਕਰਨ ਵਾਲੇ ਪਹਿਲੇ ਬਣੋ!",
			"startLearning": "ਹੁਣੇ ਅਧਿਐਨ ਕਰੋ"
		},
		"topPerformers": "ਸਿਖਰਲੇ ਪ੍ਰਦਰਸ਼ਨਕਾਰ",
		"yourPosition": "ਤੁਹਾਡਾ ਸਥਾਨ",
		"rankings": "ਦਰਜਾਬੰਦੀ",
		"rankingsRange": "ਦਰਜਾਬੰਦੀ • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "ਦਰਜਾਬੰਦੀ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਣ ਲਈ XP ਕਮਾਓ!",
			"description": "ਆਪਣੇ ਪਹਿਲੇ ਅੰਕ ਕਮਾਉਣ ਅਤੇ ਲੀਡਰਬੋਰਡ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਣ ਲਈ ਇੱਕ ਅਧਿਐਨ ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰੋ।",
			"cta": "ਆਪਣਾ ਪਹਿਲਾ ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰੋ"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "ਤੁਸੀਂ",
		"podium": {
			"first": "ਪਹਿਲਾ",
			"second": "ਦੂਜਾ",
			"third": "ਤੀਜਾ"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>#{{rank}} ਨੂੰ ਪਿੱਛੇ ਛੱਡਣ ਲਈ</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>ਪੋਡੀਅਮ ਤੋਂ</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "ਪਾਠ",
			"searchPlaceholder": "ਪਾਠ ਖੋਜੋ",
			"count_one": "{{count}} ਪਾਠ",
			"count_other": "{{count}} ਪਾਠ",
			"sortModalTitle": "ਪਾਠ ਕ੍ਰਮਬੱਧ ਕਰੋ",
			"filterModalTitle": "ਵਿਸ਼ਿਆਂ ਅਨੁਸਾਰ ਫਿਲਟਰ ਕਰੋ",
			"sort": {
				"popularity": "ਪ੍ਰਸਿੱਧੀ",
				"popularityShort": "ਪ੍ਰਸਿੱਧ",
				"topic": "ਵਿਸ਼ਾ",
				"difficulty": "ਕਠਿਨਾਈ",
				"recent": "ਹਾਲ ਹੀ ਵਿੱਚ ਅੱਪਡੇਟ ਕੀਤੇ",
				"recentShort": "ਅੱਪਡੇਟ ਕੀਤੇ",
				"completed": "ਪੂਰਾ ਹੋਇਆ"
			},
			"chips": {
				"all": "ਸਭ",
				"recent": "ਹਾਲ ਹੀ ਵਿੱਚ ਅੱਪਡੇਟ ਕੀਤੇ",
				"completed": "ਪੂਰਾ ਹੋਇਆ",
				"premium": "ਪ੍ਰੀਮੀਅਮ",
				"topics": "ਵਿਸ਼ੇ",
				"topicsCount_one": "{{count}} ਵਿਸ਼ਾ",
				"topicsCount_other": "{{count}} ਵਿਸ਼ੇ"
			},
			"chipTooltips": {
				"all": "ਹਰ ਪਾਠ ਦਿਖਾਓ।",
				"recent": "ਸਭ ਤੋਂ ਹਾਲ ਹੀ ਵਿੱਚ ਅੱਪਡੇਟ ਕੀਤੇ ਪਾਠ ਦਿਖਾਓ।",
				"completed": "ਪੂਰੇ ਹੋਏ ਪਾਠ ਦਿਖਾਓ।",
				"premium": "ਪ੍ਰੀਮੀਅਮ ਪਾਠ ਦਿਖਾਓ।",
				"topics": "ਵਿਸ਼ੇ ਅਨੁਸਾਰ ਪਾਠ ਫਿਲਟਰ ਕਰੋ।"
			},
			"filterNames": {
				"premium": "ਪ੍ਰੀਮੀਅਮ",
				"completed": "ਪੂਰਾ ਹੋਇਆ",
				"topics": "ਵਿਸ਼ਾ"
			},
			"empty": {
				"searchTitle_one": "ਖੋਜ ਦੁਆਰਾ {{count}} ਪਾਠ ਲੁਕਾਇਆ ਗਿਆ",
				"searchTitle_other": "ਖੋਜ ਦੁਆਰਾ {{count}} ਪਾਠ ਲੁਕਾਏ ਗਏ",
				"searchSubtitle": "ਵੱਖਰੇ ਕੀਵਰਡ ਅਜ਼ਮਾਓ ਜਾਂ ਆਪਣੀ ਖੋਜ ਸਾਫ਼ ਕਰੋ",
				"searchCta": "ਖੋਜ ਸਾਫ਼ ਕਰੋ",
				"filtersTitle_one": "ਫਿਲਟਰਾਂ ਦੁਆਰਾ {{count}} ਪਾਠ ਲੁਕਾਇਆ ਗਿਆ",
				"filtersTitle_other": "ਫਿਲਟਰਾਂ ਦੁਆਰਾ {{count}} ਪਾਠ ਲੁਕਾਏ ਗਏ",
				"filtersSubtitle_one": "ਹੋਰ ਵੇਖਣ ਲਈ {{filters}} ਫਿਲਟਰ ਹਟਾਓ",
				"filtersSubtitle_other": "ਹੋਰ ਵੇਖਣ ਲਈ {{filters}} ਫਿਲਟਰ ਹਟਾਓ",
				"filtersCta": "ਸਾਰੇ ਫਿਲਟਰ ਸਾਫ਼ ਕਰੋ",
				"noneTitle": "ਕੋਈ ਪਾਠ ਨਹੀਂ ਮਿਲਿਆ",
				"noneSubtitle": "ਫਿਲਟਰ ਹਟਾਉਣ ਜਾਂ ਨਵੀਂ ਖੋਜ ਸ਼ੁਰੂ ਕਰਨ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
				"noneCta": "ਸਭ ਰੀਸੈੱਟ ਕਰੋ"
			}
		},
		"home": {
			"settings": {
				"a11yLabel": "ਸੈਟਿੰਗਾਂ ਖੋਲ੍ਹੋ"
			},
			"continueLearning": {
				"title": "ਸਿੱਖਣਾ ਜਾਰੀ ਰੱਖੋ"
			},
			"suggested": {
				"title": "ਤੁਹਾਡੇ ਲਈ ਸੁਝਾਏ ਗਏ"
			},
			"completed": {
				"title": "ਪੂਰਾ ਹੋਇਆ"
			},
			"all": {
				"title": "ਸਾਰੇ ਪਾਠ"
			},
			"emptyState": {
				"title": "ਹਾਲੇ ਕੋਈ ਪਾਠ ਨਹੀਂ",
				"subtitle": "ਨਵੇਂ ਪਾਠਾਂ ਲਈ ਜਲਦੀ ਦੁਬਾਰਾ ਵੇਖੋ।"
			},
			"card": {
				"resumeCta": "ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ",
				"progress": "{{value}}% ਪੂਰਾ",
				"timeLeft_one": "{{count}} ਮਿੰਟ ਬਾਕੀ",
				"timeLeft_other": "{{count}} ਮਿੰਟ ਬਾਕੀ",
				"duration_one": "{{count}} ਮਿੰਟ",
				"duration_other": "{{count}} ਮਿੰਟ"
			}
		},
		"overview": {
			"header": {
				"title": "ਸੰਖੇਪ ਜਾਣਕਾਰੀ"
			},
			"startCta": "ਸਿੱਖਣਾ ਸ਼ੁਰੂ ਕਰੋ",
			"objectives": {
				"title": "ਸਿੱਖਣ ਦੇ ਉਦੇਸ਼"
			}
		},
		"detail": {
			"takeQuizCta": "ਕਵਿਜ਼ ਦਿਓ",
			"progress": {
				"label": "ਮੋਡਿਊਲ ਪ੍ਰਗਤੀ"
			},
			"activities": {
				"title": "ਗਤੀਵਿਧੀਆਂ",
				"completedCount": "{{total}} ਵਿੱਚੋਂ {{completed}} ਪੂਰੀਆਂ"
			},
			"artifact": {
				"completed": "ਪੂਰਾ ਹੋਇਆ",
				"locked": "ਲੌਕ"
			}
		},
		"stats": {
			"insights": {
				"title": "ਪ੍ਰਗਤੀ ਇਨਸਾਈਟ"
			},
			"overallProgress": {
				"title": "ਸਮੁੱਚੀ ਪ੍ਰਗਤੀ",
				"completedCount_one": "{{count}} ਵਿੱਚੋਂ {{completed}} ਆਈਟਮ ਪੂਰੀ",
				"completedCount_other": "{{count}} ਵਿੱਚੋਂ {{completed}} ਆਈਟਮਾਂ ਪੂਰੀਆਂ"
			},
			"milestones": {
				"title": "ਮੋਡਿਊਲ ਮੀਲ ਪੱਥਰ"
			}
		},
		"studyGuide": {
			"sectionBadge": {
				"label": "ਸੈਕਸ਼ਨ {{number}}, {{total}} ਵਿੱਚੋਂ"
			},
			"upNext": {
				"title": "ਅਗਲਾ"
			}
		}
	},
	"sessionConfig": {
		"title": "ਕਸਟਮ ਅਧਿਐਨ ਸੈਸ਼ਨ",
		"diagnostic": "ਡਾਇਗਨੌਸਟਿਕ",
		"skill": "ਹੁਨਰ",
		"Proficiency": "ਨਿਪੁੰਨਤਾ",
		"Question Type": "ਸਵਾਲਾਂ ਦੀਆਂ ਕਿਸਮਾਂ",
		"mastery": "ਮੁਹਾਰਤ",
		"sessionLength": "ਸੈਸ਼ਨ ਦੀ ਲੰਬਾਈ",
		"itemsChip_one": "{{count}} ਆਈਟਮ",
		"itemsChip_other": "{{count}} ਆਈਟਮਾਂ",
		"durationEstimate": "{{minutes}} ਮਿੰਟ",
		"durationRange": "{{min}}–{{max}} ਮਿੰਟ",
		"noItemsTooltip": "ਮੌਜੂਦਾ ਫਿਲਟਰਾਂ ਨਾਲ ਕੋਈ ਵੀ ਆਈਟਮ ਮੇਲ ਨਹੀਂ ਖਾਂਦੀ",
		"setCount": "{{count}} {{type}}",
		"dismiss": "ਠੀਕ ਹੈ",
		"status": {
			"notAnswered": "ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ",
			"needsWork": "ਸੁਧਾਰ ਲੋੜੀਂਦਾ"
		},
		"itemCount": "ਤੁਸੀਂ {{topics}} ਵਿੱਚ {{count}} ਆਈਟਮਾਂ ਪੂਰੀਆਂ ਕਰੋਗੇ",
		"start": "ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰੋ",
		"configuringSession": "ਸੈਸ਼ਨ ਸੰਰਚਿਤ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ",
		"fetchingContent": "ਸਮੱਗਰੀ ਲਿਆਂਦੀ ਜਾ ਰਹੀ ਹੈ",
		"preparingMaterials": "ਸਮੱਗਰੀ ਤਿਆਰ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ",
		"almostThere": "ਲਗਭਗ ਤਿਆਰ",
		"startingSession": "ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ",
		"playIcon": "play-outline",
		"infoText": "ਤੁਸੀਂ **{{numItems}}** {{itemCount}} ਪੂਰੀਆਂ ਕਰੋਗੇ। ਇਸ ਵਿੱਚ ਲਗਭਗ **{{timeString}}** ਦਾ ਸਮਾਂ ਲੱਗੇਗਾ।",
		"customSummary": {
			"message": "{{topics}} ਵਿੱਚੋਂ $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) ਦਾ ਅਧਿਐਨ ਕਰੋ।",
			"messageWithMastery": "{{topics}} ਵਿੱਚੋਂ $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) ਦਾ ਅਧਿਐਨ ਕਰੋ, {{masteryLevels}} $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}) 'ਤੇ ਧਿਆਨ ਕੇਂਦਰਿਤ ਕਰਦੇ ਹੋਏ।",
			"messageAllMasteryLevels": "ਸਾਰੇ ਮੁਹਾਰਤ ਪੱਧਰਾਂ ਵਿੱਚ {{topics}} ਵਿੱਚੋਂ $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) ਦਾ ਅਧਿਐਨ ਕਰੋ।",
			"itemCount_one": "{{count}} ਆਈਟਮ",
			"itemCount_other": "{{count}} ਆਈਟਮਾਂ",
			"masteryLevelCount_one": "ਮੁਹਾਰਤ ਪੱਧਰ",
			"masteryLevelCount_other": "ਮੁਹਾਰਤ ਪੱਧਰ",
			"allTopics": "ਸਾਰੇ {{count}} ਵਿਸ਼ੇ",
			"more": "{{count}} ਹੋਰ",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "ਤੁਰੰਤ ਅਧਿਐਨ",
			"recommended": "ਸਿਫ਼ਾਰਸ਼ੀ",
			"custom": "ਕਸਟਮ",
			"selectHelper": "ਚੁਣਨ ਲਈ ਕਿਸੇ ਸੈਸ਼ਨ 'ਤੇ ਟੈਪ ਕਰੋ, ਫਿਰ ਤਿਆਰ ਹੋਣ 'ਤੇ ਸ਼ੁਰੂ ਕਰੋ।",
			"emptyRecommended": "ਇਸ ਵੇਲੇ ਕੋਈ ਸਿਫ਼ਾਰਸ਼ੀ ਸੈਸ਼ਨ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
			"summary": "{{skill}} ਤੋਂ {{count}} ਆਈਟਮਾਂ ਦਾ ਅਧਿਐਨ ਕਰੋ। ਅਨੁਮਾਨਿਤ {{minutes}} ਮਿੰਟ।",
			"summary_questionType": "{{skill}}, {{questionType}} ਤੋਂ {{count}} ਆਈਟਮਾਂ ਦਾ ਅਧਿਐਨ ਕਰੋ। ਅਨੁਮਾਨਿਤ {{minutes}} ਮਿੰਟ।",
			"duration": "{{minutes}} ਮਿੰਟ",
			"durationSelector": {
				"title": "ਮਿਆਦ"
			},
			"levelSessions": {
				"rapidRecall": "ਤੇਜ਼ ਯਾਦ",
				"purposefulPractice": "ਉਦੇਸ਼ਪੂਰਨ ਅਭਿਆਸ",
				"focusFlow": "ਧਿਆਨ ਪ੍ਰਵਾਹ",
				"itemsLabel": "{{level}} ਆਈਟਮਾਂ",
				"itemsLabelGeneric": "ਆਈਟਮਾਂ",
				"summaries": {
					"rapidRecall": "ਆਪਣੀ ਕਵਰੇਜ ਨੂੰ ਲਗਾਤਾਰ ਵਧਾਉਣ ਲਈ {{count}} {{level}} ਆਈਟਮਾਂ ਨਾਲ ਤੁਰੰਤ ਜਾਣ-ਪਛਾਣ ਕਰੋ, ਜਿਨ੍ਹਾਂ ਦਾ ਤੁਸੀਂ ਹਾਲੇ ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ। ਅਨੁਮਾਨਿਤ {{minutes}} ਮਿੰਟ।",
					"purposefulPractice": "{{count}} {{level}} ਆਈਟਮਾਂ ਦੇ ਸੰਤੁਲਿਤ ਸੈੱਟ ਵਿੱਚੋਂ ਲੰਘੋ, ਸਭ ਤੋਂ ਵੱਧ ਸੁਧਾਰ ਦੀ ਲੋੜ ਵਾਲੀ ਸਮੱਗਰੀ ਤੋਂ ਸ਼ੁਰੂ ਕਰਦੇ ਹੋਏ। ਅਨੁਮਾਨਿਤ {{minutes}} ਮਿੰਟ।",
					"focusFlow": "ਘੱਟ ਜਾਂ ਮੱਧਮ ਮੁਹਾਰਤ ਨਾਲ ਜਵਾਬ ਦਿੱਤੀਆਂ {{count}} {{level}} ਆਈਟਮਾਂ ਨਾਲ ਆਪਣੀਆਂ ਕਮਜ਼ੋਰੀਆਂ ਨੂੰ ਮਜ਼ਬੂਤ ਕਰੋ। ਅਨੁਮਾਨਿਤ {{minutes}} ਮਿੰਟ।"
				},
				"summariesGeneric": {
					"rapidRecall": "ਆਪਣੀ ਕਵਰੇਜ ਨੂੰ ਲਗਾਤਾਰ ਵਧਾਉਣ ਲਈ {{count}} ਆਈਟਮਾਂ ਨਾਲ ਤੁਰੰਤ ਜਾਣ-ਪਛਾਣ ਕਰੋ, ਜਿਨ੍ਹਾਂ ਦਾ ਤੁਸੀਂ ਹਾਲੇ ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ। ਅਨੁਮਾਨਿਤ {{minutes}} ਮਿੰਟ।",
					"purposefulPractice": "{{count}} ਆਈਟਮਾਂ ਦੇ ਸੰਤੁਲਿਤ ਸੈੱਟ ਵਿੱਚੋਂ ਲੰਘੋ, ਸਭ ਤੋਂ ਵੱਧ ਸੁਧਾਰ ਦੀ ਲੋੜ ਵਾਲੀ ਸਮੱਗਰੀ ਤੋਂ ਸ਼ੁਰੂ ਕਰਦੇ ਹੋਏ। ਅਨੁਮਾਨਿਤ {{minutes}} ਮਿੰਟ।",
					"focusFlow": "ਘੱਟ ਜਾਂ ਮੱਧਮ ਮੁਹਾਰਤ ਨਾਲ ਜਵਾਬ ਦਿੱਤੀਆਂ {{count}} ਆਈਟਮਾਂ ਨਾਲ ਆਪਣੀਆਂ ਕਮਜ਼ੋਰੀਆਂ ਨੂੰ ਮਜ਼ਬੂਤ ਕਰੋ। ਅਨੁਮਾਨਿਤ {{minutes}} ਮਿੰਟ।"
				}
			},
			"lockedOptionsBanner": "ਪ੍ਰੀਮੀਅਮ ਨਾਲ {{names}} ਅਨਲੌਕ ਕਰੋ",
			"lockedOptionsBannerOverflow": "ਪ੍ਰੀਮੀਅਮ ਨਾਲ {{names}} ਅਤੇ {{count}} ਹੋਰ ਅਨਲੌਕ ਕਰੋ"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "ਆਪਣੇ ਅਨੁਭਵ ਨੂੰ ਵਿਅਕਤੀਗਤ ਬਣਾਉਣ ਲਈ, ਇੱਕ ਡਾਇਗਨੌਸਟਿਕ ਕੁਇਜ਼ ਨਾਲ ਸ਼ੁਰੂ ਕਰੋ। ਤੁਹਾਡੇ ਡਾਇਗਨੌਸਟਿਕ ਦੇ ਨਤੀਜਿਆਂ ਦੀ ਵਰਤੋਂ ਤੁਹਾਡੀ ਅਧਿਐਨ ਯੋਜਨਾ ਬਣਾਉਣ ਲਈ ਕੀਤੀ ਜਾਵੇਗੀ।"
	},
	"premium": {
		"chip": "ਪ੍ਰੀਮੀਅਮ",
		"upgrade": "ਪ੍ਰੀਮੀਅਮ ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
		"unlockTitle": "ਆਪਣੇ ਸੰਪੂਰਨ {{productName}} ਅਨੁਭਵ ਨੂੰ ਅਨਲੌਕ ਕਰੋ",
		"unlockDescription": "ਤੁਹਾਡੇ ਬਾਕੀ ਬਚੇ ਅਧਿਐਨ ਸਮੇਂ ਦੇ ਆਧਾਰ 'ਤੇ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਵਿਅਕਤੀਗਤ ਅਭਿਆਸ ਅਨਲੌਕ ਕਰੋ।",
		"readyTitle": "ਆਪਣੇ {{date}} ਦੇ ਇਮਤਿਹਾਨ ਲਈ ਤਿਆਰ ਰਹੋ",
		"tip": "ਤੁਹਾਡਾ ਵਿਅਕਤੀਗਤ ਫੋਕਸ, ਪ੍ਰੀਮੀਅਮ ਇਹ ਪਛਾਣਦਾ ਹੈ ਕਿ ਅੱਗੇ ਕੀ ਅਭਿਆਸ ਕਰਨਾ ਹੈ ਅਤੇ ਤੁਹਾਡੇ ਸੁਧਾਰ ਦੇ ਨਾਲ ਤੁਹਾਡੀ ਅਧਿਐਨ ਯੋਜਨਾ ਨੂੰ ਅਨੁਕੂਲ ਬਣਾਉਂਦਾ ਹੈ।"
	},
	"purchase": {
		"success": {
			"headerTitle": "ਤੁਹਾਡੀ ਖਰੀਦ ਲਈ ਧੰਨਵਾਦ!",
			"accessGranted": "ਤੁਹਾਡੇ {{name}} ਤੱਕ ਪਹੁੰਚ ਸਫਲਤਾਪੂਰਵਕ ਦਿੱਤੀ ਗਈ ਹੈ",
			"studyPack": "ਸਟੱਡੀ ਪੈਕ",
			"practiceTest": "ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ",
			"combo": "ਕੰਬੋ",
			"documentTitle": "ਖਰੀਦ",
			"summary_one": "ਵਧਾਈਆਂ! ਹੇਠਾਂ ਦਿੱਤਾ **ਉਤਪਾਦ** ਤੁਹਾਡੇ ਖਾਤੇ 'ਤੇ ਅਨਲੌਕ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ। {{action}} ਬਟਨ ਦਬਾਉਣ ਤੋਂ ਬਾਅਦ, ਤੁਹਾਡੀ ਐਪ ਦਾ ਸੰਦਰਭ ਇਸ ਇਮਤਿਹਾਨ ਨੂੰ ਦਰਸਾਉਣ ਲਈ ਬਦਲ ਦਿੱਤਾ ਜਾਵੇਗਾ: **{{examName}}**। ਜੇ ਤੁਸੀਂ ਕਿਸੇ ਵੱਖਰੇ ਇਮਤਿਹਾਨ ਲਈ ਅਧਿਐਨ ਕਰਨਾ ਜਾਂ ਕੋਈ ਵੱਖਰਾ ਉਤਪਾਦ ਖਰੀਦਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਤਾਂ ਤੁਸੀਂ ਇਸਨੂੰ ਆਪਣੀ ਖਾਤਾ ਸੈਟਿੰਗਾਂ ਤੋਂ ਕਿਸੇ ਵੀ ਸਮੇਂ ਬਦਲ ਸਕਦੇ ਹੋ।",
			"summary_other": "ਵਧਾਈਆਂ! ਹੇਠਾਂ ਦਿੱਤੇ **{{count}} ਉਤਪਾਦ** ਤੁਹਾਡੇ ਖਾਤੇ 'ਤੇ ਅਨਲੌਕ ਕਰ ਦਿੱਤੇ ਗਏ ਹਨ। {{action}} ਬਟਨ ਦਬਾਉਣ ਤੋਂ ਬਾਅਦ, ਤੁਹਾਡੀ ਐਪ ਦਾ ਸੰਦਰਭ ਇਸ ਇਮਤਿਹਾਨ ਨੂੰ ਦਰਸਾਉਣ ਲਈ ਬਦਲ ਦਿੱਤਾ ਜਾਵੇਗਾ: **{{examName}}**। ਜੇ ਤੁਸੀਂ ਕਿਸੇ ਵੱਖਰੇ ਇਮਤਿਹਾਨ ਲਈ ਅਧਿਐਨ ਕਰਨਾ ਜਾਂ ਕੋਈ ਵੱਖਰਾ ਉਤਪਾਦ ਖਰੀਦਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਤਾਂ ਤੁਸੀਂ ਇਸਨੂੰ ਆਪਣੀ ਖਾਤਾ ਸੈਟਿੰਗਾਂ ਤੋਂ ਕਿਸੇ ਵੀ ਸਮੇਂ ਬਦਲ ਸਕਦੇ ਹੋ।",
			"unlockedDuration": "ਵਧਾਈਆਂ! ਤੁਸੀਂ **{{name}}** ਲਈ **{{duration}}** ਦੀ ਪਹੁੰਚ ਅਨਲੌਕ ਕਰ ਲਈ ਹੈ। ਇਹ **{{expiry}}** ਨੂੰ ਖਤਮ ਹੋਵੇਗੀ।",
			"storeNote": "ਧਿਆਨ ਦਿਓ: ਸਟੱਡੀ ਪੈਕ ਸਿਰਫ਼ ਸਾਡੀਆਂ ਮੋਬਾਈਲ ਐਪਾਂ ਰਾਹੀਂ ਹੀ ਵਰਤੇ ਜਾ ਸਕਦੇ ਹਨ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਡਿਵਾਈਸ ਲਈ ਢੁਕਵੀਂ ਐਪ ਡਾਊਨਲੋਡ ਕਰੋ।",
			"actions": {
				"goToHome": "ਹੋਮ 'ਤੇ ਜਾਓ",
				"startDiagnostic": "{{label}} ਸ਼ੁਰੂ ਕਰੋ",
				"takeDiagnostic": "{{label}} ਲਓ",
				"takeFreeDiagnostic": "ਮੁਫ਼ਤ ਡਾਇਗਨੌਸਟਿਕ ਲਓ",
				"diagnosticLabel": "ਡਾਇਗਨੌਸਟਿਕ"
			}
		},
		"checkout": {
			"headerTitle": "ਆਪਣੀ ਖਰੀਦ ਪੂਰੀ ਕਰੋ"
		},
		"paywall": {
			"studyPackDialogTitle": "ਆਪਣੀ ਅਧਿਐਨ ਯੋਜਨਾ ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
			"defaultDialogTitle": "ਆਪਣੀ ਅਧਿਐਨ ਯੋਜਨਾ ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
			"practiceTestDialogTitle": "ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ ਅਨਲੌਕ ਕਰੋ",
			"restorePurchaseDialogTitle": "ਕੀ ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਖਰੀਦ ਲਿਆ ਹੈ?",
			"restorePurchaseDialogSubheadingWeb": "ਜੇ ਨਹੀਂ, ਤਾਂ ਇਹ ਅਜ਼ਮਾਓ:",
			"restorePurchaseDialogBody": "ਜੇ ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਇਹ ਉਤਪਾਦ ਖਰੀਦ ਲਿਆ ਹੈ ਅਤੇ ਇਹ ਹਾਲੇ ਵੀ ਲੌਕ ਹੈ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਹੇਠ ਲਿਖੇ ਅਜ਼ਮਾਓ:\n\n1. ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਸੀਂ ਸਹੀ ਖਾਤੇ ਵਿੱਚ ਲੌਗਇਨ ਕੀਤਾ ਹੋਇਆ ਹੈ\n2. ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਸੀਂ ਸਹੀ ਉਤਪਾਦ ਚੁਣਿਆ ਹੋਇਆ ਹੈ\n3. ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਹਾਡੀ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਦੀ ਮਿਆਦ ਖ਼ਤਮ ਨਹੀਂ ਹੋਈ\n4. ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਸੀਂ ਆਪਣੀ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਸਰਗਰਮ ਕੀਤੀ ਹੋਈ ਹੈ (ਆਪਣੀ ਜੰਕ ਮੇਲ ਚੈੱਕ ਕਰੋ)\n5. ਜੇ ਤੁਹਾਡੇ ਕੋਲ ਪਹੁੰਚ ਕੋਡ ਹੈ, ਤਾਂ [ਪਹੁੰਚ ਕੋਡ]({{baseUrl}}/redeem)\n\nਜੇ ਇਹਨਾਂ ਵਿੱਚੋਂ ਕੋਈ ਵੀ ਲਾਗੂ ਨਹੀਂ ਹੁੰਦਾ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ **ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ**",
			"restorePurchaseDialogBodyWeb": "1. ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਸੀਂ ਸਹੀ ਈਮੇਲ ਵਿੱਚ ਲੌਗਇਨ ਕੀਤਾ ਹੋਇਆ ਹੈ\n2. ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਹਾਡੇ ਕੋਲ ਸਹੀ **[ਇਮਤਿਹਾਨ ਚੁਣਿਆ ਹੋਇਆ ਹੈ](/account/settings)**\n3. ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਹਾਡੀ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਦੀ ਮਿਆਦ ਖ਼ਤਮ ਨਹੀਂ ਹੋਈ\n\nਜੇ ਇਹਨਾਂ ਵਿੱਚੋਂ ਕੋਈ ਵੀ ਲਾਗੂ ਨਹੀਂ ਹੁੰਦਾ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ **ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ**",
			"accesDuration": {
				"yearPlan": "**{{duration}}** ਯੋਜਨਾ ਵਿਸਤ੍ਰਿਤ ਪਹੁੰਚ ਪ੍ਰਦਾਨ ਕਰਦੀ ਹੈ, ਜੋ ਤੁਹਾਨੂੰ ਆਪਣੀ ਰਫ਼ਤਾਰ ਨਾਲ ਅਧਿਐਨ ਕਰਨ ਅਤੇ ਆਪਣੇ ਇਮਤਿਹਾਨ ਦੀ ਚੰਗੀ ਤਰ੍ਹਾਂ ਤਿਆਰੀ ਕਰਨ ਲਈ ਵੱਧ ਤੋਂ ਵੱਧ ਲਚਕ ਦਿੰਦੀ ਹੈ।",
				"moreTime": "ਜੇ ਤੁਹਾਨੂੰ ਲੱਗਦਾ ਹੈ ਕਿ ਤੁਹਾਨੂੰ ਅਧਿਐਨ ਲਈ ਹੋਰ ਸਮੇਂ ਦੀ ਲੋੜ ਪਵੇਗੀ, ਤਾਂ ਤੁਸੀਂ **{{duration}}** ਯੋਜਨਾ ਬਾਰੇ ਸੋਚ ਸਕਦੇ ਹੋ।",
				"otherPlan": "**{{duration}}** ਯੋਜਨਾ ਤੁਹਾਨੂੰ **{{expiryText}}** ਤੱਕ ਪਹੁੰਚ ਦੇਵੇਗੀ, ਜੋ ਤੁਹਾਨੂੰ ਅਧਿਐਨ ਲਈ ਲੋੜੀਂਦਾ ਸਮਾਂ ਦਿੰਦੀ ਹੈ। {{moreTime}}"
			},
			"actions": {
				"upgrade": "ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
				"unlock": "{{price}} ਲਈ ਅਨਲੌਕ ਕਰੋ",
				"subscribe": "{{price}} ਲਈ ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ",
				"extendAccess": "ਪਹੁੰਚ ਵਧਾਓ",
				"accessHere": "ਇੱਥੇ ਪਹੁੰਚ ਕਰੋ",
				"redeemAccessCode": "ਕੀ ਤੁਹਾਡੇ ਕੋਲ ਪਹੁੰਚ ਕੋਡ ਹੈ?",
				"restorePurchase": "ਕੀ ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਖਰੀਦ ਲਿਆ ਹੈ?",
				"restorePurchaseWeb": "ਕੀ ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਖਰੀਦ ਲਿਆ ਹੈ ਜਾਂ ਤੁਹਾਡੇ ਕੋਲ ਪਹੁੰਚ ਕੋਡ ਹੈ?"
			},
			"subscriptionSummary": {
				"yearly": "ਸਾਲਾਨਾ ਸਬਸਕ੍ਰਿਪਸ਼ਨ • ਆਪਣੇ-ਆਪ ਰੀਨਿਊ ਹੋਣ ਵਾਲੀ • ਕਿਸੇ ਵੀ ਸਮੇਂ ਰੱਦ ਕਰੋ",
				"monthly": "ਮਹੀਨਾਵਾਰ ਸਬਸਕ੍ਰਿਪਸ਼ਨ • ਆਪਣੇ-ਆਪ ਰੀਨਿਊ ਹੋਣ ਵਾਲੀ • ਕਿਸੇ ਵੀ ਸਮੇਂ ਰੱਦ ਕਰੋ",
				"weekly": "ਹਫ਼ਤਾਵਾਰ ਸਬਸਕ੍ਰਿਪਸ਼ਨ • ਆਪਣੇ-ਆਪ ਰੀਨਿਊ ਹੋਣ ਵਾਲੀ • ਕਿਸੇ ਵੀ ਸਮੇਂ ਰੱਦ ਕਰੋ",
				"generic": "ਆਪਣੇ-ਆਪ ਰੀਨਿਊ ਹੋਣ ਵਾਲੀ ਸਬਸਕ੍ਰਿਪਸ਼ਨ • ਕਿਸੇ ਵੀ ਸਮੇਂ ਰੱਦ ਕਰੋ"
			},
			"planDuration": {
				"day_one": "{{count}} ਦਿਨ",
				"day_other": "{{count}} ਦਿਨ",
				"week_one": "{{count}} ਹਫ਼ਤਾ",
				"week_other": "{{count}} ਹਫ਼ਤੇ",
				"month_one": "{{count}} ਮਹੀਨਾ",
				"month_other": "{{count}} ਮਹੀਨੇ",
				"year_one": "{{count}} ਸਾਲ",
				"year_other": "{{count}} ਸਾਲ"
			},
			"recommendedPlan": {
				"plan": "ਅਸੀਂ ਤੁਹਾਡੇ **{{date}}** ਦੇ ਇਮਤਿਹਾਨ ਦੀ ਬਿਹਤਰੀਨ ਤਿਆਰੀ ਲਈ \"**{{duration}}**\" ਯੋਜਨਾ ਦੀ ਸਿਫਾਰਸ਼ ਕਰਦੇ ਹਾਂ",
				"subscription": {
					"yearly": "ਅਸੀਂ ਤੁਹਾਡੇ **{{date}}** ਦੇ ਇਮਤਿਹਾਨ ਲਈ ਨਿਰੰਤਰ ਪਹੁੰਚ ਅਤੇ ਤਿਆਰੀ ਲਈ **ਸਾਲਾਨਾ ਸਬਸਕ੍ਰਿਪਸ਼ਨ** ਦੀ ਸਿਫਾਰਸ਼ ਕਰਦੇ ਹਾਂ",
					"monthly": "ਅਸੀਂ ਤੁਹਾਡੇ **{{date}}** ਦੇ ਇਮਤਿਹਾਨ ਲਈ ਨਿਰੰਤਰ ਪਹੁੰਚ ਅਤੇ ਤਿਆਰੀ ਲਈ **ਮਹੀਨਾਵਾਰ ਸਬਸਕ੍ਰਿਪਸ਼ਨ** ਦੀ ਸਿਫਾਰਸ਼ ਕਰਦੇ ਹਾਂ",
					"weekly": "ਅਸੀਂ ਤੁਹਾਡੇ **{{date}}** ਦੇ ਇਮਤਿਹਾਨ ਲਈ ਨਿਰੰਤਰ ਪਹੁੰਚ ਅਤੇ ਤਿਆਰੀ ਲਈ **ਹਫ਼ਤਾਵਾਰ ਸਬਸਕ੍ਰਿਪਸ਼ਨ** ਦੀ ਸਿਫਾਰਸ਼ ਕਰਦੇ ਹਾਂ",
					"generic": "ਅਸੀਂ ਤੁਹਾਡੇ **{{date}}** ਦੇ ਇਮਤਿਹਾਨ ਲਈ ਨਿਰੰਤਰ ਪਹੁੰਚ ਅਤੇ ਤਿਆਰੀ ਲਈ **ਸਬਸਕ੍ਰਿਪਸ਼ਨ** ਦੀ ਸਿਫਾਰਸ਼ ਕਰਦੇ ਹਾਂ"
				}
			},
			"disclaimer": "ਖਰੀਦ ਦੀ ਪੁਸ਼ਟੀ ਹੋਣ 'ਤੇ ਤੁਹਾਨੂੰ ਚੁਣੀ ਗਈ ਮਿਆਦ ਲਈ ਇਸ ਉਤਪਾਦ ਦੀ ਸਮੱਗਰੀ ਤੱਕ ਪੂਰੀ ਪਹੁੰਚ ਦਿੱਤੀ ਜਾਵੇਗੀ। ਜਦੋਂ ਇਹ ਮਿਆਦ ਖ਼ਤਮ ਹੋ ਜਾਂਦੀ ਹੈ, ਤੁਸੀਂ ਪ੍ਰਤਿਬੰਧਿਤ ਸਮੱਗਰੀ ਤੱਕ ਪਹੁੰਚ ਗੁਆ ਦੇਵੋਗੇ। ਜੇ ਤੁਸੀਂ ਕਿਸੇ ਵੀ ਕਾਰਨ ਆਪਣੀ ਪਹੁੰਚ ਵਧਾਉਣੀ ਚਾਹੁੰਦੇ ਹੋ (ਜਿਵੇਂ ਕਿ ਤੁਸੀਂ ਆਪਣੀ ਟੈਸਟ ਦੀ ਤਾਰੀਖ ਬਦਲੀ), ਤਾਂ ਤੁਸੀਂ ਵਾਧੂ ਇਨ-ਐਪ ਖਰੀਦਾਂ ਰਾਹੀਂ ਸਮਾਂ ਜੋੜ ਸਕਦੇ ਹੋ। ਹੋਰ ਜਾਣਕਾਰੀ ਲਈ, ਸਾਡੀਆਂ [ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ ਅਤੇ ਪਰਦੇਦਾਰੀ ਨੀਤੀ](https://memorang.com/legal) ਵੇਖੋ।"
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "{{count}} {{type}} ਵਿੱਚ ਜਵਾਬ ਦਿੱਤੇ ਗਏ {{numItems}} {{item}} ਦੇ ਆਧਾਰ 'ਤੇ",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "ਇਹ {{count}} {{type}} ਵਿੱਚ ਤੁਹਾਡੀ ਪ੍ਰਗਤੀ ਦਿਖਾਉਂਦਾ ਹੈ। ਇਹ ਹੁਣ ਤੱਕ ਤੁਹਾਡੇ ਵੱਲੋਂ ਜਵਾਬ ਦਿੱਤੇ {{itemCount}} {{item}} 'ਤੇ ਆਧਾਰਿਤ ਹੈ।"
		},
		"needsImprovement": {
			"title": "ਸੁਧਾਰ ਲੋੜੀਂਦਾ",
			"subtitle": "ਤੁਹਾਡੇ ਸੁਧਾਰ ਲਈ ਸਿਫ਼ਾਰਸ਼ੀ {{type}}",
			"cta": "ਹੁਣੇ ਅਧਿਐਨ ਕਰੋ"
		},
		"mastery": {
			"high": "ਮਾਹਿਰ",
			"medium": "ਲਗਭਗ ਤਿਆਰ",
			"low": "ਸੁਧਾਰ ਲੋੜੀਂਦਾ",
			"count": "ਜਵਾਬ ਦਿੱਤੇ ਗਏ {{count}} {{item}}",
			"zeroTooltip": "{{total}} ਜਵਾਬ ਦਿੱਤੇ ਗਏ ਆਈਟਮਾਂ ਵਿੱਚੋਂ ਹਾਲੇ ਤੱਕ ਕੋਈ {{label}} ਆਈਟਮ ਨਹੀਂ",
			"highTooltip": "ਤੁਸੀਂ ਜਵਾਬ ਦਿੱਤੇ ਗਏ {{total}} {{item}} ਵਿੱਚੋਂ {{count}} ਵਿੱਚ ਮੁਹਾਰਤ ਹਾਸਲ ਕਰ ਲਈ ਹੈ",
			"mediumTooltip": "ਤੁਸੀਂ ਜਵਾਬ ਦਿੱਤੇ ਗਏ {{total}} {{item}} ਵਿੱਚੋਂ {{count}} 'ਤੇ ਪ੍ਰਗਤੀ ਕਰ ਰਹੇ ਹੋ",
			"lowTooltip": "ਤੁਹਾਨੂੰ ਜਵਾਬ ਦਿੱਤੇ ਗਏ {{total}} {{item}} ਵਿੱਚੋਂ {{count}} ਨਾਲ ਹੋਰ ਅਭਿਆਸ ਦੀ ਲੋੜ ਹੈ"
		},
		"stats": {
			"completion": "ਸੰਪੂਰਨਤਾ",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "ਤੁਸੀਂ {{total}} {{item}} ਵਿੱਚੋਂ {{completed}} ਪੂਰੇ ਕੀਤੇ ਹਨ"
		},
		"exams": {
			"title": "ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ",
			"subtitle_one": "{{count}} ਪੂਰੇ ਹੋਏ ਮੁਲਾਂਕਣ ਦੇ ਆਧਾਰ 'ਤੇ",
			"subtitle_other": "{{count}} ਪੂਰੇ ਹੋਏ ਮੁਲਾਂਕਣਾਂ ਦੇ ਆਧਾਰ 'ਤੇ"
		},
		"summary": {
			"title": "ਸਿੱਖਣ ਦਾ ਸੰਖੇਪ",
			"subtitle": "ਜਵਾਬ ਦਿੱਤੇ ਗਏ {{count}} {{item}} ਦੇ ਆਧਾਰ 'ਤੇ",
			"tooltip": "ਇਹ ਸੰਖੇਪ ਕੁੱਲ {{count}} {{item}} ਵਿੱਚ ਤੁਹਾਡੇ ਮੁਹਾਰਤ ਪੱਧਰ ਅਤੇ ਸੰਪੂਰਨਤਾ ਪ੍ਰਗਤੀ ਨੂੰ ਦਿਖਾਉਂਦਾ ਹੈ। ਤੁਹਾਡਾ ਪ੍ਰਦਰਸ਼ਨ ਅਧਿਐਨ ਸੈਸ਼ਨਾਂ, ਮੁਲਾਂਕਣਾਂ ਅਤੇ ਅਧਿਐਨ ਗਤੀਵਿਧੀਆਂ ਰਾਹੀਂ ਮਾਪਿਆ ਜਾਂਦਾ ਹੈ।",
			"mastery": "ਮੁਹਾਰਤ",
			"quickStats": "ਤੁਰੰਤ ਅੰਕੜੇ"
		},
		"languageLearning": {
			"proficiencyCardTitle": "{{skill}} ਨਿਪੁੰਨਤਾ",
			"proficiencyCardTooltip": "ਤੁਸੀਂ ਇਸ ਵੇਲੇ {{level, lowercase}} {{skill, lowercase}} ਪੱਧਰ 'ਤੇ ਪ੍ਰਦਰਸ਼ਨ ਕਰ ਰਹੇ ਹੋ",
			"itemTypesCardSubtitle_one": "{{count}} ਆਈਟਮ ਦੀ ਕਿਸਮ",
			"itemTypesCardSubtitle_other": "{{count}} ਆਈਟਮਾਂ ਦੀਆਂ ਕਿਸਮਾਂ",
			"itemTypesCardTitle": "{{skill}} ਆਈਟਮਾਂ",
			"itemTypeLevelTooltip": "ਤੁਸੀਂ ਇਸ ਵੇਲੇ “{{itemType}}” ਸਵਾਲਾਂ ਦੀਆਂ ਕਿਸਮਾਂ 'ਤੇ {{level, lowercase}} {{skill, lowercase}} ਪੱਧਰ 'ਤੇ ਪ੍ਰਦਰਸ਼ਨ ਕਰ ਰਹੇ ਹੋ",
			"itemTypesFallbackTitle": "ਆਈਟਮਾਂ ਦੀਆਂ ਕਿਸਮਾਂ",
			"itemTypesEmptyTitle": "ਆਈਟਮਾਂ ਦੀਆਂ ਕਿਸਮਾਂ ਉਪਲਬਧ ਨਹੀਂ",
			"itemTypesEmptySubtitle": "ਸਾਨੂੰ ਇਸ ਹੁਨਰ ਲਈ ਆਈਟਮਾਂ ਦੀਆਂ ਕਿਸਮਾਂ ਨਹੀਂ ਮਿਲੀਆਂ। ਪ੍ਰਗਤੀ 'ਤੇ ਵਾਪਸ ਜਾਓ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
			"itemTypesEmptyCta": "ਪ੍ਰਗਤੀ 'ਤੇ ਵਾਪਸ ਜਾਓ",
			"notAnswered": "ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ",
			"answeredSubtitle_one": "ਜਵਾਬ ਦਿੱਤੇ ਗਏ {{count}} ਆਈਟਮ ਦੇ ਆਧਾਰ 'ਤੇ",
			"answeredSubtitle_other": "ਜਵਾਬ ਦਿੱਤੇ ਗਏ {{count}} ਆਈਟਮਾਂ ਦੇ ਆਧਾਰ 'ਤੇ",
			"responsesSubtitle_one": "{{count}} ਪ੍ਰਤੀਕਿਰਿਆ ਦੇ ਆਧਾਰ 'ਤੇ",
			"responsesSubtitle_other": "{{count}} ਪ੍ਰਤੀਕਿਰਿਆਵਾਂ ਦੇ ਆਧਾਰ 'ਤੇ",
			"testsTakenSubtitle_one": "ਦਿੱਤੇ ਗਏ {{count}} ਟੈਸਟ ਦੇ ਆਧਾਰ 'ਤੇ",
			"testsTakenSubtitle_other": "ਦਿੱਤੇ ਗਏ {{count}} ਟੈਸਟਾਂ ਦੇ ਆਧਾਰ 'ਤੇ",
			"startFirstTest": {
				"title": "ਆਓ ਸ਼ੁਰੂ ਕਰੀਏ",
				"itemsSubtitle_one": "{{count}} ਆਈਟਮ",
				"itemsSubtitle_other": "{{count}} ਆਈਟਮਾਂ",
				"guidance": {
					"diagnostic": "ਆਪਣੀਆਂ ਤਾਕਤਾਂ ਲੱਭਣ ਅਤੇ ਆਪਣੀ ਅਧਿਐਨ ਯੋਜਨਾ ਨੂੰ ਅਨੁਕੂਲ ਬਣਾਉਣ ਲਈ ਇੱਕ ਡਾਇਗਨੌਸਟਿਕ ਨਾਲ ਸ਼ੁਰੂ ਕਰੋ।",
					"sectional": "ਸੈਕਸ਼ਨਲ ਟੈਸਟ ਇਮਤਿਹਾਨ ਦੇ ਇੱਕ ਹਿੱਸੇ 'ਤੇ ਧਿਆਨ ਕੇਂਦਰਿਤ ਕਰਦਾ ਹੈ, ਤਾਂ ਜੋ ਤੁਹਾਨੂੰ ਘੱਟ ਸਮੇਂ ਵਿੱਚ ਸਕੋਰ ਮਿਲੇ।",
					"fullMock": "ਪੂਰਾ ਮੌਕ ਟੈਸਟ ਅਸਲ ਇਮਤਿਹਾਨ ਨੂੰ ਪੂਰੀ ਤਰ੍ਹਾਂ ਦਰਸਾਉਂਦਾ ਹੈ ਅਤੇ ਤੁਹਾਨੂੰ ਸਭ ਤੋਂ ਸੰਪੂਰਨ ਸਕੋਰ ਦਿੰਦਾ ਹੈ।"
				}
			},
			"noScoresTitle": "ਹਾਲੇ ਤੱਕ ਕੋਈ {{skill, lowercase}} ਸਕੋਰ ਨਹੀਂ",
			"noScoresSubtitle": "ਆਪਣਾ ਅਨੁਮਾਨਿਤ ਸਕੋਰ ਅਤੇ ਕਾਰਜ ਵੇਰਵਾ ਵੇਖਣ ਲਈ ਆਪਣਾ ਪਹਿਲਾ ਟੈਸਟ ਲਓ।",
			"noScoresCta": "ਸ਼ੁਰੂ ਕਰੋ",
			"noScoresCardSubtitle": "ਤੁਸੀਂ ਜੋ ਟੈਸਟ ਦਿਓਗੇ ਉਨ੍ਹਾਂ ਦੇ ਆਧਾਰ 'ਤੇ",
			"personalBestLabel": "ਤੁਹਾਡਾ ਨਿੱਜੀ ਸਭ ਤੋਂ ਵਧੀਆ",
			"latestLabel": "ਤੁਹਾਡਾ ਨਵੀਨਤਮ",
			"examCountdown_one": "ਤੁਹਾਡਾ ਇਮਤਿਹਾਨ {{count}} ਦਿਨ ਵਿੱਚ ਹੈ",
			"examCountdown_other": "ਤੁਹਾਡਾ ਇਮਤਿਹਾਨ {{count}} ਦਿਨਾਂ ਵਿੱਚ ਹੈ",
			"greeting": {
				"none": "ਆਓ ਸ਼ੁਰੂ ਕਰੀਏ, {{firstName}}! 🚀",
				"low": "ਵਧੀਆ ਸ਼ੁਰੂਆਤ, {{firstName}} — ਜਾਰੀ ਰੱਖੋ! 💪",
				"medium": "ਇੰਝ ਹੀ ਜਾਰੀ ਰੱਖੋ, {{firstName}}! 💪",
				"high": "ਤੁਸੀਂ ਲਗਭਗ ਪਹੁੰਚ ਗਏ ਹੋ, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "ਆਓ ਸ਼ੁਰੂ ਕਰੀਏ! 🚀",
				"low": "ਵਧੀਆ ਸ਼ੁਰੂਆਤ — ਜਾਰੀ ਰੱਖੋ! 💪",
				"medium": "ਇੰਝ ਹੀ ਜਾਰੀ ਰੱਖੋ! 💪",
				"high": "ਤੁਸੀਂ ਲਗਭਗ ਪਹੁੰਚ ਗਏ ਹੋ! 🎯"
			},
			"stats": {
				"untilExam": "ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ",
				"itemsAnswered": "ਜਵਾਬ ਦਿੱਤੀਆਂ ਆਈਟਮਾਂ",
				"responsesAnswered": "ਪ੍ਰਤੀਕਿਰਿਆਵਾਂ"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "ਗਲਤ ਪਾਸਕੋਡ",
		"incorrectPassword": "ਗਲਤ ਪਾਸਵਰਡ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
		"passwordPlaceholder": "ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ",
		"emailPlaceholder": "ਜਿਵੇਂ, dave@gmail.com",
		"verify": {
			"openEmail": "ਜਾਰੀ ਰੱਖਣ ਲਈ ਈਮੇਲ ਖੋਲ੍ਹੋ",
			"signInCta": "ਤੁਹਾਡਾ ਖਾਤਾ ਪ੍ਰਮਾਣਿਤ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
			"signUpCta": "ਤੁਹਾਡਾ ਖਾਤਾ ਬਣਾਇਆ ਜਾ ਰਿਹਾ ਹੈ...",
			"contactSupport": "ਈਮੇਲ ਨਹੀਂ ਦਿਖ ਰਹੀ? ਆਪਣਾ ਸਪੈਮ ਫੋਲਡਰ ਚੈੱਕ ਕਰੋ ਜਾਂ",
			"contactSupportLink": "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
			"resendMagicLink": "ਮੈਜਿਕ ਲਿੰਕ ਦੁਬਾਰਾ ਭੇਜੋ",
			"resendMagicLinkIn": "{{time}} ਵਿੱਚ ਮੈਜਿਕ ਲਿੰਕ ਦੁਬਾਰਾ ਭੇਜੋ",
			"signInBody": "ਤੁਸੀਂ ਲਗਭਗ ਪਹੁੰਚ ਗਏ ਹੋ! {{appName}} ਐਪ ਵਿੱਚ ਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਸਾਈਨ ਇਨ ਕਰਨ ਲਈ ਤੁਹਾਡੇ ਵੇਰਵਿਆਂ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ।",
			"signUpBody": "ਲਗਭਗ ਹੋ ਗਿਆ! ਤੁਹਾਡਾ ਨਵਾਂ {{appName}} ਐਪ ਖਾਤਾ ਬਣਾਉਣ ਲਈ ਅਸੀਂ ਤੁਹਾਡੇ ਵੇਰਵਿਆਂ ਦੀ ਪੁਸ਼ਟੀ ਕਰ ਰਹੇ ਹਾਂ।",
			"magicLinkEmail": "ਅਸੀਂ **{{email}}** 'ਤੇ ਇੱਕ ਮੈਜਿਕ ਲਿੰਕ ਭੇਜਿਆ ਹੈ\nਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਸਾਈਨ ਇਨ ਕਰਨ ਲਈ ਆਪਣੀ ਈਮੇਲ ਵਿੱਚ ਦਿੱਤੇ ਲਿੰਕ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
			"magicLinkEmailExpiry": "ਇਹ ਲਿੰਕ 10 ਮਿੰਟਾਂ ਵਿੱਚ ਸਮਾਪਤ ਹੋ ਜਾਂਦਾ ਹੈ",
			"confirmEmail": "ਆਪਣੀ ਈਮੇਲ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
			"redirectingToApp": "{{appName}} ਐਪ ਵੱਲ ਰੀਡਾਇਰੈਕਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
			"appNotOpen": "ਐਪ ਨਹੀਂ ਖੁੱਲ੍ਹੀ? ਸੰਬੰਧਿਤ ਐਪਲੀਕੇਸ਼ਨ ਖੋਲ੍ਹਣ ਲਈ ਹੇਠਾਂ ਦਿੱਤੇ ਬਟਨ 'ਤੇ ਕਲਿੱਕ ਕਰੋ",
			"openApp": "{{appName}} ਐਪ ਖੋਲ੍ਹੋ",
			"installAppPrompt": "ਜੇ ਕੁਝ ਨਹੀਂ ਹੁੰਦਾ, ਤਾਂ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਹਾਡੀ ਡਿਵਾਈਸ 'ਤੇ {{appName}} ਐਪ ਇੰਸਟੌਲ ਹੈ",
			"verifyAccountTitle": "ਆਪਣੇ ਖਾਤੇ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
			"emailResent": "ਮੈਜਿਕ ਲਿੰਕ {{email}} 'ਤੇ ਭੇਜਿਆ ਗਿਆ\nਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਇਨਬਾਕਸ ਚੈੱਕ ਕਰੋ, ਸਪੈਮ ਸਮੇਤ।",
			"verificationLinkExpired": "ਪੁਸ਼ਟੀਕਰਨ ਲਿੰਕ ਸਮਾਪਤ ਹੋ ਗਿਆ",
			"verificationLinkExpiredBody": "ਪੁਸ਼ਟੀਕਰਨ ਲਿੰਕ 10 ਮਿੰਟਾਂ ਬਾਅਦ ਸਮਾਪਤ ਹੋ ਜਾਂਦੇ ਹਨ ਅਤੇ ਸਿਰਫ਼ ਇੱਕ ਵਾਰ ਵਰਤੇ ਜਾ ਸਕਦੇ ਹਨ। \nਤੁਸੀਂ ਦੁਬਾਰਾ ਲੌਗ ਇਨ ਕਰਕੇ ਨਵਾਂ ਲਿੰਕ ਮੰਗਵਾ ਸਕਦੇ ਹੋ",
			"accountSetupTimeoutTitle": "ਸਾਈਨ ਇਨ ਪੂਰਾ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ",
			"accountSetupTimeoutBody": "ਤੁਹਾਡੇ ਖਾਤੇ ਨੂੰ ਸੈੱਟ ਅੱਪ ਹੋਣ ਵਿੱਚ ਉਮੀਦ ਨਾਲੋਂ ਵੱਧ ਸਮਾਂ ਲੱਗ ਰਿਹਾ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਲੌਗ ਇਨ ਕਰਨ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਜੇ ਇਹ ਜਾਰੀ ਰਹੇ ਤਾਂ ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
			"loginAgain": "ਦੁਬਾਰਾ ਲੌਗ ਇਨ ਕਰੋ",
			"contactSupportExpiredLink": "ਜੇ ਇਹ ਸਮੱਸਿਆ ਜਾਰੀ ਰਹੇ, ਤਾਂ ਸਾਨੂੰ ਦੱਸੋ",
			"successTitle": "ਤੁਸੀਂ ਹੁਣ ਇੱਕ ਹੋਰ ਟੈਬ 'ਤੇ ਸਾਈਨ ਇਨ ਹੋ ਗਏ ਹੋ",
			"successBody": "ਇਸ ਟੈਬ ਨੂੰ ਬੰਦ ਕਰੋ ਜਾਂ ਇੱਥੋਂ ਜਾਰੀ ਰੱਖੋ",
			"successCtaLabel": "ਇੱਥੇ ਜਾਰੀ ਰੱਖੋ",
			"needHelpLabel": "ਮਦਦ ਚਾਹੀਦੀ ਹੈ?",
			"contactSupportButton": "ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ"
		},
		"contactSupportDialog": {
			"title": "ਲੌਗ ਇਨ ਕਰਨ ਵਿੱਚ ਮੁਸ਼ਕਲ?",
			"body": "ਜੇ ਤੁਹਾਨੂੰ ਲੌਗ ਇਨ ਕਰਨ ਵਿੱਚ ਮੁਸ਼ਕਲ ਆ ਰਹੀ ਹੈ ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੀ ਗਾਹਕ ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ ਜਾਂ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
			"cta": "ਸਾਨੂੰ ਈਮੇਲ ਕਰੋ"
		},
		"emailInstruction": {
			"default": "ਜੇ ਤੁਹਾਨੂੰ ਈਮੇਲ ਨਹੀਂ ਮਿਲਦੀ, ਤਾਂ ਆਪਣੇ ਜੰਕ, ਸਪੈਮ, ਅਤੇ ਹਾਲ ਹੀ ਵਿੱਚ ਮਿਟਾਏ ਗਏ ਫੋਲਡਰ ਚੈੱਕ ਕਰੋ",
			"edu": "ਜੇ ਤੁਹਾਨੂੰ ਈਮੇਲ ਨਹੀਂ ਮਿਲਦੀ, ਤਾਂ ਆਪਣੇ ਜੰਕ, ਸਪੈਮ, ਅਤੇ ਹਾਲ ਹੀ ਵਿੱਚ ਮਿਟਾਏ ਗਏ ਫੋਲਡਰ ਚੈੱਕ ਕਰੋ, ਜਾਂ ਆਪਣੇ IT ਪ੍ਰਸ਼ਾਸਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ"
		},
		"createSessionLoader": {
			"configuringSession": "ਸੈਸ਼ਨ ਕੌਂਫਿਗਰ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ",
			"analyzingMastery": "ਮੁਹਾਰਤ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ",
			"loadingContent": "ਸਮੱਗਰੀ ਲੋਡ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "ਅਸੀਂ ਤੁਹਾਨੂੰ ਕੀ ਕਹੀਏ?",
				"description": "ਤੁਹਾਡਾ ਯੂਜ਼ਰਨੇਮ ਜਨਤਕ ਲੀਡਰਬੋਰਡਾਂ 'ਤੇ ਦਿਖਾਈ ਦਿੰਦਾ ਹੈ ਜਦਕਿ ਤੁਹਾਡਾ ਨਾਮ ਨਿੱਜੀ ਰਹਿੰਦਾ ਹੈ।",
				"usernameLabel": "ਯੂਜ਼ਰਨੇਮ",
				"firstNameLabel": "ਪਹਿਲਾ ਨਾਮ",
				"lastNameLabel": "ਆਖਰੀ ਨਾਮ",
				"avatarLabel": "ਅਵਤਾਰ",
				"avatarTooltip": "ਅਵਤਾਰ ਤੁਹਾਡੇ ਯੂਜ਼ਰਨੇਮ ਦੇ ਆਧਾਰ 'ਤੇ ਆਪਣੇ-ਆਪ ਤਿਆਰ ਹੁੰਦੇ ਹਨ।",
				"profileSaveFailed": "ਅਸੀਂ ਤੁਹਾਡਾ ਪ੍ਰੋਫ਼ਾਈਲ ਸੇਵ ਨਹੀਂ ਕਰ ਸਕੇ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।"
			},
			"testDate": {
				"cta": "ਜਾਰੀ ਰੱਖੋ"
			},
			"examDate": {
				"daysAway": "ਇਹ ਸਾਨੂੰ {{value}} ਦਿਨ ਦਿੰਦਾ ਹੈ। ਅਸੀਂ ਤੁਰੰਤ ਤੁਹਾਡੇ ਸਭ ਤੋਂ ਕਮਜ਼ੋਰ ਖੇਤਰਾਂ ਨੂੰ ਪਹਿਲ ਦੇਵਾਂਗੇ।"
			},
			"skills": {
				"chooseAll": "ਜੋ ਵੀ ਲਾਗੂ ਹੋਵੇ ਸਭ ਚੁਣੋ"
			},
			"plan": {
				"recommended": "ਸਿਫ਼ਾਰਸ਼ੀ"
			},
			"toeicLevelOverview": {
				"title": "ਹਰ ਕੋਈ ਕਿਤੋਂ ਨਾ ਕਿਤੋਂ ਸ਼ੁਰੂ ਕਰਦਾ ਹੈ।",
				"description": "ਅਭਿਆਸ ਤੁਹਾਨੂੰ ਅਗਲੇ ਪੱਧਰ ਵਿੱਚ ਕੁਦਰਤੀ ਢੰਗ ਨਾਲ ਵਧਣ ਤੋਂ ਪਹਿਲਾਂ ਇੱਕ ਪੱਧਰ 'ਤੇ ਮੁਹਾਰਤ ਬਣਾਉਣ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ।",
				"illustrationLabel": "ਬੇਸਿਕ (A1–A2) ਤੋਂ ਇੰਟਰਮੀਡੀਏਟ (B1–B2) ਤੋਂ ਪ੍ਰੋਫੀਸ਼ੀਐਂਟ (C1) ਤੱਕ ਦੀ ਪ੍ਰਗਤੀ।",
				"levels": {
					"basic": {
						"name": "ਬੇਸਿਕ",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "ਇੰਟਰਮੀਡੀਏਟ",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "ਪ੍ਰੋਫੀਸ਼ੀਐਂਟ",
						"band": "C1"
					}
				},
				"progression": {
					"title": "ਤੁਸੀਂ ਕਿਵੇਂ ਅੱਗੇ ਵਧੋਗੇ",
					"practiceSessions": "ਸਿਫ਼ਾਰਸ਼ੀ ਸੈਸ਼ਨਾਂ ਦਾ ਅਭਿਆਸ ਕਰੋ",
					"buildMastery": "ਆਪਣੇ ਮੌਜੂਦਾ ਪੱਧਰ 'ਤੇ ਮੁਹਾਰਤ ਬਣਾਓ",
					"growToward": "ਪ੍ਰੋਫੀਸ਼ੀਐਂਟ ਵੱਲ ਵਧਦੇ ਰਹੋ"
				},
				"levelDetails": {
					"title": "ਹਰੇਕ ਪੱਧਰ ਦਾ ਕੀ ਮਤਲਬ ਹੈ",
					"scoreRange": "{{band}} · ਸਕੋਰ {{min}}–{{max}}",
					"basic": {
						"name": "ਬੇਸਿਕ ਯੂਜ਼ਰ",
						"summary": "ਕੰਮ ਵਾਲੀ ਥਾਂ ਦੀ ਸਾਧਾਰਨ ਅੰਗਰੇਜ਼ੀ",
						"examples": {
							"forms": "ਫਾਰਮ ਅਤੇ ਸੂਚਨਾਵਾਂ",
							"instructions": "ਹਦਾਇਤਾਂ",
							"announcements": "ਛੋਟੇ ਐਲਾਨ"
						}
					},
					"intermediate": {
						"name": "ਇੰਟਰਮੀਡੀਏਟ ਯੂਜ਼ਰ",
						"summary": "ਰੋਜ਼ਾਨਾ ਕੰਮ ਵਾਲੀ ਥਾਂ ਦਾ ਸੰਚਾਰ",
						"examples": {
							"emails": "ਈਮੇਲਾਂ ਅਤੇ ਗੱਲਬਾਤ",
							"customers": "ਗਾਹਕਾਂ ਨਾਲ ਗੱਲਬਾਤ",
							"followUps": "ਮੀਟਿੰਗ ਫਾਲੋ-ਅੱਪ"
						}
					},
					"proficient": {
						"name": "ਪ੍ਰੋਫੀਸ਼ੀਐਂਟ ਯੂਜ਼ਰ",
						"summary": "ਪੇਸ਼ੇਵਰ ਅਤੇ ਐਡਵਾਂਸਡ ਅੰਗਰੇਜ਼ੀ",
						"examples": {
							"reports": "ਗੁੰਝਲਦਾਰ ਰਿਪੋਰਟਾਂ ਅਤੇ ਪੇਸ਼ਕਾਰੀਆਂ",
							"negotiations": "ਸੂਖਮ ਸੌਦੇਬਾਜ਼ੀ",
							"highStakes": "ਉੱਚ-ਦਾਅ ਵਾਲੇ ਪੇਸ਼ੇਵਰ ਸੰਦਰਭ"
						}
					}
				},
				"disclaimer": "TOEIC Link ਸਕੋਰ CEFR-ਅਧਾਰਿਤ ਦਿਸ਼ਾ-ਨਿਰਦੇਸ਼ ਹਨ, ਨਾ ਕਿ ਪੂਰਨ ਕੱਟ-ਆਫ ਸਕੋਰ। ਰੀਡਿੰਗ ਅਤੇ ਲਿਸਨਿੰਗ ਸੁਤੰਤਰ ਤੌਰ 'ਤੇ ਅੱਗੇ ਵਧਦੇ ਹਨ — ਤੁਸੀਂ ਹਰੇਕ ਹੁਨਰ ਵਿੱਚ ਵੱਖ-ਵੱਖ ਪੱਧਰਾਂ 'ਤੇ ਪਹੁੰਚ ਸਕਦੇ ਹੋ।"
			},
			"review": {
				"diagnosticChoice": {
					"title": "ਡਾਇਗਨੌਸਟਿਕ: {{title}}",
					"body": "ਧਿਆਨ ਕੇਂਦਰਿਤ ਕਰਨ ਵਾਲੀ ਥਾਂ ਲੱਭਣ ਲਈ {{count}} ਆਈਟਮਾਂ",
					"duration": "{{minutes}} ਮਿੰਟ"
				},
				"homeChoice": {
					"title": "ਖ਼ੁਦ ਪੜਚੋਲ ਕਰਾਂ",
					"body": "ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਤਿਆਰ ਨਹੀਂ, ਪਹਿਲਾਂ ਐਪ ਦੀ ਪੜਚੋਲ ਕਰਾਂ"
				}
			}
		},
		"common": {
			"changeLater": "ਤੁਸੀਂ ਇਸਨੂੰ ਬਾਅਦ ਵਿੱਚ ਬਦਲ ਸਕਦੇ ਹੋ"
		},
		"actions": {
			"previous": "ਪਿਛਲਾ",
			"finish": "ਪੂਰਾ ਕਰੋ",
			"start": "ਸ਼ੁਰੂ ਕਰੋ",
			"continue": "ਜਾਰੀ ਰੱਖੋ",
			"stepIndicator": "{{total}} ਵਿੱਚੋਂ ਪੜਾਅ {{step}}"
		}
	},
	"more": {
		"profile": {
			"title": "ਤੁਹਾਡੇ ਬਾਰੇ"
		},
		"exam": {
			"title": "ਤੁਹਾਡਾ ਇਮਤਿਹਾਨ"
		},
		"subscriptions": {
			"title": "ਉਤਪਾਦ",
			"redeem": {
				"title": "ਖਰੀਦ ਰਿਡੀਮ ਕਰੋ"
			},
			"extend": {
				"cta": "ਵਧਾਓ"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "ਆਪਣੀ ਟੀਚਾ ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ ਸੈੱਟ ਕਰੋ",
			"description": "ਇਹ ਤਾਰੀਖ ਸਿਰਫ਼ ਐਪ ਦੇ ਅੰਦਰ ਤੁਹਾਡੇ ਅਧਿਐਨ ਸ਼ਡਿਊਲ ਦੀ ਅਗਵਾਈ ਕਰਨ ਲਈ ਹੈ। ਇਹ ਤੁਹਾਡੀ ਅਧਿਕਾਰਤ ਇਮਤਿਹਾਨ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਨਹੀਂ ਕਰਦੀ।",
			"dismissCta": "ਹੁਣੇ ਨਹੀਂ",
			"confirmCta": "ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ ਸੈੱਟ ਕਰੋ"
		}
	},
	"account": {
		"title": "ਖਾਤਾ ਸੈਟਿੰਗਾਂ",
		"currentExam": "ਮੌਜੂਦਾ ਇਮਤਿਹਾਨ",
		"subscriptions": "ਉਤਪਾਦ",
		"examDate": "ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ",
		"examDateUpdated": "ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ {{date}} 'ਤੇ ਸੈੱਟ ਕੀਤੀ ਗਈ",
		"selectDate": "ਤਾਰੀਖ ਚੁਣੋ",
		"appearance": "ਦਿੱਖ",
		"features": "ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ",
		"audioPlaybackTest": "ਟੈਸਟ ਆਡੀਓ ਪਲੇਬੈਕ ਡਾਇਲਾਗ ਵਿਖਾਓ",
		"theme": "ਥੀਮ",
		"selectTheme": "ਥੀਮ ਚੁਣੋ",
		"themeOptions": {
			"system": "ਸਿਸਟਮ",
			"light": "ਲਾਈਟ",
			"dark": "ਡਾਰਕ"
		},
		"accountInfo": "ਖਾਤਾ",
		"username": "ਯੂਜ਼ਰਨੇਮ",
		"name": "ਨਾਮ",
		"nameNotSet": "ਸੈੱਟ ਨਹੀਂ ਹੈ",
		"save": "ਸੇਵ ਕਰੋ",
		"editUsername": {
			"title": "ਯੂਜ਼ਰਨੇਮ ਸੋਧੋ"
		},
		"editName": {
			"title": "ਨਾਮ ਸੋਧੋ"
		},
		"email": "ਈਮੇਲ",
		"dev": "ਡਿਵੈਲਪਰ",
		"sandbox": "ਸੈਂਡਬਾਕਸ",
		"redoOnboarding": "ਔਨਬੋਰਡਿੰਗ ਦੁਬਾਰਾ ਕਰੋ",
		"about": "ਇਸ ਬਾਰੇ",
		"termsOfService": "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ",
		"privacyPolicy": "ਪਰਦੇਦਾਰੀ ਨੀਤੀ",
		"aiToolsTos": "AI ਟੂਲਸ ਵਰਤੋਂ ਦੀਆਂ ਸ਼ਰਤਾਂ",
		"support": "ਸਹਾਇਤਾ",
		"supportEmailBody": "ਮੈਂ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰ ਰਿਹਾ/ਰਹੀ ਹਾਂ ਕਿਉਂਕਿ ਮੈਨੂੰ [  ] ਵਿੱਚ ਸਹਾਇਤਾ ਦੀ ਲੋੜ ਹੈ\n\n\n\nਚੀਜ਼ਾਂ ਨੂੰ ਜਲਦੀ ਹੱਲ ਕਰਨ ਵਿੱਚ ਮਦਦ ਲਈ ਇੱਥੇ ਕੁਝ ਸਹਾਇਕ ਜਾਣਕਾਰੀ ਹੈ: \n\nਖਾਤੇ ਨਾਲ ਸੰਬੰਧਿਤ ਯੂਜ਼ਰਨੇਮ (ਐਪ ਵਿੱਚ ਲੌਗ ਇਨ ਹੋਣ 'ਤੇ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਮਿਲਦਾ ਹੈ):\n{{username}}\n\nਮੇਰੇ ਆਰਡਰ ਨਾਲ ਸੰਬੰਧਿਤ ਈਮੇਲ (ਐਪ ਵਿੱਚ ਲੌਗ ਇਨ ਹੋਣ 'ਤੇ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਮਿਲਦੀ ਹੈ):\n{{email}}\n\nਆਰਡਰ ਨੰਬਰ (ਆਮ ਤੌਰ 'ਤੇ ਖਰੀਦ ਸਮੇਂ ਭੇਜੀ ਗਈ ਰਸੀਦ ਈਮੇਲ ਵਿੱਚ ਮਿਲਦਾ ਹੈ):\n\nਕੀ ਇਹ ਸੰਭਵ ਹੈ ਕਿ ਉਤਪਾਦ ਖਰੀਦਣ ਵੇਲੇ ਕੋਈ ਵੱਖਰਾ ਨਾਮ ਜਾਂ ਈਮੇਲ ਵਰਤਿਆ ਗਿਆ ਹੋਵੇ? ਜੇ ਹਾਂ ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਉਹ ਦੱਸੋ:\n\nਪਹਿਲਾ ਅਤੇ ਆਖਰੀ ਨਾਮ:\n\nਈਮੇਲ:",
		"contactSupport": "ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
		"signOut": "ਸਾਈਨ ਆਊਟ ਕਰੋ",
		"signOutConfirmation": "ਕੀ ਤੁਸੀਂ ਯਕੀਨਨ ਸਾਈਨ ਆਊਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
		"deleteAccount": "ਖਾਤਾ ਮਿਟਾਓ",
		"platform": "ਪਲੇਟਫਾਰਮ",
		"partnerships": "ਭਾਈਵਾਲੀ",
		"validUntil": "{{date}} ਨੂੰ ਸਮਾਪਤ ਹੁੰਦਾ ਹੈ",
		"extendValidity": "ਪਹੁੰਚ ਵਧਾਓ",
		"redeemPurchase": "ਖਰੀਦ ਰਿਡੀਮ ਕਰੋ",
		"redeemPurchaseNoneFound": "ਰਿਡੀਮ ਕਰਨ ਲਈ ਕੋਈ ਖਰੀਦ ਉਪਲਬਧ ਨਹੀਂ",
		"redeemPurchaseCheckFailed": "ਖਰੀਦਾਂ ਦੀ ਜਾਂਚ ਨਹੀਂ ਹੋ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
		"purchases": "ਖਰੀਦਾਂ",
		"frequentlyAskedQuestions": "ਅਕਸਰ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲ",
		"deleteFeedbackForm": {
			"placeholder": "ਫ਼ੀਡਬੈਕ"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "ਹੋਰ ਡਾਟਾ ਦੀ ਲੋੜ ਹੈ",
		"proficiencyLevelPendingTooltip": "ਆਪਣੇ ਪੱਧਰ ਦਾ ਅੰਦਾਜ਼ਾ ਲਗਾਉਣ ਲਈ ਹੋਰ {{label}} ਆਈਟਮਾਂ ਦੇ ਜਵਾਬ ਦਿਓ",
		"on": "ਨੂੰ",
		"gotIt": "ਸਮਝ ਗਏ",
		"goBack": "ਵਾਪਸ ਜਾਓ",
		"topic": "ਵਿਸ਼ਾ",
		"itemCount_one": "{{count, number}} ਆਈਟਮ",
		"itemCount_other": "{{count, number}} ਆਈਟਮਾਂ",
		"examCount_one": "{{count}} ਇਮਤਿਹਾਨ",
		"examCount_other": "{{count}} ਇਮਤਿਹਾਨ",
		"questionCount_one": "{{count}} ਸਵਾਲ",
		"questionCount_other": "{{count}} ਸਵਾਲ",
		"item_one": "ਆਈਟਮ",
		"item_other": "ਆਈਟਮਾਂ",
		"and": "ਅਤੇ",
		"this": "ਇਹ",
		"of": "ਦਾ",
		"knowMore": "ਹੋਰ ਜਾਣੋ",
		"proficiency": "ਨਿਪੁੰਨਤਾ",
		"didNotAnswer": "ਆਈਟਮਾਂ ਜਿਨ੍ਹਾਂ ਦਾ ਤੁਸੀਂ ਹਾਲੇ ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ",
		"notAnswered": "ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ",
		"attempted": "ਕੋਸ਼ਿਸ਼ ਕੀਤੀ",
		"attempt": "ਕੋਸ਼ਿਸ਼",
		"activity": "ਗਤੀਵਿਧੀ",
		"performance": "ਪ੍ਰਦਰਸ਼ਨ",
		"estimatedProficiency": "ਅਨੁਮਾਨਿਤ ਨਿਪੁੰਨਤਾ",
		"details": "ਵੇਰਵੇ",
		"keepPracticing": "ਅਭਿਆਸ ਜਾਰੀ ਰੱਖੋ!",
		"leaveFeedback": "ਫ਼ੀਡਬੈਕ ਦਿਓ",
		"copiedToClipboard": "ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਕੀਤਾ",
		"eg": "ਜਿਵੇਂ",
		"set": "ਸੈੱਟ",
		"hint": "ਸੰਕੇਤ",
		"itemType": "ਆਈਟਮ ਦੀ ਕਿਸਮ",
		"minute": "ਮਿੰਟ",
		"minutes": "{{count}} ਮਿੰਟ",
		"hour": "ਘੰਟਾ",
		"hours": "{{count}} ਘੰਟੇ",
		"continue": "ਜਾਰੀ ਰੱਖੋ",
		"unlock": "ਅਨਲੌਕ ਕਰੋ",
		"cancel": "ਰੱਦ ਕਰੋ",
		"view": "ਵੇਖੋ",
		"switch": "ਬਦਲੋ",
		"update": "ਅੱਪਡੇਟ ਕਰੋ",
		"ok": "ਠੀਕ ਹੈ",
		"yes": "ਹਾਂ",
		"free": "ਮੁਫ਼ਤ",
		"answered": "ਜਵਾਬ ਦਿੱਤਾ ਗਿਆ",
		"correct": "ਸਹੀ",
		"incorrect": "ਗਲਤ",
		"marked": "ਨਿਸ਼ਾਨਬੱਧ",
		"unmarked": "ਨਿਸ਼ਾਨਬੱਧ ਨਹੀਂ",
		"skipped": "ਛੱਡਿਆ ਗਿਆ",
		"skill_one": "ਹੁਨਰ",
		"skill_other": "ਹੁਨਰ",
		"word_one": "ਸ਼ਬਦ",
		"word_other": "ਸ਼ਬਦ",
		"submitResponse": "ਪ੍ਰਤੀਕਿਰਿਆ ਜਮ੍ਹਾਂ ਕਰੋ",
		"viewDetails": "ਵੇਰਵੇ ਵੇਖੋ",
		"sec_one": "ਸਕਿੰਟ",
		"sec_other": "ਸਕਿੰਟ",
		"point_one": "ਅੰਕ",
		"point_other": "ਅੰਕ",
		"week": "ਹਫ਼ਤਾ",
		"month": "ਮਹੀਨਾ",
		"year": "ਸਾਲ",
		"day": "ਦਿਨ",
		"selectTestDate": "ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ ਚੁਣੋ",
		"points": "ਅੰਕ",
		"viewAll": "ਸਭ ਵੇਖੋ",
		"timeline": "ਸਮਾਂਰੇਖਾ",
		"save": "ਸੇਵ ਕਰੋ",
		"filters": {
			"selectAll": "ਸਭ ਚੁਣੋ",
			"deselectAll": "ਸਾਰੀ ਚੋਣ ਹਟਾਓ",
			"selectedCount": "{{count}} ਚੁਣੇ ਗਏ",
			"expandSection": "{{section}} ਨੂੰ ਫੈਲਾਓ",
			"collapseSection": "{{section}} ਨੂੰ ਸਮੇਟੋ"
		},
		"showMore": "ਹੋਰ ਵੇਖੋ",
		"showLess": "ਘੱਟ ਵੇਖੋ",
		"expandA11yLabel": "ਵੇਰਵਾ ਫੈਲਾਓ",
		"collapseA11yLabel": "ਵੇਰਵਾ ਸਮੇਟੋ",
		"done": "ਹੋ ਗਿਆ",
		"clearAll": "ਸਭ ਸਾਫ਼ ਕਰੋ",
		"clear": "ਸਾਫ਼ ਕਰੋ",
		"datePicker": {
			"title": "ਤਾਰੀਖ ਚੁਣੋ",
			"enterDateLabel": "ਤਾਰੀਖ ਦਰਜ ਕਰੋ",
			"enterDateRangeLabel": "ਤਾਰੀਖਾਂ ਦਰਜ ਕਰੋ",
			"dateLabel": "ਤਾਰੀਖ",
			"startDateLabel": "ਸ਼ੁਰੂਆਤੀ ਤਾਰੀਖ",
			"endDateLabel": "ਸਮਾਪਤੀ ਤਾਰੀਖ",
			"dateRequiredError": "ਤਾਰੀਖ ਲੋੜੀਂਦੀ ਹੈ",
			"invalidDateFormatError": "ਗਲਤ ਤਾਰੀਖ ਫਾਰਮੈਟ। ਕਿਰਪਾ ਕਰਕੇ MM/DD/YYYY ਵਰਤੋ।",
			"startAfterEndError": "ਸ਼ੁਰੂਆਤੀ ਤਾਰੀਖ ਸਮਾਪਤੀ ਤਾਰੀਖ ਤੋਂ ਬਾਅਦ ਨਹੀਂ ਹੋ ਸਕਦੀ।",
			"endBeforeStartError": "ਸਮਾਪਤੀ ਤਾਰੀਖ ਸ਼ੁਰੂਆਤੀ ਤਾਰੀਖ ਤੋਂ ਪਹਿਲਾਂ ਨਹੀਂ ਹੋ ਸਕਦੀ।",
			"minDateError": "ਤਾਰੀਖ {{date}} ਜਾਂ ਉਸ ਤੋਂ ਬਾਅਦ ਦੀ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ।",
			"maxDateError": "ਤਾਰੀਖ {{date}} ਜਾਂ ਉਸ ਤੋਂ ਪਹਿਲਾਂ ਦੀ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ।",
			"dateRangeError": "ਤਾਰੀਖ {{startDate}} ਅਤੇ {{endDate}} ਦੇ ਵਿਚਕਾਰ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ।",
			"setDateCta": "ਤਾਰੀਖ ਸੈੱਟ ਕਰੋ",
			"nextCta": "ਅਗਲਾ",
			"setTimeCta": "ਸਮਾਂ ਸੈੱਟ ਕਰੋ"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}} ਸਿਖਿਆਰਥੀਆਂ ਨੇ ਇਹ ਜਵਾਬ ਚੁਣਿਆ।",
		"choiceCorrectA11yLabel": "ਸਹੀ ਜਵਾਬ",
		"choiceIncorrectA11yLabel": "ਗਲਤ ਜਵਾਬ",
		"choiceNotSelectedA11yLabel": "ਨਹੀਂ ਚੁਣਿਆ ਗਿਆ",
		"moreItemsAlertDialog": {
			"title": "ਵਾਧੂ ਆਈਟਮਾਂ",
			"cta": "ਸਮਝ ਗਏ"
		},
		"results": {
			"followUps": {
				"title": "ਫਾਲੋ-ਅੱਪ"
			},
			"summary": {
				"sessionAnalysis": "ਸੈਸ਼ਨ ਵਿਸ਼ਲੇਸ਼ਣ",
				"itemCount_one": "{{count}} ਆਈਟਮ",
				"itemCount_other": "{{count}} ਆਈਟਮਾਂ",
				"skilledItemCount_one": "{{count}} {{skills}} ਆਈਟਮ",
				"skilledItemCount_other": "{{count}} {{skills}} ਆਈਟਮਾਂ",
				"levelPhrase_one": "{{levels}} ਪੱਧਰ ਤੋਂ",
				"levelPhrase_other": "{{levels}} ਪੱਧਰਾਂ ਤੋਂ",
				"message": "<bold>ਵਧੀਆ ਕੰਮ!</bold> ਤੁਸੀਂ ਹੁਣੇ {{timeTaken}} ਵਿੱਚ {{itemPhrase}} ਪੂਰੇ ਕੀਤੇ ਹਨ।",
				"messageWithLevels": "<bold>ਵਧੀਆ ਕੰਮ!</bold> ਤੁਸੀਂ ਹੁਣੇ {{timeTaken}} ਵਿੱਚ {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) ਪੂਰੇ ਕੀਤੇ ਹਨ।",
				"proficiencyEstimateReady": "ਤੁਹਾਡਾ ਅਨੁਮਾਨਿਤ {{skill}} ਪੱਧਰ <bold>{{currentLevel}}</bold> ਹੈ। ਹੁਣ ਤੁਸੀਂ <bold>{{nextLevel}}</bold> ਨੂੰ ਟੀਚਾ ਬਣਾਉਣ ਲਈ ਤਿਆਰ ਹੋ।",
				"proficiencyEstimateKeepPracticing": "ਤੁਹਾਡਾ ਅਨੁਮਾਨਿਤ {{skill}} ਪੱਧਰ <bold>{{currentLevel}}</bold> ਹੈ। <bold>{{nextLevel}}</bold> 'ਤੇ ਜਾਣ ਤੋਂ ਪਹਿਲਾਂ ਅਭਿਆਸ ਜਾਰੀ ਰੱਖੋ।",
				"proficiencyEstimateHighest": "ਤੁਹਾਡਾ ਅਨੁਮਾਨਿਤ {{skill}} ਪੱਧਰ <bold>{{currentLevel}}</bold> ਹੈ। ਸ਼ਾਨਦਾਰ ਕੰਮ!",
				"mixedLevel": "ਮਿਸ਼ਰਤ",
				"overallScore": "ਸਮੁੱਚਾ ਸਕੋਰ",
				"stats": {
					"itemsAttempted_one": "ਜਵਾਬ ਦਿੱਤੀ ਆਈਟਮ",
					"itemsAttempted_other": "ਜਵਾਬ ਦਿੱਤੀਆਂ ਆਈਟਮਾਂ",
					"pointsEarned_one": "ਪ੍ਰਾਪਤ ਅੰਕ",
					"pointsEarned_other": "ਪ੍ਰਾਪਤ ਅੰਕ",
					"answeredCorrectly": "ਸਹੀ ਜਵਾਬ ਦਿੱਤਾ",
					"timeTaken": "ਲਿਆ ਗਿਆ ਸਮਾਂ",
					"target": "ਟੀਚਾ",
					"ofTotal": "{{total}} ਵਿੱਚੋਂ",
					"ofPointsTotal": "{{total}} ਵਿੱਚੋਂ",
					"skill": "ਹੁਨਰ",
					"skills": "ਹੁਨਰ",
					"questionType": "ਸਵਾਲ ਦੀ ਕਿਸਮ",
					"questionTypes": "ਸਵਾਲਾਂ ਦੀਆਂ ਕਿਸਮਾਂ",
					"proficiencyLevel": "ਨਿਪੁੰਨਤਾ ਪੱਧਰ",
					"proficiencyLevels": "ਨਿਪੁੰਨਤਾ ਪੱਧਰ"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "ਆਡੀਓ {{seconds}} ਸਕਿੰਟ ਵਿੱਚ ਸ਼ੁਰੂ ਹੋਵੇਗਾ",
			"audioStartsInPlayOnce": "ਆਡੀਓ {{seconds}} ਸਕਿੰਟ ਵਿੱਚ ਸ਼ੁਰੂ ਹੋਵੇਗਾ, ਸਿਰਫ਼ ਇੱਕ ਵਾਰ ਚੱਲੇਗਾ",
			"videoStartsIn": "ਵੀਡੀਓ {{seconds}} ਸਕਿੰਟ ਵਿੱਚ ਸ਼ੁਰੂ ਹੋਵੇਗਾ",
			"videoStartsInPlayOnce": "ਵੀਡੀਓ {{seconds}} ਸਕਿੰਟ ਵਿੱਚ ਸ਼ੁਰੂ ਹੋਵੇਗਾ, ਸਿਰਫ਼ ਇੱਕ ਵਾਰ ਚੱਲੇਗਾ",
			"recordingIn": "{{seconds}} ਸਕਿੰਟ ਵਿੱਚ ਰਿਕਾਰਡਿੰਗ"
		},
		"timeOverrunBanner": {
			"message": "ਸਮਾਂ ਖ਼ਤਮ ਹੋ ਗਿਆ। ਅਸਲ ਇਮਤਿਹਾਨ ਵਿੱਚ, ਇਸ ਤੋਂ ਬਾਅਦ ਦਾ ਕੁਝ ਵੀ ਸਕੋਰ ਨਹੀਂ ਕੀਤਾ ਜਾਵੇਗਾ। ਤੁਸੀਂ ਅਭਿਆਸ ਜਾਰੀ ਰੱਖ ਸਕਦੇ ਹੋ।"
		},
		"attributes": {
			"stimulus": "ਸਟੀਮੂਲਸ"
		},
		"stimulusTypes": {
			"reading": "ਰੀਡਿੰਗ",
			"listening": "ਲਿਸਨਿੰਗ",
			"speaking": "ਸਪੀਕਿੰਗ",
			"writing": "ਰਾਈਟਿੰਗ",
			"image": "ਤਸਵੀਰ"
		},
		"masteryLevels": {
			"belowBasic": "ਬੇਸਿਕ ਤੋਂ ਹੇਠਾਂ",
			"basic": "ਬੇਸਿਕ",
			"belowLowIntermediate": "ਲੋਅ-ਇੰਟਰਮੀਡੀਏਟ ਤੋਂ ਹੇਠਾਂ",
			"lowIntermediate": "ਲੋਅ-ਇੰਟਰਮੀਡੀਏਟ",
			"highIntermediate": "ਹਾਈ-ਇੰਟਰਮੀਡੀਏਟ",
			"advanced": "ਐਡਵਾਂਸਡ",
			"proficiencySubtitle": "{{trademark}} 'ਤੇ, ਇਹ **{{minScore}}-{{maxScore}}/30** ਦੇ ਸਕੋਰ ਨਾਲ ਮੇਲ ਖਾਂਦਾ ਹੈ।",
			"infoSectionLabel": "{{skill}} ਸੈਕਸ਼ਨ ਜਾਣਕਾਰੀ",
			"infoSectionText": {
				"Reading": "{{trademark}} ਰੀਡਿੰਗ ਸੈਕਸ਼ਨ ਇਹ ਮੁਲਾਂਕਣ ਕਰਦਾ ਹੈ ਕਿ ਤੁਸੀਂ ਅਕਾਦਮਿਕ ਮਾਹੌਲ ਵਿੱਚ ਵਰਤੀ ਜਾਂਦੀ ਲਿਖਤੀ ਸਮੱਗਰੀ ਨੂੰ ਕਿੰਨੀ ਚੰਗੀ ਤਰ੍ਹਾਂ ਪੜ੍ਹ ਅਤੇ ਸਮਝ ਸਕਦੇ ਹੋ। ਇਸ ਵਿੱਚ ਦੋ ਰੀਡਿੰਗ ਅੰਸ਼ ਸ਼ਾਮਲ ਹਨ, ਹਰੇਕ ਲਗਭਗ 700 ਸ਼ਬਦਾਂ ਲੰਬਾ, ਅਤੇ ਹਰੇਕ ਅੰਸ਼ ਲਈ 10 ਸਵਾਲ ਹਨ। ਰੀਡਿੰਗ ਸੈਕਸ਼ਨ ਪੂਰਾ ਕਰਨ ਵਿੱਚ ਲਗਭਗ 35 ਮਿੰਟ ਲੱਗਣੇ ਚਾਹੀਦੇ ਹਨ।",
				"Listening": "{{trademark}} ਲਿਸਨਿੰਗ ਸੈਕਸ਼ਨ ਅੰਗਰੇਜ਼ੀ ਵਿੱਚ ਗੱਲਬਾਤ ਅਤੇ ਲੈਕਚਰਾਂ ਨੂੰ ਸਮਝਣ ਦੀ ਤੁਹਾਡੀ ਯੋਗਤਾ ਨੂੰ ਮਾਪਣ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਹੈ। ਇਸ ਵਿੱਚ ਸ਼ਾਮਲ ਹੈ: ਬੁਨਿਆਦੀ ਸਮਝ, ਬੁਲਾਰੇ ਦੇ ਰਵੱਈਏ ਅਤੇ ਨਿਸ਼ਚਤਤਾ ਦੀ ਡਿਗਰੀ ਨੂੰ ਸਮਝਣਾ, ਅਤੇ ਜਾਣਕਾਰੀ ਨੂੰ ਜੋੜਨਾ। ਲਿਸਨਿੰਗ ਸੈਕਸ਼ਨ ਪੂਰਾ ਕਰਨ ਵਿੱਚ ਲਗਭਗ 36 ਮਿੰਟ ਲੱਗਣੇ ਚਾਹੀਦੇ ਹਨ।",
				"Speaking": "{{trademark}} ਸਪੀਕਿੰਗ ਸੈਕਸ਼ਨ ਅਕਾਦਮਿਕ ਮਾਹੌਲ ਵਿੱਚ ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਢੰਗ ਨਾਲ ਅੰਗਰੇਜ਼ੀ ਬੋਲਣ ਦੀ ਤੁਹਾਡੀ ਯੋਗਤਾ ਨੂੰ ਮਾਪਦਾ ਹੈ। ਚਾਰੇ ਸਵਾਲ/ਕੰਮ ਅਸਲ-ਜ਼ਿੰਦਗੀ ਦੀਆਂ ਉਹਨਾਂ ਸਥਿਤੀਆਂ ਨਾਲ ਮਿਲਦੇ-ਜੁਲਦੇ ਹਨ ਜਿਨ੍ਹਾਂ ਦਾ ਤੁਹਾਨੂੰ ਕਲਾਸਰੂਮ ਦੇ ਅੰਦਰ ਅਤੇ ਬਾਹਰ ਦੋਵੇਂ ਥਾਈਂ ਸਾਹਮਣਾ ਹੋ ਸਕਦਾ ਹੈ। ਸਪੀਕਿੰਗ ਸੈਕਸ਼ਨ ਪੂਰਾ ਕਰਨ ਵਿੱਚ ਲਗਭਗ 16 ਮਿੰਟ ਲੱਗਣੇ ਚਾਹੀਦੇ ਹਨ।",
				"Writing": "{{trademark}} ਰਾਈਟਿੰਗ ਸੈਕਸ਼ਨ ਅਕਾਦਮਿਕ ਮਾਹੌਲ ਵਿੱਚ ਅੰਗਰੇਜ਼ੀ ਵਿੱਚ ਲਿਖਣ ਅਤੇ ਆਪਣੇ ਵਿਚਾਰਾਂ ਨੂੰ ਸਪਸ਼ਟ ਅਤੇ ਸੁਸੰਗਠਿਤ ਢੰਗ ਨਾਲ ਪੇਸ਼ ਕਰਨ ਦੀ ਤੁਹਾਡੀ ਯੋਗਤਾ ਨੂੰ ਮਾਪਦਾ ਹੈ। ਤੁਸੀਂ ਆਪਣੀਆਂ ਪ੍ਰਤੀਕਿਰਿਆਵਾਂ ਕੰਪਿਊਟਰ ਕੀਬੋਰਡ 'ਤੇ ਟਾਈਪ ਕਰੋਗੇ ਅਤੇ ਰਾਈਟਿੰਗ ਸੈਕਸ਼ਨ ਪੂਰਾ ਕਰਨ ਵਿੱਚ ਲਗਭਗ 29 ਮਿੰਟ ਲੱਗਣੇ ਚਾਹੀਦੇ ਹਨ।"
			}
		},
		"itemTypes": {
			"MCSS": "ਬਹੁ-ਵਿਕਲਪੀ ਇੱਕ-ਚੋਣ",
			"MCSSH": "ਬਹੁ-ਵਿਕਲਪੀ ਇੱਕ-ਚੋਣ ਹਾਈਲਾਈਟ",
			"MCMS": "ਬਹੁ-ਵਿਕਲਪੀ ਬਹੁ-ਚੋਣ",
			"MCMSH": "ਬਹੁ-ਵਿਕਲਪੀ ਬਹੁ-ਚੋਣ ਹਾਈਲਾਈਟ",
			"INSERT_TEXT": "ਟੈਕਸਟ ਸ਼ਾਮਲ ਕਰਨਾ",
			"MATCH_MS": "ਮੇਲ ਬਹੁ-ਚੋਣ",
			"MCSSM": "ਬਹੁ-ਵਿਕਲਪੀ ਇੱਕ-ਚੋਣ ਮੇਲ",
			"MCMSM": "ਬਹੁ-ਵਿਕਲਪੀ ਬਹੁ-ਚੋਣ ਮੇਲ",
			"MCGS": "ਬਹੁ-ਵਿਕਲਪੀ ਖਾਲੀ ਥਾਂ ਚੋਣ",
			"MCOS": "ਬਹੁ-ਵਿਕਲਪੀ ਕ੍ਰਮ ਚੋਣ",
			"LISTENING_REPLAY": "ਲਿਸਨਿੰਗ ਰੀਪਲੇਅ",
			"AUDIO_INPUT": "ਆਡੀਓ ਇਨਪੁੱਟ",
			"ACADEMIC_DISCUSSION_RESPONSE": "ਅਕਾਦਮਿਕ ਚਰਚਾ ਪ੍ਰਤੀਕਿਰਿਆ",
			"INTEGRATED_WRITING_RESPONSE": "ਏਕੀਕ੍ਰਿਤ ਰਾਈਟਿੰਗ ਪ੍ਰਤੀਕਿਰਿਆ"
		},
		"passageStem": {
			"itemOfTotal": "{{total}} ਵਿੱਚੋਂ ਆਈਟਮ {{current}}",
			"questionOfTotal": "{{total}} ਵਿੱਚੋਂ ਸਵਾਲ {{current}}",
			"stimulusCorrespondsToNextItems": "ਹੇਠਾਂ ਦਿੱਤਾ ਸਟੀਮੂਲਸ ਅਗਲੀਆਂ {{total}} ਆਈਟਮਾਂ ਨਾਲ ਸੰਬੰਧਿਤ ਹੈ।",
			"passage": "ਅੰਸ਼",
			"lecture": "ਲੈਕਚਰ",
			"professorsQuestion": "ਪ੍ਰੋਫੈਸਰ ਦਾ ਸਵਾਲ",
			"listen": "ਸੁਣੋ",
			"openPassage": "ਅੰਸ਼ ਖੋਲ੍ਹੋ",
			"backToItem": "ਆਈਟਮ 'ਤੇ ਵਾਪਸ ਜਾਓ",
			"notYetInserted": "ਹਾਲੇ ਸ਼ਾਮਲ ਨਹੀਂ ਕੀਤਾ",
			"insertedAtPosition": "ਸਥਿਤੀ #{{position}} 'ਤੇ ਸ਼ਾਮਲ ਕੀਤਾ"
		},
		"hint": {
			"show": "ਸੰਕੇਤ ਵੇਖੋ"
		},
		"navigation": {
			"next": "ਅਗਲਾ",
			"exit": "ਬਾਹਰ ਜਾਓ",
			"saveAndExit": "ਸੇਵ ਕਰੋ ਅਤੇ ਬਾਹਰ ਜਾਓ",
			"previous": "ਪਿਛਲਾ",
			"skip": "ਛੱਡੋ",
			"finish": "ਪੂਰਾ ਕਰੋ",
			"help": "ਮਦਦ",
			"about": "ਸਵਾਲ ਦੇ ਸੁਝਾਅ",
			"questionsButtonLabel": "ਸਵਾਲ ਨੈਵੀਗੇਸ਼ਨ",
			"questionsButtonTooltip": "ਕਿਸੇ ਵੀ ਸਵਾਲ 'ਤੇ ਜਾਓ ਜਾਂ ਨਿਸ਼ਾਨਬੱਧ ਸਵਾਲਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
			"questionsButtonActiveFiltersA11y": "ਸਰਗਰਮ ਫਿਲਟਰ: {{count}}",
			"recordingInProgressTooltip": "ਰਿਕਾਰਡਿੰਗ ਜਾਰੀ ਹੋਣ ਦੌਰਾਨ ਤੁਸੀਂ ਇਸ ਆਈਟਮ ਤੋਂ ਬਾਹਰ ਨਹੀਂ ਜਾ ਸਕਦੇ",
			"questionNotReachedTooltip": "ਤੁਸੀਂ ਹਾਲੇ ਇਸ ਸਵਾਲ ਤੱਕ ਨਹੀਂ ਪਹੁੰਚੇ"
		},
		"questionTips": {
			"hideFutureLabel": "ਸੁਝਾਅ ਆਪਣੇ ਆਪ ਨਾ ਵਿਖਾਓ"
		},
		"toolbar": {
			"calculatorTooltip": "ਕੈਲਕੁਲੇਟਰ ਖੋਲ੍ਹੋ",
			"highlightTooltip": "ਆਸਾਨੀ ਨਾਲ ਹਵਾਲੇ ਲਈ ਮਹੱਤਵਪੂਰਨ ਜਾਣਕਾਰੀ ਨੂੰ ਹਾਈਲਾਈਟ ਕਰਨ ਲਈ ਟੈਕਸਟ ਚੁਣੋ",
			"markTooltip": "ਜਮ੍ਹਾਂ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਵੇਖਣ ਲਈ ਇਸ ਸਵਾਲ ਨੂੰ ਨਿਸ਼ਾਨਬੱਧ ਕਰੋ",
			"unmarkTooltip": "ਇਸ ਸਵਾਲ ਤੋਂ ਨਿਸ਼ਾਨ ਹਟਾਉਣ ਲਈ ਕਲਿੱਕ ਕਰੋ"
		},
		"summary": {
			"viewFullInsights": "ਪੂਰੀ ਇਨਸਾਈਟ ਵੇਖੋ",
			"targetTooltip": "ਇਸ ਸੈਸ਼ਨ ਲਈ ਪ੍ਰਦਰਸ਼ਨ ਟੀਚਾ।"
		},
		"stats": {
			"skill": "ਹੁਨਰ",
			"answered": "ਜਵਾਬ ਦਿੱਤਾ",
			"speed": "ਗਤੀ",
			"duration": "ਮਿਆਦ",
			"duration_tooltip": "ਤੁਹਾਡੀ ਰਿਕਾਰਡ ਕੀਤੀ ਪ੍ਰਤੀਕਿਰਿਆ ਦੀ ਲੰਬਾਈ: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "ਭਰੋਸਾ",
			"pointsEarned": "ਅੰਕ",
			"word": "ਸ਼ਬਦ",
			"words": "ਸ਼ਬਦ",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "ਇਸ ਆਈਟਮ ਨੂੰ ਪੜ੍ਹਨ ਅਤੇ ਜਵਾਬ ਦੇਣ ਵਿੱਚ ਤੁਹਾਨੂੰ {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) ਲੱਗੇ",
			"skill_tooltip": "ਇਸ ਆਈਟਮ ਲਈ ਮੁਲਾਂਕਣ ਕੀਤਾ ਗਿਆ ਹੁਨਰ ਖੇਤਰ: {{skill}}",
			"answered_correct_tooltip": "ਤੁਹਾਡੀ ਜਮ੍ਹਾਂ ਕੀਤੀ ਪ੍ਰਤੀਕਿਰਿਆ ਸਹੀ ਸੀ",
			"answered_incorrect_tooltip": "ਤੁਹਾਡੀ ਜਮ੍ਹਾਂ ਕੀਤੀ ਪ੍ਰਤੀਕਿਰਿਆ ਗਲਤ ਸੀ",
			"skipped_tooltip": "ਤੁਸੀਂ ਇਸ ਆਈਟਮ ਲਈ ਕੋਈ ਪ੍ਰਤੀਕਿਰਿਆ ਜਮ੍ਹਾਂ ਨਹੀਂ ਕੀਤੀ",
			"words_tooltip": "ਤੁਹਾਡੀ ਲਿਖਤੀ ਪ੍ਰਤੀਕਿਰਿਆ ਵਿੱਚ ਸ਼ਬਦਾਂ ਦੀ ਗਿਣਤੀ: {{count}}",
			"word_tooltip": "ਤੁਹਾਡੀ ਲਿਖਤੀ ਪ੍ਰਤੀਕਿਰਿਆ ਵਿੱਚ ਸ਼ਬਦਾਂ ਦੀ ਗਿਣਤੀ: {{count}}",
			"confidence_tooltip": "ਜਦੋਂ ਤੁਸੀਂ ਆਪਣੀ ਪ੍ਰਤੀਕਿਰਿਆ ਜਮ੍ਹਾਂ ਕੀਤੀ ਸੀ, ਤਾਂ ਤੁਹਾਨੂੰ ਕਿੰਨਾ ਭਰੋਸਾ ਸੀ",
			"points_earned_tooltip_one": "ਤੁਸੀਂ ਇਸ ਆਈਟਮ ਲਈ ਵੱਧ ਤੋਂ ਵੱਧ {{maximumScore}} ਅੰਕਾਂ ਵਿੱਚੋਂ {{points}} ਅੰਕ ਕਮਾਇਆ",
			"points_earned_tooltip_other": "ਤੁਸੀਂ ਇਸ ਆਈਟਮ ਲਈ ਵੱਧ ਤੋਂ ਵੱਧ {{maximumScore}} ਅੰਕਾਂ ਵਿੱਚੋਂ {{points}} ਅੰਕ ਕਮਾਏ",
			"challengers_tooltip": "ਤੁਹਾਡੇ ਤੋਂ ਪਹਿਲਾਂ ਇਸ ਆਈਟਮ ਦਾ ਜਵਾਬ ਦੇਣ ਵਾਲੇ ਸਿਖਿਆਰਥੀਆਂ ਦੀ ਗਿਣਤੀ: {{count}}",
			"learning_mode_points_tooltip": "ਇਸ ਕੋਸ਼ਿਸ਼ ਲਈ ਕਮਾਏ ਗਏ ਅੰਕ: +{{xp}} XP",
			"pts_earned_tooltip": "ਇਸ ਕੋਸ਼ਿਸ਼ ਲਈ ਕਮਾਏ ਗਏ ਅੰਕ: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "ਵੇਰਵਾ ਫੈਲਾਓ"
		},
		"explanation": {
			"title": "ਵਿਆਖਿਆ",
			"feedback": "ਫ਼ੀਡਬੈਕ",
			"skippedFeedbackNotice": "ਤੁਸੀਂ ਇਹ ਸਵਾਲ ਛੱਡ ਦਿੱਤਾ, ਇਸ ਲਈ ਵਿਅਕਤੀਗਤ ਫ਼ੀਡਬੈਕ ਤਿਆਰ ਨਹੀਂ ਕੀਤਾ ਗਿਆ।"
		},
		"followUps": "ਫਾਲੋ-ਅੱਪ",
		"suggestCorrection": "ਸੋਧ ਦਾ ਸੁਝਾਅ ਦਿਓ",
		"answer": {
			"correct": "ਸਹੀ",
			"incorrect": "ਗਲਤ",
			"skipped": "ਛੱਡਿਆ ਗਿਆ"
		},
		"confidence": {
			"high": "ਉੱਚ",
			"medium": "ਮੱਧਮ",
			"low": "ਘੱਟ"
		},
		"endDialog": {
			"title": "ਕੀ ਸੈਸ਼ਨ ਜਲਦੀ ਖਤਮ ਕਰਨਾ ਹੈ?",
			"confirmEndDiagnostic": "ਕੀ ਤੁਸੀਂ ਯਕੀਨਨ ਆਪਣਾ ਸੈਸ਼ਨ ਖਤਮ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ? ਸਾਰੀ ਪ੍ਰਗਤੀ ਖਤਮ ਹੋ ਜਾਵੇਗੀ ਅਤੇ ਤੁਹਾਨੂੰ ਦੁਬਾਰਾ ਸ਼ੁਰੂ ਕਰਨਾ ਪਵੇਗਾ।",
			"confirmEnd": "ਤੁਹਾਡੇ ਕੋਲ ਅਜੇ ਵੀ {{num}} {{itemLabel}} ਬਾਕੀ ਹਨ। ਤੁਸੀਂ ਹੁਣੇ ਪੂਰਾ ਕਰ ਸਕਦੇ ਹੋ ਜਾਂ ਉਹਨਾਂ ਨੂੰ ਪੂਰਾ ਕਰਨ ਲਈ ਅਧਿਐਨ ਜਾਰੀ ਰੱਖ ਸਕਦੇ ਹੋ।",
			"confirmEndNoAnswer": "ਤੁਸੀਂ ਹਾਲੇ ਕਿਸੇ ਵੀ ਸਵਾਲ ਦਾ ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ। ਕੀ ਤੁਸੀਂ ਯਕੀਨਨ ਹੁਣੇ ਖਤਮ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
			"confirmEndNoAnswerPositive": "ਅਧਿਐਨ ਜਾਰੀ ਰੱਖੋ",
			"confirmEndNoAnswerNegative": "ਹੁਣੇ ਖਤਮ ਕਰੋ"
		},
		"permissionDialog": {
			"title": "ਮਾਈਕ੍ਰੋਫੋਨ ਪਹੁੰਚ ਲੋੜੀਂਦੀ ਹੈ",
			"descriptionWeb": "ਸਪੀਕਿੰਗ ਅਭਿਆਸ ਤੁਹਾਡੇ ਮਾਈਕ੍ਰੋਫੋਨ ਦੀ ਵਰਤੋਂ ਕਰਦਾ ਹੈ। ਤੁਹਾਡਾ ਬ੍ਰਾਊਜ਼ਰ ਇਸ ਸਾਈਟ ਲਈ ਪਹੁੰਚ ਨੂੰ ਬਲਾਕ ਕਰ ਰਿਹਾ ਹੈ — ਵੈੱਬ ਪਤੇ ਦੇ ਨਾਲ ਵਾਲੇ ਅਧਿਕਾਰ ਆਈਕਨ 'ਤੇ ਕਲਿੱਕ ਕਰੋ, ਮਾਈਕ੍ਰੋਫੋਨ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ, ਫਿਰ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
			"descriptionMobile": "ਸਪੀਕਿੰਗ ਅਭਿਆਸ ਤੁਹਾਡੇ ਮਾਈਕ੍ਰੋਫੋਨ ਦੀ ਵਰਤੋਂ ਕਰਦਾ ਹੈ। ਜਾਰੀ ਰੱਖਣ ਲਈ ਆਪਣੀਆਂ ਡਿਵਾਈਸ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਮਾਈਕ੍ਰੋਫੋਨ ਪਹੁੰਚ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ।",
			"promptDescriptionWeb": "ਸਪੀਕਿੰਗ ਅਭਿਆਸ ਤੁਹਾਡੇ ਮਾਈਕ੍ਰੋਫੋਨ ਦੀ ਵਰਤੋਂ ਕਰਦਾ ਹੈ। ਇਜਾਜ਼ਤ ਦੀ ਬੇਨਤੀ ਕਰੋ ਅਤੇ ਜਦੋਂ ਤੁਹਾਡਾ ਬ੍ਰਾਊਜ਼ਰ ਪੁੱਛੇ ਤਾਂ ਇਜਾਜ਼ਤ ਦਿਓ ਚੁਣੋ।",
			"blockedDescriptionWeb": "ਇਸ ਸਾਈਟ ਲਈ ਮਾਈਕ੍ਰੋਫੋਨ ਪਹੁੰਚ ਬਲਾਕ ਹੈ। ਵੈੱਬ ਪਤੇ ਦੇ ਨਾਲ ਵਾਲੇ ਆਈਕਨ 'ਤੇ ਕਲਿੱਕ ਕਰੋ, ਮਾਈਕ੍ਰੋਫੋਨ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ, ਫਿਰ ਦੁਬਾਰਾ ਇਜਾਜ਼ਤ ਦੀ ਬੇਨਤੀ ਕਰੋ।",
			"ok": "ਠੀਕ ਹੈ",
			"cancel": "ਰੱਦ ਕਰੋ",
			"openSettings": "ਸੈਟਿੰਗਾਂ ਖੋਲ੍ਹੋ",
			"requestPermission": "ਇਜਾਜ਼ਤ ਦੀ ਬੇਨਤੀ ਕਰੋ",
			"dismissAndExit": "ਖਾਰਜ ਕਰੋ ਅਤੇ ਬਾਹਰ ਜਾਓ",
			"learnMore": "ਹੋਰ ਜਾਣੋ"
		},
		"audioPlaybackTestDialog": {
			"title": "ਆਡੀਓ ਪਲੇਬੈਕ ਟੈਸਟ ਕਰੋ",
			"description": "{{appName}} ਐਪ ਵਿੱਚ ਕਈ ਆਡੀਓ ਪਲੇਬੈਕ ਫੀਚਰ ਸ਼ਾਮਲ ਹਨ, ਜਿਵੇਂ ਕਿ ਸਟੀਮੂਲਸ, ਟੈਸਟ ਆਈਟਮਾਂ ਅਤੇ ਟੈਕਸਟ-ਟੂ-ਸਪੀਚ ਵਿੱਚ ਮੌਜੂਦ ਫੀਚਰ। ਸਭ ਤੋਂ ਵਧੀਆ ਅਨੁਭਵ ਯਕੀਨੀ ਬਣਾਉਣ ਲਈ, ਕਿਰਪਾ ਕਰਕੇ ਹੇਠਾਂ ਆਪਣੇ ਆਡੀਓ ਦੀ ਜਾਂਚ ਕਰੋ। ਇੱਕ ਵਾਰ ਜਦੋਂ ਤੁਸੀਂ ਪੁਸ਼ਟੀ ਕਰ ਲਵੋ ਕਿ ਇਹ ਕੰਮ ਕਰ ਰਿਹਾ ਹੈ, ਤਾਂ ਅੱਗੇ ਵਧੋ।",
			"troubleshooting": {
				"title": "ਆਡੀਓ ਸਮੱਸਿਆਵਾਂ ਦਾ ਨਿਪਟਾਰਾ",
				"volumeTitle": "ਡਿਵਾਈਸ ਦੀ ਆਵਾਜ਼ ਦੀ ਜਾਂਚ ਕਰੋ",
				"volumeDescriptionWeb": "ਕੀਬੋਰਡ ਕੰਟਰੋਲ ਜਾਂ ਮੀਨੂ/ਟਾਸਕਬਾਰ ਵਿੱਚ ਸਿਸਟਮ ਆਵਾਜ਼ ਸੈਟਿੰਗਾਂ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਆਵਾਜ਼ ਵਿਵਸਥਿਤ ਕਰੋ",
				"volumeDescriptionMobile": "ਡਿਵਾਈਸ ਦੇ ਆਵਾਜ਼ ਬਟਨ ਵਰਤੋ ਜਾਂ ਸਿਸਟਮ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਵਿਵਸਥਿਤ ਕਰੋ",
				"outputTitle": "ਆਡੀਓ ਆਊਟਪੁੱਟ ਡਿਵਾਈਸ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
				"outputDescription": "ਹੈੱਡਫੋਨ ਦੀ ਸਥਿਤੀ ਵਿੱਚ, ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਉਹ ਸਹੀ ਢੰਗ ਨਾਲ ਕਨੈਕਟ ਹਨ ਅਤੇ ਸਰਗਰਮ ਆਊਟਪੁੱਟ ਡਿਵਾਈਸ ਵਜੋਂ ਚੁਣੇ ਗਏ ਹਨ",
				"browserTitle": "ਬ੍ਰਾਊਜ਼ਰ ਟੈਬ ਆਡੀਓ ਦੀ ਜਾਂਚ ਕਰੋ",
				"browserDescription": "ਟੈਬ ਸਿਰਲੇਖ ਦੇ ਨਾਲ ਮਿਊਟ ਕੀਤੇ ਸਪੀਕਰ ਆਈਕਨ ਨੂੰ ਵੇਖੋ ਅਤੇ ਜੇ ਮੌਜੂਦ ਹੋਵੇ ਤਾਂ ਅਣਮਿਊਟ ਕਰੋ।"
			},
			"skipCheck": "ਅਗਲੀ ਵਾਰ ਇਹ ਜਾਂਚ ਛੱਡੋ",
			"workingButton": "ਆਡੀਓ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
			"textToHear": "ਤੁਹਾਨੂੰ ਸੁਣਨਾ ਚਾਹੀਦਾ ਹੈ: {{text}}"
		},
		"overall": "ਸਮੁੱਚਾ",
		"subskills": {
			"content": {
				"title": "ਸਮੱਗਰੀ"
			},
			"languageUse": {
				"title": "ਭਾਸ਼ਾ ਦੀ ਵਰਤੋਂ"
			},
			"organizationAndDevelopment": {
				"title": "ਸੰਗਠਨ ਅਤੇ ਵਿਕਾਸ"
			},
			"topicDevelopment": {
				"title": "ਵਿਸ਼ਾ ਵਿਕਾਸ"
			},
			"delivery": {
				"title": "ਪੇਸ਼ਕਾਰੀ"
			}
		},
		"finalizing": {
			"title": "ਤੁਹਾਡੇ ਨਤੀਜੇ ਅੰਤਿਮ ਰੂਪ ਦਿੱਤੇ ਜਾ ਰਹੇ ਹਨ",
			"gradingProgress": "ਪ੍ਰਤੀਕਿਰਿਆਵਾਂ ਦੀ ਗਰੇਡਿੰਗ ਹੋ ਰਹੀ ਹੈ..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "ਇੱਕ ਸਪੀਕਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਸੁਣੇ ਹੋਏ ਵਾਕ ਨੂੰ ਜਿੰਨਾ ਸੰਭਵ ਹੋ ਸਕੇ ਸਹੀ ਢੰਗ ਨਾਲ ਦੁਹਰਾਉਂਦਾ ਹੈ।",
			"Read Aloud": "ਇੱਕ ਸਪੀਕਿੰਗ ਆਈਟਮ ਜਿੱਥੇ ਸਿਖਿਆਰਥੀ ਮੁਲਾਂਕਣ ਲਈ ਇੱਕ ਅੰਸ਼ ਉੱਚੀ ਆਵਾਜ਼ ਵਿੱਚ ਪੜ੍ਹਦਾ ਹੈ।",
			"Describe Image": "ਇੱਕ ਸਪੀਕਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਇੱਕ ਦ੍ਰਿਸ਼ਟੀਗਤ ਸਟੀਮੂਲਸ ਦਾ ਵਿਸਥਾਰ ਵਿੱਚ ਵਰਣਨ ਕਰਦਾ ਹੈ।",
			"Write Essay": "ਇੱਕ ਨਿਰਮਿਤ-ਪ੍ਰਤੀਕਿਰਿਆ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਦਿੱਤੇ ਗਏ ਵਿਸ਼ੇ 'ਤੇ ਇੱਕ ਢਾਂਚਾਗਤ ਲੇਖ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ।",
			"Retell Lecture": "ਇੱਕ ਸਪੀਕਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਸੁਣੇ ਹੋਏ ਲੈਕਚਰ ਜਾਂ ਭਾਸ਼ਣ ਦਾ ਸੰਖੇਪ ਦਿੰਦਾ ਹੈ।",
			"Summarize Group Discussion": "ਇੱਕ ਲਿਸਨਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਇੱਕ ਬਹੁ-ਬੁਲਾਰਾ ਚਰਚਾ ਦਾ ਸੰਖੇਪ ਦਿੰਦਾ ਹੈ।",
			"Answer Short Question": "ਇੱਕ ਸੰਖੇਪ ਸਪੀਕਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਇੱਕ ਸੰਖੇਪ ਪ੍ਰਤੀਕਿਰਿਆ ਨਾਲ ਇੱਕ ਛੋਟੇ ਸਵਾਲ ਦਾ ਜਵਾਬ ਦਿੱਤਾ ਜਾਂਦਾ ਹੈ।",
			"Respond to a Situation": "ਇੱਕ ਸਪੀਕਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਦੱਸੇ ਗਏ ਦ੍ਰਿਸ਼ ਦਾ ਉਚਿਤ ਢੰਗ ਨਾਲ ਜਵਾਬ ਦਿੰਦਾ ਹੈ।",
			"Summarize Written Text": "ਇੱਕ ਰੀਡਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਇੱਕ ਅੰਸ਼ ਦਾ ਆਪਣੇ ਸ਼ਬਦਾਂ ਵਿੱਚ ਸੰਖੇਪ ਦਿੰਦਾ ਹੈ।",
			"Reorder Paragraph": "ਇੱਕ ਰੀਡਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਰਲੇ-ਮਿਲੇ ਪੈਰਿਆਂ ਨੂੰ ਸਹੀ ਕ੍ਰਮ ਵਿੱਚ ਵਿਵਸਥਿਤ ਕਰਦਾ ਹੈ।",
			"Fill in the Blanks (Dropdown)": "ਇੱਕ ਰੀਡਿੰਗ ਕਾਰਜ ਜਿੱਥੇ ਹਰ ਖਾਲੀ ਥਾਂ ਨੂੰ ਵਿਕਲਪਾਂ ਦੇ ਇੱਕ ਡ੍ਰੌਪਡਾਊਨ ਵਿੱਚੋਂ ਪੂਰਾ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
			"Fill in the Blanks (Type In)": "ਇੱਕ ਲਿਸਨਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਗੁੰਮ ਸ਼ਬਦ ਜਾਂ ਛੋਟਾ ਵਾਕੰਸ਼ ਟਾਈਪ ਕਰਦਾ ਹੈ।",
			"Fill in the Blanks (Drag and Drop)": "ਇੱਕ ਰੀਡਿੰਗ ਕਾਰਜ ਜਿੱਥੇ ਵਿਕਲਪਾਂ ਨੂੰ ਖਾਲੀ ਥਾਵਾਂ ਵਿੱਚ ਖਿੱਚ ਕੇ ਗੁੰਮ ਸ਼ਬਦ ਭਰੇ ਜਾਂਦੇ ਹਨ।",
			"Multiple Choice, Single Answer": "ਇੱਕ ਬਹੁ-ਚੋਣ ਆਈਟਮ ਜਿੱਥੇ ਸਿਖਿਆਰਥੀ ਇੱਕ ਸਹੀ ਜਵਾਬ ਚੁਣਦਾ ਹੈ।",
			"Multiple Choice, Single Answer (Reading)": "ਇੱਕ ਰੀਡਿੰਗ ਬਹੁ-ਚੋਣ ਆਈਟਮ ਜਿੱਥੇ ਸਿਖਿਆਰਥੀ ਇੱਕ ਸਹੀ ਜਵਾਬ ਚੁਣਦਾ ਹੈ।",
			"Multiple Choice, Single Answer (Listening)": "ਇੱਕ ਲਿਸਨਿੰਗ ਬਹੁ-ਚੋਣ ਆਈਟਮ ਜਿੱਥੇ ਸਿਖਿਆਰਥੀ ਇੱਕ ਸਹੀ ਜਵਾਬ ਚੁਣਦਾ ਹੈ।",
			"Multiple Choice, Multiple Answers": "ਇੱਕ ਆਈਟਮ ਜਿੱਥੇ ਸਿਖਿਆਰਥੀ ਇੱਕ ਤੋਂ ਵੱਧ ਸਹੀ ਜਵਾਬ ਚੁਣ ਸਕਦਾ ਹੈ।",
			"Multiple Choice, Multiple Answers (Reading)": "ਇੱਕ ਰੀਡਿੰਗ ਆਈਟਮ ਜਿੱਥੇ ਸਿਖਿਆਰਥੀ ਇੱਕ ਤੋਂ ਵੱਧ ਸਹੀ ਜਵਾਬ ਚੁਣ ਸਕਦਾ ਹੈ।",
			"Multiple Choice, Multiple Answers (Listening)": "ਇੱਕ ਲਿਸਨਿੰਗ ਆਈਟਮ ਜਿੱਥੇ ਸਿਖਿਆਰਥੀ ਇੱਕ ਤੋਂ ਵੱਧ ਸਹੀ ਜਵਾਬ ਚੁਣ ਸਕਦਾ ਹੈ।",
			"Summarize Spoken Text": "ਇੱਕ ਲਿਸਨਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਸੁਣੀ ਹੋਈ ਗੱਲ ਦਾ ਸੰਖੇਪ ਲਿਖਦਾ ਹੈ।",
			"Highlight Correct Summary": "ਇੱਕ ਲਿਸਨਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਉਸ ਸੰਖੇਪ ਨੂੰ ਹਾਈਲਾਈਟ ਕਰਦਾ ਹੈ ਜੋ ਆਡੀਓ ਨਾਲ ਸਭ ਤੋਂ ਵਧੀਆ ਮੇਲ ਖਾਂਦਾ ਹੈ।",
			"Select Missing Word": "ਇੱਕ ਲਿਸਨਿੰਗ ਖਾਲੀ-ਥਾਂ-ਭਰੋ ਕਾਰਜ ਜਿੱਥੇ ਸਿਖਿਆਰਥੀ ਗੁੰਮ ਸ਼ਬਦ ਚੁਣਦਾ ਹੈ।",
			"Highlight Incorrect Words": "ਇੱਕ ਲਿਸਨਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਟ੍ਰਾਂਸਕ੍ਰਿਪਟ ਵਿੱਚ ਉਹ ਸ਼ਬਦ ਹਾਈਲਾਈਟ ਕਰਦਾ ਹੈ ਜੋ ਆਡੀਓ ਤੋਂ ਵੱਖਰੇ ਹਨ।",
			"Write from Dictation": "ਇੱਕ ਲਿਸਨਿੰਗ ਕਾਰਜ ਜਿਸ ਵਿੱਚ ਸਿਖਿਆਰਥੀ ਸੁਣੇ ਹੋਏ ਵਾਕ ਨੂੰ ਲਿਖਦਾ ਹੈ।"
		}
	},
	"report": {
		"readFullInsights": "ਪੂਰੇ ਇਨਸਾਈਟ ਪੜ੍ਹੋ",
		"productName": "{{examName}} {{type}}",
		"startedAt": "{{time}} 'ਤੇ ਸ਼ੁਰੂ ਹੋਇਆ",
		"itemTypesTitle": "ਆਈਟਮ ਕਿਸਮਾਂ ਦੀ ਵੰਡ",
		"itemTypesFilterAll": "ਸਭ",
		"questionTypeCardTitle": "{{skill}} ਆਈਟਮ ਕਿਸਮਾਂ ਦੀ ਵੰਡ",
		"questionTypeCardSubtitle_one": "ਇਸ ਸੈਸ਼ਨ ਵਿੱਚ {{count}} {{skill}} ਆਈਟਮ ਕਿਸਮ ਦੇ ਆਧਾਰ 'ਤੇ",
		"questionTypeCardSubtitle_other": "ਇਸ ਸੈਸ਼ਨ ਵਿੱਚ {{count}} {{skill}} ਆਈਟਮ ਕਿਸਮਾਂ ਦੇ ਆਧਾਰ 'ਤੇ",
		"questionTypeCardAltSubtitle_one": "ਇਸ ਸੈਸ਼ਨ ਵਿੱਚ {{count}} ਆਈਟਮ ਕਿਸਮ ਦੇ ਆਧਾਰ 'ਤੇ",
		"questionTypeCardAltSubtitle_other": "ਇਸ ਸੈਸ਼ਨ ਵਿੱਚ {{count}} ਆਈਟਮ ਕਿਸਮਾਂ ਦੇ ਆਧਾਰ 'ਤੇ",
		"questionTypeRowSubtitle_zero": "ਕਿਸੇ ਆਈਟਮ ਦਾ ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ ਗਿਆ",
		"questionTypeRowSubtitle_one": "{{count}} ਆਈਟਮ ਦਾ ਜਵਾਬ ਦਿੱਤਾ ਗਿਆ",
		"questionTypeRowSubtitle_other": "{{count}} ਆਈਟਮਾਂ ਦੇ ਜਵਾਬ ਦਿੱਤੇ ਗਏ",
		"itemTypeDetail": {
			"review_one": "ਆਈਟਮ ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
			"review_other": "ਆਈਟਮਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
			"stats": {
				"answered_one": "ਜਵਾਬ ਦਿੱਤੀ ਆਈਟਮ",
				"answered_other": "ਜਵਾਬ ਦਿੱਤੀਆਂ ਆਈਟਮਾਂ",
				"avgTime": "ਪ੍ਰਤੀ ਆਈਟਮ ਔਸਤ ਸਮਾਂ"
			}
		},
		"reviewAnswersDialog": {
			"title": "ਜਵਾਬਾਂ ਦੀ ਸਮੀਖਿਆ",
			"sections": {
				"skills": "ਹੁਨਰ",
				"questionTypes": "ਸਵਾਲਾਂ ਦੀਆਂ ਕਿਸਮਾਂ",
				"proficiency": "ਨਿਪੁੰਨਤਾ",
				"performance": "ਪ੍ਰਦਰਸ਼ਨ"
			},
			"summaryNone": "ਜਾਰੀ ਰੱਖਣ ਲਈ ਆਈਟਮਾਂ ਵਾਲੇ ਫਿਲਟਰ ਚੁਣੋ।",
			"summaryAll_one": "ਸਾਰੇ {{count}} ਜਵਾਬ ਦੀ ਸਮੀਖਿਆ ਕਰੋ।",
			"summaryAll_other": "ਸਾਰੇ {{count}} ਜਵਾਬਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ।",
			"summaryFiltered_one": "{{filters}} ਨਾਲ ਮੇਲ ਖਾਂਦੇ {{count}} ਜਵਾਬ ਦੀ ਸਮੀਖਿਆ ਕਰੋ।",
			"summaryFiltered_other": "{{filters}} ਨਾਲ ਮੇਲ ਖਾਂਦੇ {{count}} ਜਵਾਬਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ।",
			"reviewAnswers_one": "{{count}} ਜਵਾਬ ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
			"reviewAnswers_other": "{{count}} ਜਵਾਬਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
			"more": "{{count}} ਹੋਰ"
		},
		"itemDetail": {
			"title": "ਮੇਰੇ ਜਵਾਬਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
			"filterAll": "ਸਭ",
			"filterCorrect": "ਸਹੀ",
			"filterIncorrect": "ਗਲਤ",
			"filterMarked": "ਨਿਸ਼ਾਨਬੱਧ",
			"emptyTitle": "ਕੋਈ ਮੇਲ ਖਾਂਦੀ ਆਈਟਮ ਨਹੀਂ",
			"emptyDescription": "ਤੁਹਾਡੇ ਸੈਸ਼ਨ ਦੀ ਕੋਈ ਵੀ ਆਈਟਮ ਚੁਣੇ ਗਏ ਫਿਲਟਰ ({{filter}}) ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦੀ। ਹੋਰ ਨਤੀਜੇ ਵੇਖਣ ਲਈ ਫਿਲਟਰ ਬਦਲਣ ਜਾਂ ਸਾਫ਼ ਕਰਨ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
			"emptyCta": "ਫਿਲਟਰ ਸਾਫ਼ ਕਰੋ"
		},
		"answerCardTitle": "ਜਵਾਬ ਦਿੱਤੀਆਂ ਆਈਟਮਾਂ",
		"answerCardSubtitle_one": "ਵੇਖੋ ਕਿ ਤੁਸੀਂ ਸਾਰੇ ਸਵਾਲਾਂ ਵਿੱਚ ਕਿਵੇਂ ਕੀਤਾ",
		"answerCardSubtitle_other": "ਵੇਖੋ ਕਿ ਤੁਸੀਂ ਸਾਰੇ {{count}} ਸਵਾਲਾਂ ਵਿੱਚ ਕਿਵੇਂ ਕੀਤਾ",
		"skillsBreakdown": {
			"title": "ਹੁਨਰ ਦੀ ਵੰਡ",
			"subtitle_one": "{{count}} ਆਈਟਮ ਦੇ ਆਧਾਰ 'ਤੇ",
			"subtitle_other": "{{count}} ਆਈਟਮਾਂ ਦੇ ਆਧਾਰ 'ਤੇ"
		},
		"studyPack": "ਸਟੱਡੀ ਪੈਕ",
		"practiceTestCompleted": "ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ ਪੂਰਾ ਹੋਇਆ",
		"studySessionCompleted": "ਅਧਿਐਨ ਸੈਸ਼ਨ ਪੂਰਾ ਹੋਇਆ",
		"diagnosticSessionCompleted": "ਡਾਇਗਨੌਸਟਿਕ ਸੈਸ਼ਨ ਪੂਰਾ ਹੋਇਆ",
		"timeElapsed": "ਬੀਤਿਆ ਸਮਾਂ",
		"stats": {
			"answered": "ਜਵਾਬ ਦਿੱਤੇ",
			"time elapsed": "ਬੀਤਿਆ ਸਮਾਂ",
			"avg speed": "ਔਸਤ ਗਤੀ",
			"hints used": "ਵਰਤੇ ਗਏ ਸੰਕੇਤ"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "ਸ਼ਾਨਦਾਰ ਕੰਮ—ਉੱਤਮਤਾ ਲਈ ਕੋਸ਼ਿਸ਼ ਜਾਰੀ ਰੱਖੋ!",
				"highIntermediate": "ਤੁਸੀਂ ਬਹੁਤ ਵਧੀਆ ਕਰ ਰਹੇ ਹੋ—ਆਪਣੀਆਂ ਖੂਬੀਆਂ ਨੂੰ ਨਿਖਾਰਦੇ ਰਹੋ!",
				"lowIntermediate": "ਤੁਹਾਡੀ ਪ੍ਰਗਤੀ ਸਥਿਰ ਹੈ—ਇਸੇ ਤਰ੍ਹਾਂ ਜਾਰੀ ਰੱਖੋ!",
				"basic": "ਆਪਣੀਆਂ ਯੋਗਤਾਵਾਂ ਵਧਾਉਣ ਲਈ ਕੰਮ ਕਰਦੇ ਰਹੋ!"
			},
			"infoText": "ਤੁਸੀਂ ਆਪਣੇ {{skillsText}} {{skills}} ਦਾ ਅਭਿਆਸ ਕਰਨ ਲਈ **{{numActivities}} {{activityLabel}}** ਪੂਰੀਆਂ ਕੀਤੀਆਂ। {{skillDetails}}। ਕੁੱਲ ਮਿਲਾ ਕੇ, ਤੁਸੀਂ **{{numPointsEarned}} ਵਿੱਚੋਂ {{numTotalPoints}} ਅੰਕ** ਪ੍ਰਾਪਤ ਕੀਤੇ, ਜੋ {{thisText}} {{skills}} ਵਿੱਚ **{{compositeLevel}} ਨਿਪੁੰਨਤਾ** ਦਰਸਾਉਂਦਾ ਹੈ। {{compositeFeedback}}",
			"infoText.singleSkill": "ਤੁਸੀਂ ਆਪਣੇ **{{skill_1}}** ਹੁਨਰ 'ਤੇ ਕੇਂਦ੍ਰਿਤ **{{itemCount}} {{itemLabel}}** ਪੂਰੀਆਂ ਕੀਤੀਆਂ। ਤੁਸੀਂ **{{skill_1_score}} ਵਿੱਚੋਂ {{skill_1_total}}** ਸਕੋਰ ਕੀਤਾ, ਜੋ **{{proficiency}}** ਨਿਪੁੰਨਤਾ ਦਰਸਾਉਂਦਾ ਹੈ। {{compositeFeedback}}",
			"infoText.multiSkill": "ਤੁਸੀਂ ਆਪਣੇ **{{skills_text}}** ਹੁਨਰਾਂ ਦਾ ਅਭਿਆਸ ਕਰਦੇ ਹੋਏ **{{itemCount}} {{itemLabel}}** ਪੂਰੀਆਂ ਕੀਤੀਆਂ। {{skill_details}} ਕੁੱਲ ਮਿਲਾ ਕੇ, ਤੁਸੀਂ **{{overall_score}} ਵਿੱਚੋਂ {{overall_total}} ਅੰਕ** ਪ੍ਰਾਪਤ ਕੀਤੇ, ਜੋ ਇਹਨਾਂ ਹੁਨਰਾਂ ਵਿੱਚ **{{overall_proficiency}}** ਨਿਪੁੰਨਤਾ ਦਰਸਾਉਂਦਾ ਹੈ। {{compositeFeedback}}",
			"skillDetails": "**{{skill}}** ਵਿੱਚ, ਤੁਸੀਂ **{{score}} ਵਿੱਚੋਂ {{total}}** ਸਕੋਰ ਕੀਤਾ, ਜੋ **{{proficiency}}** ਨਿਪੁੰਨਤਾ ਦਰਸਾਉਂਦਾ ਹੈ।"
		},
		"actions": {
			"goToHome": "ਹੋਮਪੇਜ 'ਤੇ ਜਾਓ",
			"studyMore": "ਹੋਰ ਅਧਿਐਨ ਕਰੋ",
			"studyFree": "ਮੁਫ਼ਤ {{tagTypes}} ਦਾ ਅਧਿਐਨ ਕਰੋ",
			"reviewAnswers": "ਜਵਾਬਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ"
		},
		"nextAction": {
			"title": "ਸਿਫ਼ਾਰਸ਼ੀ: {{focus}} ਅਭਿਆਸ",
			"dialog": {
				"title": "ਸਿਫ਼ਾਰਸ਼ੀ ਅਧਿਐਨ ਸੈਸ਼ਨ",
				"subtitle": "ਆਪਣੇ ਕਮਜ਼ੋਰ ਖੇਤਰਾਂ 'ਤੇ ਧਿਆਨ ਦਿਓ"
			},
			"fallback": {
				"title": "ਅਭਿਆਸ ਜਾਰੀ ਰੱਖੋ",
				"description": "ਉਹਨਾਂ ਖੇਤਰਾਂ ਦੁਆਲੇ ਅਧਿਐਨ ਸੈਸ਼ਨ ਬਣਾਓ ਜਿਨ੍ਹਾਂ 'ਤੇ ਤੁਸੀਂ ਅੱਗੇ ਕੰਮ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ।"
			}
		},
		"premium": {
			"upgradeCta": "ਪ੍ਰੀਮੀਅਮ ਲਈ ਅੱਪਗ੍ਰੇਡ ਕਰੋ"
		},
		"disclaimer": {
			"title": "ਬੇਦਾਅਵਾ",
			"summativeBody": "ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ ਸਕੋਰ ਇੱਕ ਅੰਦਾਜ਼ਾ ਹਨ ਅਤੇ ਲਾਈਵ {{examName}} ਟੈਸਟ ਵਿੱਚ ਉਹੀ ਨਤੀਜਾ ਯਕੀਨੀ ਨਹੀਂ ਬਣਾਉਂਦੇ।"
		},
		"performance": {
			"title": "ਪ੍ਰਦਰਸ਼ਨ",
			"subtitle": "{{count}} ਆਈਟਮਾਂ ਦੇ ਆਧਾਰ 'ਤੇ",
			"correct": "ਸਹੀ",
			"correctItems": "{{count}} ਆਈਟਮਾਂ",
			"incorrect": "ਗਲਤ",
			"incorrectItems": "{{count}} ਆਈਟਮਾਂ"
		},
		"mastery": {
			"performanceTitle": "ਪ੍ਰਦਰਸ਼ਨ",
			"sessionMasteryTitle": "ਅਨੁਮਾਨਿਤ ਨਿਪੁੰਨਤਾ",
			"subtitle_assessment": "ਇਸ ਮੁਲਾਂਕਣ ਦੀਆਂ ਸਾਰੀਆਂ {{count}} {{item}} ਦੇ ਆਧਾਰ 'ਤੇ",
			"subtitle_session": "ਇਸ ਸੈਸ਼ਨ ਦੀਆਂ ਸਾਰੀਆਂ {{count}} {{item}} ਦੇ ਆਧਾਰ 'ਤੇ"
		},
		"sessionAnalysis": {
			"title": "ਸੈਸ਼ਨ ਵਿਸ਼ਲੇਸ਼ਣ",
			"subtitle": "ਵਿਅਕਤੀਗਤ ਵਿਸ਼ਲੇਸ਼ਣ ਅਤੇ ਸਿਫ਼ਾਰਸ਼ਾਂ",
			"viewFullAnalysis": "ਵਿਸ਼ਲੇਸ਼ਣ ਵੇਖੋ",
			"feedbackDialog": {
				"body": "ਅਸੀਂ ਲਗਭਗ ਹਰ ਰੋਜ਼ ਅੱਪਡੇਟ ਜਾਰੀ ਕਰਦੇ ਹਾਂ ਅਤੇ ਸੁਧਾਰ ਕਰਨ ਲਈ ਦ੍ਰਿੜ ਹਾਂ। ਕੀ ਤੁਸੀਂ ਫ਼ੀਡਬੈਕ ਦੇ ਸਕਦੇ ਹੋ?",
				"placeholder": "ਆਪਣਾ ਫ਼ੀਡਬੈਕ ਇੱਥੇ ਦਰਜ ਕਰੋ",
				"cta": "ਫ਼ੀਡਬੈਕ ਭੇਜੋ",
				"successMessage": "ਫ਼ੀਡਬੈਕ ਜਮ੍ਹਾਂ ਹੋ ਗਿਆ। ਧੰਨਵਾਦ!",
				"feedbackLimitError": "ਫ਼ੀਡਬੈਕ ਘੱਟੋ-ਘੱਟ 10 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ"
			},
			"menuActions": {
				"copy": "ਕਾਪੀ ਕਰੋ",
				"altCopy": "ਸੰਖੇਪ ਟੈਕਸਟ ਕਾਪੀ ਕਰੋ",
				"altPositiveFeedback": "ਇਹ ਮਦਦਗਾਰ ਸੀ",
				"positiveFeedback": "ਵਧੀਆ ਪ੍ਰਤੀਕਿਰਿਆ",
				"negativeFeedback": "ਮਾੜੀ ਪ੍ਰਤੀਕਿਰਿਆ",
				"reportIssue": "ਰਿਪੋਰਟ ਕਰੋ",
				"altReportIssue": "ਇਸ ਪ੍ਰਤੀਕਿਰਿਆ ਦੀ ਰਿਪੋਰਟ ਕਰੋ",
				"emailSummary": "ਸੰਖੇਪ ਟੈਕਸਟ ਈਮੇਲ ਕਰੋ",
				"emailAlreadySent": "ਈਮੇਲ ਪਹਿਲਾਂ ਹੀ ਭੇਜੀ ਜਾ ਚੁੱਕੀ ਹੈ",
				"copiedAnalysis": "ਵਿਸ਼ਲੇਸ਼ਣ ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਕੀਤਾ",
				"emailSent": "{{email}} 'ਤੇ ਈਮੇਲ ਭੇਜੀ ਗਈ, ਜੇ ਤੁਹਾਨੂੰ ਈਮੇਲ ਪ੍ਰਾਪਤ ਨਹੀਂ ਹੁੰਦੀ, ਤਾਂ ਆਪਣੇ ਜੰਕ, ਸਪੈਮ, ਅਤੇ ਹਾਲ ਹੀ ਵਿੱਚ ਮਿਟਾਏ ਗਏ ਫੋਲਡਰ ਚੈੱਕ ਕਰੋ",
				"emailFailed": "{{email}} ਨੂੰ ਈਮੇਲ ਭੇਜਣ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ",
				"emailInstructionMessage": "ਜੇ ਤੁਹਾਨੂੰ ਈਮੇਲ ਪ੍ਰਾਪਤ ਨਹੀਂ ਹੁੰਦੀ, ਤਾਂ ਆਪਣੇ ਜੰਕ, ਸਪੈਮ, ਅਤੇ ਹਾਲ ਹੀ ਵਿੱਚ ਮਿਟਾਏ ਗਏ ਫੋਲਡਰ ਚੈੱਕ ਕਰੋ, ਜਾਂ ਆਪਣੇ IT ਪ੍ਰਸ਼ਾਸਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ"
			}
		}
	},
	"feedback": {
		"successMessage": "ਫ਼ੀਡਬੈਕ ਜਮ੍ਹਾਂ ਹੋ ਗਿਆ। ਧੰਨਵਾਦ!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "ਤੁਹਾਨੂੰ ਕੀ ਪਸੰਦ ਹੈ? ਕੀ ਸੁਧਾਰਿਆ ਜਾ ਸਕਦਾ ਹੈ? ਅਸੀਂ ਪਲੇਟਫਾਰਮ ਵਿੱਚ ਰੋਜ਼ਾਨਾ ਸੁਧਾਰ ਕਰਦੇ ਹਾਂ ਅਤੇ ਸਾਡੀ ਟੀਮ ਹਰ ਫ਼ੀਡਬੈਕ ਪੜ੍ਹਦੀ ਹੈ। ਧੰਨਵਾਦ!",
			"title": "ਆਪਣਾ ਫ਼ੀਡਬੈਕ ਸਾਂਝਾ ਕਰੋ",
			"body": "ਤੁਹਾਨੂੰ ਕੀ ਪਸੰਦ ਹੈ? ਕੀ ਸੁਧਾਰਿਆ ਜਾ ਸਕਦਾ ਹੈ? ਅਸੀਂ ਪਲੇਟਫਾਰਮ ਵਿੱਚ ਰੋਜ਼ਾਨਾ ਸੁਧਾਰ ਕਰਦੇ ਹਾਂ ਅਤੇ ਸਾਡੀ ਟੀਮ ਹਰ ਫ਼ੀਡਬੈਕ ਪੜ੍ਹਦੀ ਹੈ। **ਧੰਨਵਾਦ!**",
			"positiveBody": "ਸਾਨੂੰ ਖੁਸ਼ੀ ਹੈ ਕਿ ਇਹ ਮਦਦਗਾਰ ਰਿਹਾ! ਸਾਨੂੰ ਦੱਸੋ ਕਿ **ਤੁਹਾਨੂੰ ਕੀ ਪਸੰਦ ਆਇਆ।**",
			"negativeBody": "ਸਾਨੂੰ ਸਮਝਣ ਵਿੱਚ ਮਦਦ ਕਰੋ ਕਿ ਕੀ ਗਲਤ ਹੋਇਆ ਤਾਂ ਜੋ ਅਸੀਂ **ਆਪਣੀਆਂ ਪ੍ਰਤੀਕਿਰਿਆਵਾਂ ਨੂੰ ਬਿਹਤਰ ਬਣਾ ਸਕੀਏ।**",
			"placeholder": "ਫ਼ੀਡਬੈਕ ਦਰਜ ਕਰੋ",
			"cta": "ਫ਼ੀਡਬੈਕ ਭੇਜੋ"
		},
		"report": {
			"title": "ਰਿਪੋਰਟ ਜਮ੍ਹਾਂ ਕਰੋ",
			"body": "ਸਾਨੂੰ ਸਮਝਣ ਵਿੱਚ ਮਦਦ ਕਰੋ ਕਿ ਇਸ ਪ੍ਰਤੀਕਿਰਿਆ ਵਿੱਚ ਕੀ ਗਲਤ ਹੈ",
			"cta": "ਰਿਪੋਰਟ ਜਮ੍ਹਾਂ ਕਰੋ"
		},
		"suggestCorrection": {
			"title": "ਸੁਧਾਰ ਸੁਝਾਓ",
			"body": "ਇਸ ਸਮੱਗਰੀ ਦੀ ਸ਼ੁੱਧਤਾ ਸੁਧਾਰਨ ਵਿੱਚ ਸਾਡੀ ਮਦਦ ਕਰੋ **ਕਿਸੇ ਵੀ ਗਲਤੀ ਦੀ ਰਿਪੋਰਟ ਕਰਕੇ।**",
			"cta": "ਜਮ੍ਹਾਂ ਕਰੋ"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "ਗਲਤ",
					"description": "ਪ੍ਰਤੀਕਿਰਿਆ ਵਿੱਚ ਗਲਤ ਜਾਣਕਾਰੀ ਹੈ"
				},
				"notHelpful": {
					"title": "ਮਦਦਗਾਰ ਨਹੀਂ",
					"description": "ਪ੍ਰਤੀਕਿਰਿਆ ਨੇ ਮੇਰੇ ਸਵਾਲ ਦਾ ਜਵਾਬ ਨਹੀਂ ਦਿੱਤਾ"
				},
				"incomplete": {
					"title": "ਅਧੂਰਾ",
					"description": "ਪ੍ਰਤੀਕਿਰਿਆ ਵਿੱਚ ਮਹੱਤਵਪੂਰਨ ਵੇਰਵੇ ਗਾਇਬ ਹਨ"
				},
				"hardToUnderstand": {
					"title": "ਸਮਝਣਾ ਔਖਾ",
					"description": "ਪ੍ਰਤੀਕਿਰਿਆ ਉਲਝਣ ਵਾਲੀ ਜਾਂ ਅਸਪਸ਼ਟ ਸੀ"
				},
				"other": {
					"title": "ਹੋਰ",
					"description": "ਕੁਝ ਹੋਰ"
				}
			},
			"report": {
				"misinformation": {
					"title": "ਗਲਤ ਜਾਣਕਾਰੀ",
					"description": "ਪ੍ਰਤੀਕਿਰਿਆ ਵਿੱਚ ਝੂਠੀ ਜਾਂ ਗੁੰਮਰਾਹਕੁੰਨ ਜਾਣਕਾਰੀ ਹੈ"
				},
				"harmfulContent": {
					"title": "ਨੁਕਸਾਨਦੇਹ ਜਾਂ ਅਪਮਾਨਜਨਕ ਸਮੱਗਰੀ",
					"description": "ਨਫ਼ਰਤੀ ਭਾਸ਼ਣ, ਪਰੇਸ਼ਾਨੀ, ਜਾਂ ਅਣਉਚਿਤ ਭਾਸ਼ਾ"
				},
				"violatesPolicies": {
					"title": "ਨੀਤੀਆਂ ਦੀ ਉਲੰਘਣਾ",
					"description": "ਸਪੈਮ, ਸਵੈ-ਪ੍ਰਚਾਰ, ਜਾਂ ਗੈਰ-ਕਾਨੂੰਨੀ ਸਮੱਗਰੀ"
				},
				"other": {
					"title": "ਹੋਰ",
					"description": "ਆਪਣੇ ਸ਼ਬਦਾਂ ਵਿੱਚ ਦੱਸੋ ਕਿ ਕੀ ਗਲਤ ਹੋਇਆ"
				}
			}
		},
		"faqs": {
			"title": "ਅਕਸਰ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲ",
			"body": "ਇੱਥੇ ਐਪ ਬਾਰੇ ਕੁਝ ਸਭ ਤੋਂ ਵੱਧ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲ ਹਨ। ਜੇ ਤੁਹਾਡੇ ਕੋਈ ਹੋਰ ਸਵਾਲ ਹਨ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ support@memorang.ai 'ਤੇ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।"
		},
		"delete": {
			"title": "ਖਾਤਾ ਮਿਟਾਓ",
			"body": "ਤੁਹਾਨੂੰ ਜਾਂਦੇ ਵੇਖ ਕੇ ਸਾਨੂੰ ਅਫ਼ਸੋਸ ਹੈ ਅਤੇ ਅਸੀਂ ਤੁਹਾਡੇ ਅਕਾਦਮਿਕ ਅਤੇ ਪੇਸ਼ੇਵਰ ਸਫ਼ਰ ਲਈ ਤੁਹਾਨੂੰ ਸ਼ੁਭਕਾਮਨਾਵਾਂ ਦਿੰਦੇ ਹਾਂ!",
			"options": "ਬਹੁਤ ਮਹਿੰਗਾ|ਪਹਿਲਾਂ ਹੀ ਆਪਣਾ ਟੈਸਟ ਦੇ ਦਿੱਤਾ|ਸਮੱਗਰੀ ਪਸੰਦ ਨਹੀਂ ਆਈ|ਫੀਚਰ/ਫੰਕਸ਼ਨੈਲਿਟੀ ਗਾਇਬ|ਹੋਰ",
			"confirmdelete": {
				"title": "ਖਾਤਾ ਮਿਟਾਉਣ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
				"cta": "ਮਿਟਾਓ",
				"errorMessage": "ਮੁਆਫ਼ ਕਰਨਾ, ਉਹ ਈਮੇਲ ਇਸ ਖਾਤੇ ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
				"successMessage": "ਖਾਤਾ ਸਫਲਤਾਪੂਰਵਕ ਮਿਟਾਇਆ ਗਿਆ!",
				"validEmail": "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਈਮੇਲ ਪਤਾ ਦਰਜ ਕਰੋ"
			}
		}
	},
	"recorder": {
		"tapToRecord": "ਆਪਣੀ ਪ੍ਰਤੀਕਿਰਿਆ ਰਿਕਾਰਡ ਕਰਨ ਲਈ ਟੈਪ ਕਰੋ",
		"responseAudioUnavailable": "ਪ੍ਰਤੀਕਿਰਿਆ ਆਡੀਓ ਪਲੇਬੈਕ ਲਈ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
		"recording": "ਰਿਕਾਰਡਿੰਗ",
		"recordingCompleted": "ਰਿਕਾਰਡਿੰਗ ਪੂਰੀ ਹੋਈ",
		"getReady": "ਤਿਆਰ ਹੋ ਜਾਓ",
		"timeIsUp": "ਸਮਾਂ ਖ਼ਤਮ ਹੋ ਗਿਆ। ਤੁਹਾਡੀ ਪ੍ਰਤੀਕਿਰਿਆ ਰਿਕਾਰਡ ਨਹੀਂ ਕੀਤੀ ਗਈ।",
		"alert": {
			"title": "ਵੱਧ ਤੋਂ ਵੱਧ ਸਮਾਂ ਸੀਮਾ ਪੂਰੀ ਹੋ ਗਈ",
			"body": "ਰਿਕਾਰਡਿੰਗ ਬੰਦ ਕਰ ਦਿੱਤੀ ਗਈ ਹੈ ਕਿਉਂਕਿ ਇਹ {{maxDuration}} ਸਕਿੰਟ ਦੀ ਵੱਧ ਤੋਂ ਵੱਧ ਮਿਆਦ ਤੱਕ ਪਹੁੰਚ ਗਈ ਹੈ।"
		},
		"uiElementPressed": "ਰਿਕਾਰਡਿੰਗ ਬੰਦ ਕੀਤੀ ਗਈ - ਸਰਗਰਮ ਰਿਕਾਰਡਿੰਗ ਦੌਰਾਨ ਸਟੀਮੂਲਸ ਖੋਲ੍ਹਿਆ ਗਿਆ।"
	},
	"writing": {
		"placeholder": "ਆਪਣੀ ਪ੍ਰਤੀਕਿਰਿਆ ਇੱਥੇ ਲਿਖੋ...",
		"wordCount": "{{count}} {{word}}",
		"title": "ਤੁਹਾਡੀ ਪ੍ਰਤੀਕਿਰਿਆ",
		"submit": "ਜਮ੍ਹਾਂ ਕਰੋ",
		"helper": {
			"range": "ਆਪਣੀ ਪ੍ਰਤੀਕਿਰਿਆ ਜਮ੍ਹਾਂ ਕਰਨ ਲਈ {{min}}–{{max}} ਸ਼ਬਦ ਲਿਖੋ",
			"min": "ਆਪਣੀ ਪ੍ਰਤੀਕਿਰਿਆ ਜਮ੍ਹਾਂ ਕਰਨ ਲਈ ਘੱਟੋ-ਘੱਟ {{min}} ਸ਼ਬਦ ਲਿਖੋ",
			"max": "ਆਪਣੀ ਪ੍ਰਤੀਕਿਰਿਆ ਨੂੰ {{max}} ਜਾਂ ਘੱਟ ਸ਼ਬਦਾਂ ਤੱਕ ਛੋਟਾ ਕਰੋ"
		}
	},
	"navbar": {
		"home": "ਹੋਮ",
		"progress": "ਪ੍ਰਗਤੀ",
		"insights": "ਇਨਸਾਈਟ",
		"leaderboard": "ਲੀਡਰ",
		"store": "ਸਟੋਰ",
		"more": "ਹੋਰ",
		"redeem": "ਰਿਡੀਮ",
		"study-pack": "ਸਟੱਡੀ ਪੈਕ",
		"podcasts": "ਪੌਡਕਾਸਟ",
		"modules": "ਮੋਡਿਊਲ",
		"account": "ਖਾਤਾ ਸੈਟਿੰਗਾਂ",
		"accountTab": "ਖਾਤਾ",
		"privacy": "ਪਰਦੇਦਾਰੀ",
		"terms": "ਸ਼ਰਤਾਂ",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "ਕੋਡ ਸਹੀ ਢੰਗ ਨਾਲ ਦਰਜ ਕੀਤਾ ਅਤੇ ਫਿਰ ਵੀ ਸਮੱਸਿਆ ਹੈ? **ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ** ਅਤੇ ਆਪਣਾ ਐਕਸੈਸ ਕੋਡ ਅਤੇ ਖਰੀਦ ਵੇਰਵੇ ਸ਼ਾਮਲ ਕਰਨਾ ਯਕੀਨੀ ਬਣਾਓ",
		"olxDialog": {
			"unlockedTitle": "ਐਕਸੈਸ ਅਨਲੌਕ ਹੋਇਆ",
			"expiredTitle": "ਐਕਸੈਸ ਦੀ ਮਿਆਦ ਖਤਮ ਹੋਈ",
			"testInfo": "**ਪ੍ਰੀਖਿਆ:** {{examName}} | **ਟੈਸਟ:** {{bundleName}}",
			"upcomingBody_one": "OLX ਟੈਸਟ ਤੱਕ ਤੁਹਾਡੀ ਪਹੁੰਚ ਅਨਲੌਕ ਹੋ ਗਈ ਹੈ!\n\nਤੁਸੀਂ ਆਪਣਾ ਸੈਸ਼ਨ **{{count}} ਦਿਨ** ਵਿੱਚ ਸ਼ੁਰੂ ਕਰ ਸਕਦੇ ਹੋ। ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ ਟੈਬ ਤੋਂ ਆਪਣਾ ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਦੇਖੋ।",
			"upcomingBody_other": "OLX ਟੈਸਟ ਤੱਕ ਤੁਹਾਡੀ ਪਹੁੰਚ ਅਨਲੌਕ ਹੋ ਗਈ ਹੈ!\n\nਤੁਸੀਂ ਆਪਣਾ ਸੈਸ਼ਨ **{{count}} ਦਿਨਾਂ** ਵਿੱਚ ਸ਼ੁਰੂ ਕਰ ਸਕਦੇ ਹੋ। ਪ੍ਰੈਕਟਿਸ ਟੈਸਟ ਟੈਬ ਤੋਂ ਆਪਣਾ ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਦੇਖੋ।",
			"activeBody": "OLX ਟੈਸਟ ਤੱਕ ਤੁਹਾਡੀ ਪਹੁੰਚ ਹੁਣ ਸਰਗਰਮ ਹੈ!\n\nਤੁਸੀਂ **{{date}}** ਤੋਂ ਪਹਿਲਾਂ ਕਿਸੇ ਵੀ ਸਮੇਂ ਆਪਣਾ ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰ ਸਕਦੇ ਹੋ।\n\nਕੀ ਤੁਸੀਂ ਹੁਣੇ ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰਨਾ ਚਾਹੋਗੇ ਜਾਂ ਬਾਅਦ ਵਿੱਚ?",
			"expiredBody": "OLX ਟੈਸਟ ਤੱਕ ਤੁਹਾਡੀ ਪਹੁੰਚ **{{date}}** ਨੂੰ ਖਤਮ ਹੋ ਗਈ ਹੈ।\n\nਹੋਰ ਮਦਦ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਪ੍ਰੋਫੈਸਰ ਜਾਂ ਸਕੂਲ ਪ੍ਰਸ਼ਾਸਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
			"startNowCta": "ਹੁਣੇ ਸ਼ੁਰੂ ਕਰੋ",
			"startLaterCta": "ਬਾਅਦ ਵਿੱਚ ਸ਼ੁਰੂ ਕਰੋ"
		},
		"unexpectedError": "इक अणकिआसी गलती आई।"
	},
	"redeemCode": {
		"titleRedeem": "ਪਹੁੰਚ ਰਿਡੀਮ ਕਰੋ",
		"titleGranted": "ਪਹੁੰਚ ਦਿੱਤੀ ਗਈ",
		"formTitle": "ਆਪਣਾ ਪਹੁੰਚ ਕੋਡ ਦਰਜ ਕਰੋ",
		"accessCodeHint": "ਜੇ ਤੁਹਾਡੇ ਕੋਲ ਪਹੁੰਚ ਕੋਡ ਹੈ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਇਸਨੂੰ ਡੈਸ਼ਾਂ ਸਮੇਤ ਇੱਥੇ ਦਰਜ ਕਰੋ।",
		"submit": "ਰਿਡੀਮ ਕਰੋ",
		"access": "ਇੱਥੇ ਪਹੁੰਚ ਕਰੋ",
		"helpFindCode": "ਆਪਣਾ ਕੋਡ ਲੱਭਣ ਵਿੱਚ ਮਦਦ ਚਾਹੀਦੀ ਹੈ?",
		"troubleRedeeming": "ਰਿਡੀਮ ਕਰਨ ਵਿੱਚ ਸਮੱਸਿਆ ਆ ਰਹੀ ਹੈ? ਅਸਿਸਟੈਂਟ ਨੂੰ ਪੁੱਛੋ!",
		"skipStep": "ਇਹ ਪੜਾਅ ਛੱਡੋ"
	},
	"autoRedeem": {
		"redeem": "ਰਿਡੀਮ ਕਰੋ",
		"redeeming": "ਰਿਡੀਮ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
		"continue": "ਜਾਰੀ ਰੱਖੋ",
		"unredeemedPrompt_one": "**{{email}}** ਈਮੇਲ ਪਤੇ ਨਾਲ ਜੁੜਿਆ **{{count}} ਉਤਪਾਦ** ਹੈ ਜੋ ਰਿਡੀਮ ਨਹੀਂ ਕੀਤਾ ਗਿਆ। ਕੀ ਤੁਸੀਂ ਇਸਨੂੰ ਆਪਣੇ ਖਾਤੇ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
		"unredeemedPrompt_other": "**{{email}}** ਈਮੇਲ ਪਤੇ ਨਾਲ ਜੁੜੇ **{{count}} ਉਤਪਾਦ** ਹਨ ਜੋ ਰਿਡੀਮ ਨਹੀਂ ਕੀਤੇ ਗਏ। ਕੀ ਤੁਸੀਂ ਉਹਨਾਂ ਨੂੰ ਆਪਣੇ ਖਾਤੇ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
		"successMessage_one": "ਵਧਾਈਆਂ! ਹੇਠਾਂ ਦਿੱਤਾ **ਉਤਪਾਦ** ਤੁਹਾਡੇ ਖਾਤੇ 'ਤੇ ਅਨਲੌਕ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ। ਜਾਰੀ ਰੱਖੋ ਦਬਾਉਣ ਤੋਂ ਬਾਅਦ, ਤੁਹਾਡੀ ਐਪ ਦਾ ਸੰਦਰਭ ਇਸ ਇਮਤਿਹਾਨ ਨੂੰ ਦਰਸਾਉਣ ਲਈ ਬਦਲ ਦਿੱਤਾ ਜਾਵੇਗਾ: **{{examName}}**। ਜੇ ਤੁਸੀਂ ਕਿਸੇ ਵੱਖਰੇ ਇਮਤਿਹਾਨ ਲਈ ਅਧਿਐਨ ਕਰਨਾ ਜਾਂ ਕੋਈ ਵੱਖਰਾ ਉਤਪਾਦ ਖਰੀਦਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਤਾਂ ਤੁਸੀਂ ਇਸਨੂੰ ਆਪਣੀ ਖਾਤਾ ਸੈਟਿੰਗਾਂ ਤੋਂ ਕਿਸੇ ਵੀ ਸਮੇਂ ਬਦਲ ਸਕਦੇ ਹੋ।",
		"successMessage_other": "ਵਧਾਈਆਂ! ਹੇਠਾਂ ਦਿੱਤੇ **{{count}} ਉਤਪਾਦ** ਤੁਹਾਡੇ ਖਾਤੇ 'ਤੇ ਅਨਲੌਕ ਕਰ ਦਿੱਤੇ ਗਏ ਹਨ। ਜਾਰੀ ਰੱਖੋ ਦਬਾਉਣ ਤੋਂ ਬਾਅਦ, ਤੁਹਾਡੀ ਐਪ ਦਾ ਸੰਦਰਭ ਇਸ ਇਮਤਿਹਾਨ ਨੂੰ ਦਰਸਾਉਣ ਲਈ ਬਦਲ ਦਿੱਤਾ ਜਾਵੇਗਾ: **{{examName}}**। ਜੇ ਤੁਸੀਂ ਕਿਸੇ ਵੱਖਰੇ ਇਮਤਿਹਾਨ ਲਈ ਅਧਿਐਨ ਕਰਨਾ ਜਾਂ ਕੋਈ ਵੱਖਰਾ ਉਤਪਾਦ ਖਰੀਦਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਤਾਂ ਤੁਸੀਂ ਇਸਨੂੰ ਆਪਣੀ ਖਾਤਾ ਸੈਟਿੰਗਾਂ ਤੋਂ ਕਿਸੇ ਵੀ ਸਮੇਂ ਬਦਲ ਸਕਦੇ ਹੋ।"
	},
	"olxEligibility": {
		"goToPracticeTests": "ਪ੍ਰੈਕਟਿਸ ਟੈਸਟਾਂ 'ਤੇ ਜਾਓ"
	},
	"moreChallenges": {
		"challenges": "ਚੁਣੌਤੀਆਂ",
		"challengesCount": "{{value}} ਚੁਣੌਤੀਆਂ"
	},
	"tts": {
		"tooltip": "ਸੁਣੋ"
	},
	"commandBar": {
		"placeholder": "ਖੋਜੋ...",
		"input": {
			"placeholder": "ਕੋਈ ਕਮਾਂਡ ਟਾਈਪ ਕਰੋ ਜਾਂ ਖੋਜੋ"
		},
		"sections": {
			"quickActions": "ਤੁਰੰਤ ਕਾਰਵਾਈਆਂ"
		},
		"actions": {
			"changeExam": "ਇਮਤਿਹਾਨ ਬਦਲੋ",
			"switchToDarkMode": "ਡਾਰਕ ਮੋਡ 'ਤੇ ਬਦਲੋ",
			"switchToLightMode": "ਲਾਈਟ ਮੋਡ 'ਤੇ ਬਦਲੋ",
			"setExamDate": "ਇਮਤਿਹਾਨ ਦੀ ਤਾਰੀਖ ਸੈੱਟ ਕਰੋ"
		}
	},
	"filterView": {
		"placeholder": "ਇਮਤਿਹਾਨ ਖੋਜੋ..."
	},
	"transcript": {
		"show": "ਟ੍ਰਾਂਸਕ੍ਰਿਪਟ ਵੇਖੋ",
		"hide": "ਟ੍ਰਾਂਸਕ੍ਰਿਪਟ ਲੁਕਾਓ"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "ਐਪ ਲੋਗੋ",
			"testNameLabel": "ਟੈਸਟ ਦਾ ਨਾਮ",
			"sectionLabel": "ਸੈਕਸ਼ਨ",
			"back": "ਵਾਪਸ ਜਾਓ",
			"pause": "ਵਿਰਾਮ",
			"menuLabel": "ਹੋਰ ਵਿਕਲਪ"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "ਟੈਸਟ ਪ੍ਰਗਤੀ",
			"of": "ਵਿੱਚੋਂ",
			"pauseSession": "ਸੈਸ਼ਨ ਵਿਰਾਮ",
			"timerTooltip": {
				"item": "ਇਸ ਸਵਾਲ ਲਈ ਬਾਕੀ ਸਮਾਂ",
				"section": "ਇਸ ਸੈਕਸ਼ਨ ਵਿੱਚ ਬਾਕੀ ਸਮਾਂ",
				"test": "ਇਸ ਟੈਸਟ ਵਿੱਚ ਬਾਕੀ ਸਮਾਂ"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "ਅਗਲਾ"
		},
		"progressBar": {
			"timeLeftLabel": "ਇਸ ਸਵਾਲ ਲਈ ਬਾਕੀ ਸਮਾਂ",
			"timeLeftForUnit": "ਇਸ ਯੂਨਿਟ ਲਈ ਬਾਕੀ ਸਮਾਂ",
			"questionOf": "ਸਵਾਲ {{current}}, {{total}} ਵਿੱਚੋਂ",
			"questionProgress": "<b>{{current}}</b> {{total}} ਵਿੱਚੋਂ",
			"timesUp": "ਸਮਾਂ ਖ਼ਤਮ",
			"statusTooltips": {
				"answered": "ਜਵਾਬ ਦਿੱਤਾ",
				"inProgress": "ਜਾਰੀ ਹੈ",
				"skipped": "ਛੱਡਿਆ ਗਿਆ",
				"notSeen": "ਨਹੀਂ ਵੇਖਿਆ"
			}
		},
		"timeRemainingDialog": {
			"title": "ਤੁਹਾਡੇ ਕੋਲ ਹਾਲੇ ਸਮਾਂ ਹੈ",
			"body": "ਇਸ ਯੂਨਿਟ 'ਤੇ ਹਾਲੇ ਸਮਾਂ ਬਾਕੀ ਹੈ। ਕੀ ਤੁਸੀਂ ਜਮ੍ਹਾਂ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਆਪਣੇ ਜਵਾਬਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
			"reviewCta": "ਮੇਰੇ ਜਵਾਬਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "ਸਰੋਤ",
				"answerTitle": "ਤੁਹਾਡਾ ਜਵਾਬ",
				"remainingBadge": "{{count}} ਬਾਕੀ",
				"placedBadge": "{{count}} ਰੱਖੇ ਗਏ",
				"pointsBadge": "{{earned}}/{{max}} ਅੰਕ",
				"emptyHint": "ਖੱਬੇ ਪੈਨਲ ਤੋਂ ਪੈਰੇ ਇੱਥੇ ਖਿੱਚੋ"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "ਸਹਾਇਤਾ ਜਾਣਕਾਰੀ",
			"emailLabel": "ਈਮੇਲ",
			"subjectLabel": "ਵਿਸ਼ਾ",
			"messageBodyLabel": "ਸੁਨੇਹਾ",
			"appDetailsLabel": "ਐਪ ਵੇਰਵੇ",
			"appNameLabel": "ਨਾਮ",
			"versionLabel": "ਵਰਜ਼ਨ",
			"platformLabel": "ਪਲੇਟਫਾਰਮ"
		},
		"chat": {
			"assistantTitle": "{{tenantName}} ਸਹਾਇਤਾ ਸਹਾਇਕ",
			"fallbackTitle": "ਚੈਟ",
			"betaWarning": "ਇਹ AI ਸਹਾਇਕ **ਬੀਟਾ** ਵਿੱਚ ਹੈ—ਜਵਾਬ ਕਦੇ-ਕਦਾਈਂ ਗਲਤ ਜਾਂ ਅਧੂਰੇ ਹੋ ਸਕਦੇ ਹਨ।",
			"greeting": "ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ 👋 ਕੀ ਤੁਹਾਨੂੰ ਕਿਸੇ ਉਤਪਾਦ ਤੱਕ ਪਹੁੰਚ ਪ੍ਰਾਪਤ ਕਰਨ ਵਿੱਚ ਮੁਸ਼ਕਲ ਆ ਰਹੀ ਹੈ? ਮੈਂ ਮਦਦ ਲਈ ਇੱਥੇ ਹਾਂ! ਪਹਿਲਾਂ, ਆਓ ਸਮੱਸਿਆ ਨੂੰ ਸਮਝੀਏ। ਹੇਠਾਂ ਦਿੱਤੇ ਵਿੱਚੋਂ ਕਿਹੜਾ ਤੁਹਾਡੀ ਸਥਿਤੀ ਦਾ ਸਭ ਤੋਂ ਵਧੀਆ ਵਰਣਨ ਕਰਦਾ ਹੈ?\n\n1. ਮੇਰੇ ਕੋਲ ਇੱਕ ਐਕਸੈਸ ਕੋਡ ਹੈ, ਪਰ ਇਹ ਕੰਮ ਨਹੀਂ ਕਰ ਰਿਹਾ ਜਾਪਦਾ।\n2. ਮੈਂ ਖਰੀਦਦਾਰੀ ਕੀਤੀ, ਪਰ ਮੈਨੂੰ ਆਪਣਾ ਐਕਸੈਸ ਕੋਡ ਨਹੀਂ ਲੱਭ ਰਿਹਾ।\n3. ਮੈਨੂੰ ਆਪਣੇ ਸਕੂਲ ਰਾਹੀਂ ਪਹੁੰਚ ਮਿਲਣੀ ਚਾਹੀਦੀ ਸੀ, ਪਰ ਮੈਨੂੰ ਆਪਣਾ ਐਕਸੈਸ ਕੋਡ ਨਹੀਂ ਲੱਭ ਰਿਹਾ।\n4. ਪਹਿਲਾਂ ਮੇਰੇ ਕੋਲ ਕਿਸੇ ਉਤਪਾਦ ਦੀ ਪਹੁੰਚ ਸੀ, ਪਰ ਹੁਣ ਇਹ ਮੇਰੇ ਲਈ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।\n\nਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਸਮੱਸਿਆ ਨਾਲ ਸੰਬੰਧਿਤ ਨੰਬਰ ਦਰਜ ਕਰੋ।",
			"input": {
				"label": "ਇੱਕ ਸੁਨੇਹਾ ਲਿਖੋ...",
				"sendLabel": "ਭੇਜੋ"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 ਸਫਲਤਾਪੂਰਵਕ ਰਿਡੀਮ ਕੀਤਾ ਗਿਆ",
			"previouslyRedeemedTitle": "🚀 ਪਹਿਲਾਂ ਰਿਡੀਮ ਕੀਤਾ ਗਿਆ",
			"subtitle": "ਆਪਣੀ ਸਮੱਗਰੀ ਇੱਥੇ ਐਕਸੈਸ ਕਰੋ",
			"expires": "ਮਿਆਦ ਖਤਮ: {{date}}",
			"openCta": "ਖੋਲ੍ਹੋ"
		},
		"purchases": {
			"title": "🎉 ਐਕਸੈਸ ਕੋਡ ਮਿਲੇ",
			"subtitle": "ਆਪਣੀ ਸਮੱਗਰੀ ਤੱਕ ਪਹੁੰਚ ਲਈ ਰਿਡੀਮ ਕਰੋ",
			"accessCodesLabel_one": "ਐਕਸੈਸ ਕੋਡ",
			"accessCodesLabel_other": "ਐਕਸੈਸ ਕੋਡ",
			"moreCodes_one": "(+ {{count}} ਹੋਰ)",
			"moreCodes_other": "(+ {{count}} ਹੋਰ)",
			"featuresLabel": "ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ",
			"redeemCta": "ਰਿਡੀਮ ਕਰੋ"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "ਨਵਾਂ ਵਰਜ਼ਨ ਉਪਲਬਧ ਹੈ, ਅੱਪਡੇਟ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਰਿਫ੍ਰੈਸ਼ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
			"refreshCta": "ਰਿਫ੍ਰੈਸ਼",
			"refreshA11yLabel": "ਐਪ ਅੱਪਡੇਟ ਕਰਨ ਲਈ ਰਿਫ੍ਰੈਸ਼ ਕਰੋ",
			"dismissTooltip": "ਖਾਰਜ ਕਰੋ",
			"dismissA11yLabel": "ਅੱਪਡੇਟ ਸੂਚਨਾ ਖਾਰਜ ਕਰੋ"
		}
	},
	"cme": {
		"type": "CME ਦੀ ਕਿਸਮ",
		"chooseExportMethod": "ਐਕਸਪੋਰਟ ਵਿਧੀ ਚੁਣੋ",
		"selectDateRange": "ਤਾਰੀਖ ਸੀਮਾ ਚੁਣੋ",
		"from": "ਤੋਂ",
		"to": "ਤੱਕ",
		"sendPdfTo": "{{email}} ਨੂੰ PDF ਭੇਜੋ",
		"downloadCertificate": "ਸਰਟੀਫਿਕੇਟ PDF ਵਿੱਚ ਡਾਊਨਲੋਡ ਕਰੋ",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "CME ਕ੍ਰੈਡਿਟ ਪ੍ਰਾਪਤ ਕੀਤਾ",
		"confirmYourName": "ਆਪਣੇ ਨਾਮ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
		"certificateNameNotice": "ਇਹ ਨਾਮ ਤੁਹਾਡੇ CME ਸਰਟੀਫਿਕੇਟ 'ਤੇ ਛਾਪਿਆ ਜਾਵੇਗਾ।",
		"firstName": "ਪਹਿਲਾ ਨਾਮ",
		"lastName": "ਆਖਰੀ ਨਾਮ",
		"firstNamePlaceholder": "ਆਪਣਾ ਪਹਿਲਾ ਨਾਮ ਦਰਜ ਕਰੋ",
		"lastNamePlaceholder": "ਆਪਣਾ ਆਖਰੀ ਨਾਮ ਦਰਜ ਕਰੋ",
		"confirm": "ਪੁਸ਼ਟੀ ਕਰੋ",
		"creditsEarnedTitle": "CME ਪ੍ਰਾਪਤ ਕੀਤਾ",
		"creditRatioCaption": "12 ਚੁਣੌਤੀਆਂ = 1 CME ਕ੍ਰੈਡਿਟ",
		"earned": "ਪ੍ਰਾਪਤ ਕੀਤਾ",
		"available": "ਉਪਲਬਧ",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "CME ਸਰਟੀਫਿਕੇਟ ਐਕਸਪੋਰਟ ਕਰੋ",
		"exportDisabledCaption": "ਆਪਣਾ ਸਰਟੀਫਿਕੇਟ ਐਕਸਪੋਰਟ ਕਰਨ ਲਈ ਤੁਹਾਨੂੰ ਘੱਟੋ-ਘੱਟ 1 CME ਕ੍ਰੈਡਿਟ ਪ੍ਰਾਪਤ ਕਰਨਾ ਪਵੇਗਾ",
		"viewDisclaimer": "CME ਬੇਦਾਅਵਾ ਵੇਖੋ"
	}
}
